"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/modules/container/assets/images/brand/Cisco_wht_sm.svg
var require_Cisco_wht_sm = __commonJS({
  "src/modules/container/assets/images/brand/Cisco_wht_sm.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M12.2747 15.1997H10.6275V21.7514H12.2747V15.1997Z" fill="%23F7F7F7"/>%0A<path d="M25.5894 17.0762C25.1646 16.8452 24.6892 16.7239 24.206 16.7233C23.9771 16.7233 23.7504 16.7685 23.5389 16.8564C23.3274 16.9442 23.1352 17.073 22.9733 17.2353C22.8115 17.3977 22.6831 17.5904 22.5955 17.8025C22.5079 18.0146 22.4628 18.2419 22.4628 18.4715C22.4628 18.7011 22.5079 18.9284 22.5955 19.1405C22.6831 19.3526 22.8115 19.5453 22.9733 19.7077C23.1352 19.87 23.3274 19.9988 23.5389 20.0866C23.7504 20.1745 23.9771 20.2197 24.206 20.2197C24.6885 20.2219 25.164 20.1033 25.5894 19.8749V21.6311C25.1023 21.7818 24.5958 21.8601 24.086 21.8636C23.189 21.8636 22.3286 21.5063 21.6943 20.8701C21.0599 20.234 20.7036 19.3712 20.7036 18.4715C20.7036 17.5719 21.0599 16.709 21.6943 16.0729C22.3286 15.4367 23.189 15.0794 24.086 15.0794C24.596 15.08 25.1029 15.1584 25.5894 15.3119V17.0762Z" fill="%23F7F7F7"/>%0A<path d="M8.36356 17.0762C7.93941 16.8436 7.46358 16.7222 6.98018 16.7233C6.75126 16.7233 6.52458 16.7685 6.31308 16.8564C6.10159 16.9442 5.90941 17.073 5.74754 17.2353C5.58567 17.3977 5.45727 17.5904 5.36966 17.8025C5.28206 18.0146 5.23697 18.2419 5.23697 18.4715C5.23697 18.7011 5.28206 18.9284 5.36966 19.1405C5.45727 19.3526 5.58567 19.5453 5.74754 19.7077C5.90941 19.87 6.10159 19.9988 6.31308 20.0866C6.52458 20.1745 6.75126 20.2197 6.98018 20.2197C7.46288 20.2232 7.93868 20.1046 8.36356 19.8749V21.6311C7.87656 21.7822 7.37001 21.8606 6.86024 21.8636C5.96315 21.8636 5.1028 21.5063 4.46846 20.8701C3.83412 20.234 3.47776 19.3712 3.47776 18.4715C3.47776 17.5719 3.83412 16.709 4.46846 16.0729C5.1028 15.4367 5.96315 15.0794 6.86024 15.0794C7.37026 15.0792 7.87728 15.1577 8.36356 15.3119V17.0762Z" fill="%23F7F7F7"/>%0A<path d="M30.7451 16.7555C30.4044 16.7523 30.0704 16.8507 29.7856 17.0382C29.5008 17.2257 29.2779 17.4939 29.1453 17.8086C29.0128 18.1234 28.9764 18.4705 29.0409 18.806C29.1055 19.1415 29.2679 19.4502 29.5077 19.693C29.7475 19.9357 30.0538 20.1015 30.3877 20.1694C30.7217 20.2372 31.0682 20.204 31.3832 20.074C31.6983 19.944 31.9678 19.723 32.1574 19.4391C32.347 19.1553 32.4483 18.8213 32.4483 18.4796C32.4526 18.2534 32.4116 18.0286 32.3277 17.8185C32.2438 17.6084 32.1188 17.4173 31.96 17.2566C31.8012 17.0958 31.6118 16.9687 31.4031 16.8826C31.1945 16.7965 30.9707 16.7533 30.7451 16.7555V16.7555ZM34.1915 18.4796C34.2042 19.1658 34.0129 19.8402 33.642 20.417C33.2711 20.9937 32.7374 21.4467 32.1089 21.7182C31.4804 21.9896 30.7855 22.0673 30.1128 21.9413C29.4401 21.8153 28.82 21.4912 28.3316 21.0105C27.8432 20.5298 27.5085 19.9141 27.3703 19.242C27.232 18.5698 27.2964 17.8716 27.5553 17.2363C27.8142 16.601 28.2558 16.0574 28.8238 15.6747C29.3919 15.292 30.0607 15.0876 30.7451 15.0875C31.1955 15.0756 31.6437 15.1548 32.0629 15.3202C32.4822 15.4857 32.864 15.7341 33.1856 16.0506C33.5072 16.3671 33.7619 16.7453 33.9347 17.1626C34.1076 17.5799 34.1949 18.0278 34.1915 18.4796" fill="%23F7F7F7"/>%0A<path d="M18.5269 16.6909C18.1069 16.5744 17.6749 16.5071 17.2395 16.4904C16.5758 16.4904 16.2239 16.707 16.2239 17.0277C16.2239 17.3485 16.7037 17.565 16.9756 17.6532L17.4314 17.7976C17.8571 17.8895 18.2403 18.1204 18.521 18.4542C18.8018 18.788 18.9641 19.2057 18.9827 19.642C18.9827 21.286 17.5353 21.8393 16.2799 21.8393C15.6841 21.8334 15.0901 21.7744 14.5047 21.6629V20.1793C15.0117 20.3287 15.5358 20.4122 16.064 20.4279C16.8636 20.4279 17.2635 20.1873 17.2635 19.8104C17.2635 19.4335 16.9356 19.2892 16.5278 19.1609L16.176 19.0486C15.2564 18.7599 14.4967 18.2467 14.4967 17.132C14.4967 15.905 15.4083 15.0871 16.8956 15.0871C17.4349 15.0956 17.9714 15.1656 18.4949 15.2956L18.5269 16.6909Z" fill="%23F7F7F7"/>%0A<path d="M1.59928 8.15876C1.59928 7.94607 1.51503 7.7421 1.36507 7.59171C1.21511 7.44132 1.01172 7.35683 0.79964 7.35683C0.587562 7.35683 0.384171 7.44132 0.234209 7.59171C0.0842476 7.7421 0 7.94607 0 8.15876L0 9.88289C0 10.0956 0.0842476 10.2996 0.234209 10.4499C0.384171 10.6003 0.587562 10.6848 0.79964 10.6848C1.01172 10.6848 1.21511 10.6003 1.36507 10.4499C1.51503 10.2996 1.59928 10.0956 1.59928 9.88289V8.15876Z" fill="%23F7F7F7"/>%0A<path d="M6.12408 5.90532C6.12408 5.69264 6.03983 5.48866 5.88987 5.33827C5.73991 5.18788 5.53652 5.10339 5.32444 5.10339C5.11236 5.10339 4.90897 5.18788 4.75901 5.33827C4.60905 5.48866 4.5248 5.69264 4.5248 5.90532V9.91495C4.5248 10.1276 4.60905 10.3316 4.75901 10.482C4.90897 10.6324 5.11236 10.7169 5.32444 10.7169C5.53652 10.7169 5.73991 10.6324 5.88987 10.482C6.03983 10.3316 6.12408 10.1276 6.12408 9.91495V5.90532Z" fill="%23F7F7F7"/>%0A<path d="M10.6198 2.80193C10.6198 2.58924 10.5356 2.38527 10.3856 2.23488C10.2357 2.08449 10.0323 2 9.8202 2C9.60812 2 9.40473 2.08449 9.25477 2.23488C9.10481 2.38527 9.02056 2.58924 9.02056 2.80193V11.5188C9.02056 11.7315 9.10481 11.9355 9.25477 12.0859C9.40473 12.2363 9.60812 12.3208 9.8202 12.3208C10.0323 12.3208 10.2357 12.2363 10.3856 12.0859C10.5356 11.9355 10.6198 11.7315 10.6198 11.5188V2.80193Z" fill="%23F7F7F7"/>%0A<path d="M15.1125 5.90532C15.1125 5.69264 15.0283 5.48866 14.8783 5.33827C14.7284 5.18788 14.525 5.10339 14.3129 5.10339C14.1008 5.10339 13.8974 5.18788 13.7475 5.33827C13.5975 5.48866 13.5133 5.69264 13.5133 5.90532V9.91495C13.5133 10.1276 13.5975 10.3316 13.7475 10.482C13.8974 10.6324 14.1008 10.7169 14.3129 10.7169C14.525 10.7169 14.7284 10.6324 14.8783 10.482C15.0283 10.3316 15.1125 10.1276 15.1125 9.91495V5.90532Z" fill="%23F7F7F7"/>%0A<path d="M19.6084 8.15876C19.6084 7.94607 19.5241 7.7421 19.3742 7.59171C19.2242 7.44132 19.0208 7.35683 18.8087 7.35683C18.5967 7.35683 18.3933 7.44132 18.2433 7.59171C18.0934 7.7421 18.0091 7.94607 18.0091 8.15876V9.88289C18.0091 10.0956 18.0934 10.2996 18.2433 10.4499C18.3933 10.6003 18.5967 10.6848 18.8087 10.6848C19.0208 10.6848 19.2242 10.6003 19.3742 10.4499C19.5241 10.2996 19.6084 10.0956 19.6084 9.88289V8.15876Z" fill="%23F7F7F7"/>%0A<path d="M24.1012 5.90532C24.1012 5.69264 24.017 5.48866 23.867 5.33827C23.7171 5.18788 23.5137 5.10339 23.3016 5.10339C23.0895 5.10339 22.8861 5.18788 22.7362 5.33827C22.5862 5.48866 22.502 5.69264 22.502 5.90532V9.91495C22.502 10.1276 22.5862 10.3316 22.7362 10.482C22.8861 10.6324 23.0895 10.7169 23.3016 10.7169C23.5137 10.7169 23.7171 10.6324 23.867 10.482C24.017 10.3316 24.1012 10.1276 24.1012 9.91495V5.90532Z" fill="%23F7F7F7"/>%0A<path d="M28.6027 2.80193C28.6027 2.58924 28.5185 2.38527 28.3685 2.23488C28.2186 2.08449 28.0152 2 27.8031 2C27.591 2 27.3876 2.08449 27.2377 2.23488C27.0877 2.38527 27.0035 2.58924 27.0035 2.80193V11.5188C27.0035 11.7315 27.0877 11.9355 27.2377 12.0859C27.3876 12.2363 27.591 12.3208 27.8031 12.3208C28.0152 12.3208 28.2186 12.2363 28.3685 12.0859C28.5185 11.9355 28.6027 11.7315 28.6027 11.5188V2.80193Z" fill="%23F7F7F7"/>%0A<path d="M33.0973 5.90564C33.0973 5.68658 33.0105 5.47649 32.856 5.32158C32.7016 5.16668 32.4921 5.07966 32.2736 5.07966C32.0552 5.07966 31.8457 5.16668 31.6912 5.32158C31.5368 5.47649 31.45 5.68658 31.45 5.90564V9.91527C31.45 10.1343 31.5368 10.3444 31.6912 10.4993C31.8457 10.6542 32.0552 10.7413 32.2736 10.7413C32.4921 10.7413 32.7016 10.6542 32.856 10.4993C33.0105 10.3444 33.0973 10.1343 33.0973 9.91527V5.90564Z" fill="%23F7F7F7"/>%0A<path d="M37.5827 8.15876C37.5827 7.94607 37.4985 7.7421 37.3485 7.59171C37.1985 7.44132 36.9952 7.35683 36.7831 7.35683C36.571 7.35683 36.3676 7.44132 36.2176 7.59171C36.0677 7.7421 35.9834 7.94607 35.9834 8.15876V9.88289C35.9834 10.0956 36.0677 10.2996 36.2176 10.4499C36.3676 10.6003 36.571 10.6848 36.7831 10.6848C36.9952 10.6848 37.1985 10.6003 37.3485 10.4499C37.4985 10.2996 37.5827 10.0956 37.5827 9.88289V8.15876Z" fill="%23F7F7F7"/>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/brand/Cisco_blue_sm.svg
var require_Cisco_blue_sm = __commonJS({
  "src/modules/container/assets/images/brand/Cisco_blue_sm.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="35" height="18" viewBox="0 0 35 18" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_534_7786)">%0A<path d="M30.9184 14.7836C30.9312 15.4055 30.7584 16.0171 30.4221 16.5404C30.0859 17.0637 29.6014 17.475 29.0305 17.7219C28.4595 17.9687 27.828 18.04 27.2164 17.9265C26.6048 17.813 26.0409 17.52 25.5965 17.0847C25.1521 16.6495 24.8475 16.0917 24.7213 15.4826C24.5952 14.8735 24.6533 14.2407 24.8883 13.6647C25.1232 13.0888 25.5244 12.5959 26.0406 12.2488C26.5568 11.9018 27.1647 11.7164 27.7867 11.7162C28.1958 11.7043 28.6031 11.775 28.9842 11.9241C29.3653 12.0732 29.7124 12.2976 30.0048 12.584C30.2972 12.8704 30.5288 13.2127 30.6858 13.5907C30.8427 13.9686 30.9219 14.3743 30.9184 14.7836ZM27.7867 13.2251C27.4778 13.2227 27.1751 13.3121 26.9171 13.4819C26.6591 13.6518 26.4573 13.8945 26.3374 14.1792C26.2176 14.464 26.185 14.7779 26.2438 15.0811C26.3026 15.3844 26.4502 15.6634 26.6679 15.8826C26.8855 16.1019 27.1633 16.2516 27.4662 16.3126C27.769 16.3737 28.0832 16.3435 28.3688 16.2257C28.6544 16.108 28.8986 15.908 29.0703 15.6513C29.2421 15.3945 29.3338 15.0925 29.3336 14.7836C29.3373 14.5789 29.2998 14.3756 29.2235 14.1856C29.1472 13.9956 29.0336 13.8229 28.8894 13.6776C28.7451 13.5323 28.5733 13.4174 28.3839 13.3397C28.1945 13.262 27.9914 13.223 27.7867 13.2251Z" fill="%23005568"/>%0A<path d="M23.0819 13.5193C22.6957 13.3097 22.263 13.2009 21.8236 13.2029C21.6113 13.1955 21.3997 13.2309 21.2013 13.307C21.003 13.3832 20.822 13.4985 20.6692 13.646C20.5164 13.7936 20.3948 13.9704 20.3118 14.166C20.2288 14.3616 20.186 14.5718 20.186 14.7843C20.186 14.9967 20.2288 15.207 20.3118 15.4025C20.3948 15.5981 20.5164 15.7749 20.6692 15.9225C20.822 16.0701 21.003 16.1853 21.2013 16.2615C21.3997 16.3376 21.6113 16.373 21.8236 16.3656C22.2627 16.3669 22.6951 16.2588 23.0819 16.051V17.6418C22.6402 17.7777 22.1812 17.8488 21.7191 17.8528C21.3087 17.8647 20.9 17.7941 20.5174 17.6453C20.1347 17.4964 19.7858 17.2723 19.4913 16.9863C19.1968 16.7002 18.9627 16.3579 18.8028 15.9797C18.6429 15.6015 18.5605 15.1951 18.5605 14.7845C18.5605 14.3739 18.6429 13.9675 18.8028 13.5893C18.9627 13.2111 19.1968 12.8688 19.4913 12.5827C19.7858 12.2966 20.1347 12.0725 20.5174 11.9237C20.9 11.7749 21.3087 11.7043 21.7191 11.7162C22.1815 11.7176 22.641 11.7892 23.0819 11.9285V13.5193Z" fill="%23005568"/>%0A<path d="M16.6953 13.1683C16.3139 13.0632 15.9216 13.0025 15.5263 12.9875C14.9268 12.9875 14.6012 13.1882 14.6012 13.4732C14.6012 13.834 15.0406 13.9598 15.2867 14.0375L15.6994 14.1689C16.091 14.2518 16.4433 14.4642 16.6996 14.7717C16.9558 15.0792 17.1011 15.4641 17.1121 15.8642C17.1121 17.3528 15.803 17.8529 14.6585 17.8529C14.1167 17.8481 13.5765 17.7939 13.0446 17.691V16.3273C13.504 16.4607 13.9786 16.5347 14.4568 16.5475C15.2007 16.5475 15.543 16.3301 15.543 15.9942C15.543 15.694 15.2469 15.5205 14.876 15.404C14.7853 15.3739 14.6493 15.3313 14.5567 15.3008C13.7237 15.0376 13.0293 14.5482 13.0293 13.5671C13.0293 12.4587 13.8592 11.7144 15.2377 11.7144C15.7292 11.721 16.2183 11.7843 16.6953 11.9031V13.1683Z" fill="%23005568"/>%0A<path d="M11.0238 11.8213H9.52832V17.7474H11.0238V11.8213Z" fill="%23005568"/>%0A<path d="M7.47261 13.5195C7.08727 13.3095 6.65502 13.2007 6.21621 13.2031C6.00379 13.1955 5.79201 13.2308 5.59351 13.3068C5.39502 13.3828 5.21388 13.4981 5.06091 13.6457C4.90794 13.7933 4.78627 13.9702 4.70317 14.1658C4.62007 14.3615 4.57725 14.5719 4.57725 14.7844C4.57725 14.997 4.62007 15.2074 4.70317 15.403C4.78627 15.5987 4.90794 15.7756 5.06091 15.9231C5.21388 16.0707 5.39502 16.186 5.59351 16.262C5.79201 16.3381 6.00379 16.3733 6.21621 16.3657C6.65472 16.3675 7.08668 16.2594 7.47261 16.0512V17.642C7.03076 17.7784 6.57134 17.8495 6.10892 17.853C5.69873 17.8645 5.29039 17.7937 4.90804 17.6447C4.52569 17.4956 4.1771 17.2715 3.88289 16.9854C3.58867 16.6994 3.3548 16.3572 3.1951 15.9792C3.03541 15.6012 2.95312 15.195 2.95312 14.7847C2.95312 14.3743 3.03541 13.9681 3.1951 13.5901C3.3548 13.2121 3.58867 12.8699 3.88289 12.5839C4.1771 12.2978 4.52569 12.0737 4.90804 11.9246C5.29039 11.7756 5.69873 11.7048 6.10892 11.7163C6.57163 11.7174 7.03147 11.789 7.47261 11.9286V13.5195Z" fill="%23005568"/>%0A<path d="M33.9945 5.46055C33.9945 5.04757 33.6598 4.71279 33.2468 4.71279C32.8338 4.71279 32.499 5.04757 32.499 5.46055V7.00234C32.499 7.41532 32.8338 7.7501 33.2468 7.7501C33.6598 7.7501 33.9945 7.41532 33.9945 7.00234V5.46055Z" fill="%23005568"/>%0A<path d="M29.9174 3.41824C29.9174 3.00527 29.5826 2.67049 29.1696 2.67049C28.7567 2.67049 28.4219 3.00527 28.4219 3.41824V7.00233C28.4219 7.4153 28.7567 7.75009 29.1696 7.75009C29.5826 7.75009 29.9174 7.4153 29.9174 7.00233V3.41824Z" fill="%23005568"/>%0A<path d="M25.8393 0.625176C25.8393 0.212201 25.5045 -0.122581 25.0915 -0.122581C24.6785 -0.122581 24.3438 0.212201 24.3438 0.625176V8.48076C24.3438 8.89373 24.6785 9.22851 25.0915 9.22851C25.5045 9.22851 25.8393 8.89373 25.8393 8.48076V0.625176Z" fill="%23005568"/>%0A<path d="M21.7611 3.41824C21.7611 3.00527 21.4264 2.67049 21.0134 2.67049C20.6004 2.67049 20.2656 3.00527 20.2656 3.41824V7.00233C20.2656 7.4153 20.6004 7.75009 21.0134 7.75009C21.4264 7.75009 21.7611 7.4153 21.7611 7.00233V3.41824Z" fill="%23005568"/>%0A<path d="M17.684 5.46055C17.684 5.04757 17.3492 4.71279 16.9362 4.71279C16.5233 4.71279 16.1885 5.04757 16.1885 5.46055V7.00234C16.1885 7.41532 16.5233 7.7501 16.9362 7.7501C17.3492 7.7501 17.684 7.41532 17.684 7.00234V5.46055Z" fill="%23005568"/>%0A<path d="M13.6059 3.41824C13.6059 3.00527 13.2711 2.67049 12.8581 2.67049C12.4451 2.67049 12.1104 3.00527 12.1104 3.41824V7.00233C12.1104 7.4153 12.4451 7.75009 12.8581 7.75009C13.2711 7.75009 13.6059 7.4153 13.6059 7.00233V3.41824Z" fill="%23005568"/>%0A<path d="M9.52774 0.625176C9.52774 0.212201 9.19296 -0.122581 8.77999 -0.122581C8.36701 -0.122581 8.03223 0.212201 8.03223 0.625176V8.48076C8.03223 8.89373 8.36701 9.22851 8.77999 9.22851C9.19296 9.22851 9.52774 8.89373 9.52774 8.48076V0.625176Z" fill="%23005568"/>%0A<path d="M5.45059 3.41824C5.45059 3.00527 5.11581 2.67049 4.70284 2.67049C4.28986 2.67049 3.95508 3.00527 3.95508 3.41824V7.00233C3.95508 7.4153 4.28986 7.75009 4.70284 7.75009C5.11581 7.75009 5.45059 7.4153 5.45059 7.00233V3.41824Z" fill="%23005568"/>%0A<path d="M1.37247 5.46055C1.37247 5.04757 1.03769 4.71279 0.624711 4.71279C0.211736 4.71279 -0.123047 5.04757 -0.123047 5.46055V7.00234C-0.123047 7.41532 0.211736 7.7501 0.624711 7.7501C1.03769 7.7501 1.37247 7.41532 1.37247 7.00234V5.46055Z" fill="%23005568"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_534_7786">%0A<rect width="34.1053" height="18" fill="white"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/helpCenterTile/emptyStateError.svg
var require_emptyStateError = __commonJS({
  "src/modules/container/assets/images/helpCenterTile/emptyStateError.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="500" height="190" viewBox="0 10 500 190" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_673_5925)">%0A<rect opacity="0.4" x="338.641" y="53.0543" width="23.0203" height="102.312" rx="11.5102" transform="rotate(25 338.641 53.0543)" fill="%23FFC7C9"/>%0A<rect opacity="0.2" x="194.824" y="102.292" width="23.0203" height="76.7344" rx="11.5102" transform="rotate(25 194.824 102.292)" fill="%23FFC7C9"/>%0A<rect opacity="0.3" x="221.323" y="23" width="23.0203" height="41.0875" rx="11.5102" transform="rotate(25 221.323 23)" fill="%23FFC7C9"/>%0A<path d="M243.019 72.5803C247.333 70.0639 252.668 70.0639 256.981 72.5803L293.004 93.5935C297.26 96.0764 299.878 100.633 299.878 105.561V145.065C299.878 149.992 297.26 154.549 293.004 157.032L256.981 178.045C252.668 180.562 247.333 180.562 243.019 178.045L206.997 157.032C202.74 154.549 200.123 149.992 200.123 145.065V105.561C200.123 100.633 202.74 96.0764 206.997 93.5935L243.019 72.5803Z" fill="%23CC2D37"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M244.458 128.084L244.458 104.531C244.458 101.47 246.939 98.9886 250 98.9886C253.06 98.9886 255.542 101.47 255.542 104.531L255.542 128.084C255.542 131.144 253.06 133.626 250 133.626C246.939 133.626 244.458 131.144 244.458 128.084Z" fill="white"/>%0A<path d="M256.927 147.481C256.927 151.306 253.826 154.408 250 154.408C246.174 154.408 243.072 151.306 243.072 147.481C243.072 143.655 246.174 140.553 250 140.553C253.826 140.553 256.927 143.655 256.927 147.481Z" fill="white"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_673_5925">%0A<rect width="217.414" height="191.836" fill="white" transform="translate(141.293 23)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/brand/ai_logo_small.svg
var require_ai_logo_small = __commonJS({
  "src/modules/container/assets/images/brand/ai_logo_small.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M17.8333 11.6667C21.055 11.6667 23.6667 9.05499 23.6667 5.83333C23.6667 2.61167 21.055 0 17.8333 0C14.6117 0 12 2.61167 12 5.83333C12 9.05499 14.6117 11.6667 17.8333 11.6667Z" fill="url(%23paint0_linear_2000_12536)"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.8333C15.2217 15.8333 17.8333 13.2217 17.8333 10C17.8333 6.77834 15.2217 4.16667 12 4.16667C8.77834 4.16667 6.16667 6.77834 6.16667 10C6.16667 13.2217 8.77834 15.8333 12 15.8333ZM12 20C17.5228 20 22 15.5228 22 10C22 4.47715 17.5228 0 12 0C6.47715 0 2 4.47715 2 10C2 15.5228 6.47715 20 12 20Z" fill="%232C89EB"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6976 10.7529C14.7643 10.5133 14.8 10.2608 14.8 9.99992C14.8 8.50792 13.6331 7.28849 12.1621 7.20453C12.0561 6.76475 12 6.30555 12 5.83325C12 3.50989 13.3583 1.50378 15.3241 0.565674C19.1879 1.92705 21.9642 5.59491 21.9997 9.91608C20.9409 10.9963 19.4654 11.6666 17.8333 11.6666C16.6791 11.6666 15.6032 11.3314 14.6976 10.7529Z" fill="url(%23paint1_linear_2000_12536)"/>%0A<path d="M17.8333 11.6667C21.055 11.6667 23.6667 9.05499 23.6667 5.83333C23.6667 2.61167 21.055 0 17.8333 0C14.6117 0 12 2.61167 12 5.83333C12 9.05499 14.6117 11.6667 17.8333 11.6667Z" fill="url(%23paint2_linear_2000_12536)"/>%0A<defs>%0A<linearGradient id="paint0_linear_2000_12536" x1="13.7784" y1="1.7784" x2="22.1475" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A<linearGradient id="paint1_linear_2000_12536" x1="16.3439" y1="4.67558" x2="19.4592" y2="11.1848" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%2374BF4B" stop-opacity="0"/>%0A<stop offset="1" stop-color="%2374BF4B"/>%0A</linearGradient>%0A<linearGradient id="paint2_linear_2000_12536" x1="13.7784" y1="1.7784" x2="22.1475" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/aiModalTrigger.svg
var require_aiModalTrigger = __commonJS({
  "src/modules/container/assets/images/aiIcons/aiModalTrigger.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M16 11.6667C19.2217 11.6667 21.8334 9.05499 21.8334 5.83333C21.8334 2.61167 19.2217 0 16 0C12.7784 0 10.1667 2.61167 10.1667 5.83333C10.1667 9.05499 12.7784 11.6667 16 11.6667Z" fill="url(%23paint0_linear_2177_7002)"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1667 15.8333C13.3883 15.8333 16 13.2217 16 10C16 6.77834 13.3883 4.16667 10.1667 4.16667C6.94503 4.16667 4.33335 6.77834 4.33335 10C4.33335 13.2217 6.94503 15.8333 10.1667 15.8333ZM10.1667 20C15.6895 20 20.1667 15.5228 20.1667 10C20.1667 4.47715 15.6895 0 10.1667 0C4.64384 0 0.166687 4.47715 0.166687 10C0.166687 15.5228 4.64384 20 10.1667 20Z" fill="%232C89EB"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8643 10.7529C12.931 10.5133 12.9667 10.2608 12.9667 9.99992C12.9667 8.50792 11.7997 7.28849 10.3288 7.20453C10.2228 6.76475 10.1667 6.30555 10.1667 5.83325C10.1667 3.50989 11.525 1.50378 13.4908 0.565674C17.3546 1.92705 20.1309 5.59491 20.1663 9.91608C19.1076 10.9963 17.6321 11.6666 16 11.6666C14.8458 11.6666 13.7699 11.3314 12.8643 10.7529Z" fill="url(%23paint1_linear_2177_7002)"/>%0A<path d="M16 11.6667C19.2217 11.6667 21.8334 9.05499 21.8334 5.83333C21.8334 2.61167 19.2217 0 16 0C12.7784 0 10.1667 2.61167 10.1667 5.83333C10.1667 9.05499 12.7784 11.6667 16 11.6667Z" fill="url(%23paint2_linear_2177_7002)"/>%0A<defs>%0A<linearGradient id="paint0_linear_2177_7002" x1="11.9451" y1="1.7784" x2="20.3142" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A<linearGradient id="paint1_linear_2177_7002" x1="14.5106" y1="4.67558" x2="17.6259" y2="11.1848" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%2374BF4B" stop-opacity="0"/>%0A<stop offset="1" stop-color="%2374BF4B"/>%0A</linearGradient>%0A<linearGradient id="paint2_linear_2177_7002" x1="11.9451" y1="1.7784" x2="20.3142" y2="9.71533" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/ai_logo_large.svg
var require_ai_logo_large = __commonJS({
  "src/modules/container/assets/images/aiIcons/ai_logo_large.svg"(exports, module2) {
    module2.exports = "data:image/svg+xml,<svg%0A  xmlns='http://www.w3.org/2000/svg'%0A  width='174'%0A  height='160'%0A  viewBox='0 0 174 160'%0A  fill='none'%0A>%0A  <path%0A    d='M126.796 93.3095C152.563 93.3095 173.451 72.4214 173.451 46.6547C173.451 20.888 152.563 0 126.796 0C101.03 0 80.1416 20.888 80.1416 46.6547C80.1416 72.4214 101.03 93.3095 126.796 93.3095Z'%0A    fill='url(%23paint0_linear_7913_1973)'%0A  />%0A  <path%0A    fill-rule='evenodd'%0A    clip-rule='evenodd'%0A    d='M80 126.667C105.773 126.667 126.667 105.773 126.667 80C126.667 54.2267 105.773 33.3333 80 33.3333C54.2267 33.3333 33.3333 54.2267 33.3333 80C33.3333 105.773 54.2267 126.667 80 126.667ZM80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z'%0A    fill='%230E2B56'%0A  />%0A  <path%0A    fill-rule='evenodd'%0A    clip-rule='evenodd'%0A    d='M124.72 93.273C125.971 89.0633 126.642 84.605 126.642 79.9901C126.642 54.8821 106.763 34.4094 81.8604 33.4029C85.6433 20.6727 94.7242 10.2168 106.552 4.58191C137.488 15.4635 159.716 44.7808 160 79.32C151.523 87.9545 139.709 93.3118 126.642 93.3118C125.998 93.3118 125.357 93.2988 124.72 93.273Z'%0A    fill='url(%23paint1_linear_7913_1973)'%0A  />%0A  <path%0A    d='M126.796 93.3095C152.563 93.3095 173.451 72.4214 173.451 46.6547C173.451 20.888 152.563 0 126.796 0C101.03 0 80.1416 20.888 80.1416 46.6547C80.1416 72.4214 101.03 93.3095 126.796 93.3095Z'%0A    fill='url(%23paint2_radial_7913_1973)'%0A  />%0A  <defs>%0A    <linearGradient%0A      id='paint0_linear_7913_1973'%0A      x1='94.3652'%0A      y1='14.2236'%0A      x2='161.301'%0A      y2='77.7028'%0A      gradientUnits='userSpaceOnUse'%0A    >%0A      <stop stop-color='%233B76EA' />%0A      <stop offset='0.515625' stop-color='%2300BCEB' />%0A      <stop offset='1' stop-color='%2363FFF7' />%0A    </linearGradient>%0A    <linearGradient%0A      id='paint1_linear_7913_1973'%0A      x1='115.805'%0A      y1='37.4325'%0A      x2='141.057'%0A      y2='89.0163'%0A      gradientUnits='userSpaceOnUse'%0A    >%0A      <stop stop-color='%2374BF4B' stop-opacity='0' />%0A      <stop offset='1' stop-color='%2374BF4B' />%0A    </linearGradient>%0A    <radialGradient%0A      id='paint2_radial_7913_1973'%0A      cx='0'%0A      cy='0'%0A      r='1'%0A      gradientUnits='userSpaceOnUse'%0A      gradientTransform='translate(156.315 72.709) rotate(90) scale(99.1762 99.1343)'%0A    >%0A      <stop offset='0.661663' stop-color='%2300BCEB' stop-opacity='0' />%0A      <stop offset='1' stop-color='%2300BCEB' />%0A    </radialGradient>%0A  </defs>%0A</svg>";
  }
});

// src/modules/container/assets/images/aiIcons/lockVector.svg
var require_lockVector = __commonJS({
  "src/modules/container/assets/images/aiIcons/lockVector.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M28.8 11.5714H24.32V8.35714C24.32 6.14069 23.4434 4.01502 21.8831 2.44775C20.3228 0.880482 18.2066 0 16 0C13.7934 0 11.6772 0.880482 10.1169 2.44775C8.55657 4.01502 7.68 6.14069 7.68 8.35714V11.5714H3.2C2.35131 11.5714 1.53737 11.9101 0.937258 12.5129C0.337142 13.1157 0 13.9332 0 14.7857V32.7857C0 33.6382 0.337142 34.4558 0.937258 35.0586C1.53737 35.6614 2.35131 36 3.2 36H28.8C29.6487 36 30.4626 35.6614 31.0627 35.0586C31.6629 34.4558 32 33.6382 32 32.7857V14.7857C32 13.9332 31.6629 13.1157 31.0627 12.5129C30.4626 11.9101 29.6487 11.5714 28.8 11.5714ZM11.52 8.35714C11.52 7.16367 11.992 6.01908 12.8322 5.17516C13.6723 4.33125 14.8118 3.85714 16 3.85714C17.1882 3.85714 18.3277 4.33125 19.1678 5.17516C20.008 6.01908 20.48 7.16367 20.48 8.35714V11.5714H11.52V8.35714ZM28.16 32.1429H3.84V15.4286H28.16V32.1429ZM18.56 23.7857C18.56 24.2943 18.4099 24.7915 18.1286 25.2143C17.8473 25.6372 17.4474 25.9668 16.9797 26.1614C16.5119 26.356 15.9972 26.407 15.5006 26.3077C15.004 26.2085 14.5478 25.9636 14.1898 25.604C13.8318 25.2444 13.588 24.7862 13.4892 24.2874C13.3904 23.7886 13.4411 23.2715 13.6349 22.8017C13.8286 22.3318 14.1568 21.9302 14.5777 21.6476C14.9987 21.3651 15.4937 21.2143 16 21.2143C16.679 21.2143 17.3301 21.4852 17.8102 21.9674C18.2903 22.4497 18.56 23.1037 18.56 23.7857Z" fill="url(%23paint0_linear_1961_1974)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_1974" x1="28.381" y1="46.5882" x2="63.9071" y2="-15.9281" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/pathVector.svg
var require_pathVector = __commonJS({
  "src/modules/container/assets/images/aiIcons/pathVector.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="38" height="34" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M26.2679 15.02H34.1964C35.0726 15.02 35.9129 14.6723 36.5324 14.0535C37.1519 13.4346 37.5 12.5952 37.5 11.72V3.8C37.5 2.92479 37.1519 2.08542 36.5324 1.46655C35.9129 0.847678 35.0726 0.5 34.1964 0.5H26.2679C25.3917 0.5 24.5514 0.847678 23.9319 1.46655C23.3123 2.08542 22.9643 2.92479 22.9643 3.8V5.78H22.3036C20.7265 5.78 19.214 6.40582 18.0988 7.51979C16.9836 8.63375 16.3571 10.1446 16.3571 11.72V15.02H12.3929V14.36C12.3929 13.4848 12.0448 12.6454 11.4253 12.0265C10.8057 11.4077 9.96545 11.06 9.08929 11.06H3.80357C2.92741 11.06 2.08713 11.4077 1.46759 12.0265C0.848054 12.6454 0.5 13.4848 0.5 14.36V19.64C0.5 20.0734 0.585449 20.5025 0.751469 20.9029C0.917489 21.3032 1.16083 21.667 1.46759 21.9735C1.77436 22.2799 2.13854 22.523 2.53935 22.6888C2.94016 22.8546 3.36974 22.94 3.80357 22.94H9.08929C9.52312 22.94 9.9527 22.8546 10.3535 22.6888C10.7543 22.523 11.1185 22.2799 11.4253 21.9735C11.732 21.667 11.9754 21.3032 12.1414 20.9029C12.3074 20.5025 12.3929 20.0734 12.3929 19.64V18.98H16.3571V22.28C16.3571 23.8554 16.9836 25.3662 18.0988 26.4802C19.214 27.5942 20.7265 28.22 22.3036 28.22H22.9643V30.2C22.9643 31.0752 23.3123 31.9146 23.9319 32.5335C24.5514 33.1523 25.3917 33.5 26.2679 33.5H34.1964C35.0726 33.5 35.9129 33.1523 36.5324 32.5335C37.1519 31.9146 37.5 31.0752 37.5 30.2V22.28C37.5 21.4048 37.1519 20.5654 36.5324 19.9465C35.9129 19.3277 35.0726 18.98 34.1964 18.98H26.2679C25.3917 18.98 24.5514 19.3277 23.9319 19.9465C23.3123 20.5654 22.9643 21.4048 22.9643 22.28V24.26H22.3036C21.7779 24.26 21.2737 24.0514 20.902 23.6801C20.5303 23.3088 20.3214 22.8051 20.3214 22.28V11.72C20.3214 11.1949 20.5303 10.6913 20.902 10.3199C21.2737 9.94861 21.7779 9.74 22.3036 9.74H22.9643V11.72C22.9643 12.5952 23.3123 13.4346 23.9319 14.0535C24.5514 14.6723 25.3917 15.02 26.2679 15.02ZM8.42857 18.98H4.46429V15.02H8.42857V18.98ZM26.9286 22.94H33.5357V29.54H26.9286V22.94ZM26.9286 4.46H33.5357V11.06H26.9286V4.46Z" fill="url(%23paint0_linear_1961_1981)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_1981" x1="33.3155" y1="43.2059" x2="61.7079" y2="-19.8155" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/chatVector.svg
var require_chatVector = __commonJS({
  "src/modules/container/assets/images/aiIcons/chatVector.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M18.0142 4.06955e-07C14.9299 -0.000655073 11.8971 0.790532 9.2065 2.29772C6.51596 3.8049 4.25788 5.97755 2.64876 8.60739C1.03963 11.2372 0.133388 14.2361 0.0169168 17.3165C-0.0995548 20.3969 0.577644 23.4555 1.9836 26.1993L0.174628 31.6031C-0.0237439 32.1913 -0.053769 32.8233 0.0879367 33.4277C0.229642 34.0321 0.537445 34.5849 0.976654 35.0239C1.41586 35.4629 1.96902 35.7705 2.57377 35.9121C3.17853 36.0537 3.81084 36.0237 4.39945 35.8255L9.80634 34.0242C12.2306 35.2611 14.9039 35.9327 17.6252 35.9883C20.3465 36.044 23.045 35.4824 25.5179 34.3456C27.9907 33.2089 30.1736 31.5267 31.9022 29.4254C33.6309 27.3242 34.8605 24.8586 35.4984 22.214C36.1364 19.5695 36.1662 16.8148 35.5855 14.1571C35.0049 11.4993 33.8289 9.00777 32.1461 6.86968C30.4632 4.73159 28.3173 3.00261 25.8696 1.81275C23.4219 0.622888 20.7361 0.00310551 18.0142 4.06955e-07ZM18.0142 31.993C15.5522 31.9939 13.1335 31.3462 11.0018 30.1151C10.6978 29.9388 10.3528 29.8457 10.0014 29.8451C9.78606 29.8455 9.57217 29.8804 9.36786 29.9484L4.40111 31.6031L6.05669 26.6392C6.14634 26.3704 6.17784 26.0857 6.14909 25.8039C6.12035 25.5221 6.03202 25.2496 5.88997 25.0045C4.34607 22.337 3.72614 19.2348 4.12636 16.1793C4.52658 13.1237 5.92457 10.2856 8.10345 8.10511C10.2823 5.92466 13.1203 4.52381 16.1771 4.11988C19.2339 3.71596 22.3386 4.33153 25.0096 5.87111C27.6807 7.4107 29.7686 9.78822 30.9497 12.6348C32.1307 15.4815 32.3387 18.638 31.5415 21.6149C30.7443 24.5918 28.9865 27.2225 26.5406 29.0989C24.0947 30.9754 21.0976 31.9927 18.0142 31.993Z" fill="url(%23paint0_linear_1961_2150)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_2150" x1="31.9286" y1="46.5882" x2="65.2125" y2="-19.3038" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/thumbsDownVector.svg
var require_thumbsDownVector = __commonJS({
  "src/modules/container/assets/images/aiIcons/thumbsDownVector.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="38" height="34" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M37.0906 19.5828L35.2156 4.58281C35.0835 3.52472 34.5695 2.55132 33.7702 1.84553C32.9709 1.13974 31.9413 0.750158 30.875 0.75H4C3.1712 0.75 2.37634 1.07924 1.79029 1.66529C1.20424 2.25134 0.875 3.0462 0.875 3.875V17.625C0.875 18.0354 0.955831 18.4417 1.11288 18.8209C1.26992 19.2 1.50011 19.5445 1.79029 19.8347C2.08047 20.1249 2.42497 20.3551 2.80411 20.5121C3.18326 20.6692 3.58962 20.75 4 20.75H10.3406L16.0734 32.2141C16.2292 32.5253 16.4685 32.7871 16.7646 32.9701C17.0607 33.153 17.4019 33.25 17.75 33.25C19.5727 33.2479 21.3202 32.5229 22.6091 31.2341C23.8979 29.9452 24.6229 28.1977 24.625 26.375V24.5H32.75C33.3703 24.4999 33.9834 24.3679 34.5488 24.1128C35.1141 23.8577 35.6188 23.4853 36.0293 23.0203C36.4397 22.5553 36.7466 22.0084 36.9296 21.4157C37.1126 20.8231 37.1675 20.1983 37.0906 19.5828ZM9.625 17H4.625V4.5H9.625V17ZM33.2188 20.5391C33.16 20.6054 33.0879 20.6586 33.0071 20.695C32.9262 20.7313 32.8386 20.7501 32.75 20.75H22.75C22.2527 20.75 21.7758 20.9475 21.4242 21.2992C21.0725 21.6508 20.875 22.1277 20.875 22.625V26.375C20.875 27.0169 20.6773 27.6431 20.3088 28.1687C19.9404 28.6943 19.419 29.0936 18.8156 29.3125L13.375 18.4328V4.5H30.875C31.0281 4.4988 31.1763 4.55382 31.2915 4.65462C31.4067 4.75542 31.4809 4.895 31.5 5.04688L33.375 20.0469C33.3855 20.1353 33.377 20.225 33.3501 20.3099C33.3231 20.3947 33.2784 20.4729 33.2188 20.5391Z" fill="url(%23paint0_linear_1961_2156)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_2156" x1="33.0247" y1="42.8088" x2="61.0837" y2="-19.1478" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/assets/images/aiIcons/warningVector.svg
var require_warningVector = __commonJS({
  "src/modules/container/assets/images/aiIcons/warningVector.svg"(exports, module2) {
    module2.exports = 'data:image/svg+xml,<svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M35.4192 25.5538L21.8503 2.18965C21.4573 1.52322 20.8952 0.970438 20.2198 0.586284C19.5444 0.202131 18.7794 0 18.0008 0C17.2222 0 16.4571 0.202131 15.7818 0.586284C15.1064 0.970438 14.5442 1.52322 14.1512 2.18965L0.582342 25.5538C0.200986 26.2005 0 26.9361 0 27.6853C0 28.4344 0.200986 29.1701 0.582342 29.8168C0.971004 30.4865 1.53238 31.0417 2.20887 31.4253C2.88536 31.8089 3.65261 32.0072 4.4319 31.9998H31.5697C32.3484 32.0067 33.115 31.8081 33.7909 31.4245C34.4668 31.0409 35.0277 30.4861 35.4161 29.8168C35.7979 29.1703 35.9995 28.4348 36 27.6857C36.0005 26.9366 35.8001 26.2008 35.4192 25.5538ZM32.1918 27.9691C32.1287 28.0757 32.0378 28.1635 31.9285 28.223C31.8193 28.2826 31.6958 28.3118 31.5712 28.3076H4.4319C4.30729 28.3118 4.18384 28.2826 4.07459 28.223C3.96534 28.1635 3.87436 28.0757 3.81125 27.9691C3.75773 27.8828 3.72939 27.7835 3.72939 27.6822C3.72939 27.5809 3.75773 27.4816 3.81125 27.3953L17.3801 4.03115C17.4473 3.92861 17.5393 3.84434 17.6477 3.786C17.7561 3.72766 17.8774 3.6971 18.0008 3.6971C18.1241 3.6971 18.2455 3.72766 18.3539 3.786C18.4623 3.84434 18.5542 3.92861 18.6214 4.03115L32.1887 27.3953C32.2427 27.4813 32.2716 27.5805 32.2722 27.6818C32.2727 27.7831 32.2449 27.8825 32.1918 27.9691ZM16.1388 17.8462V12.9233C16.1388 12.4337 16.335 11.9641 16.6842 11.6179C17.0334 11.2717 17.507 11.0772 18.0008 11.0772C18.4946 11.0772 18.9682 11.2717 19.3174 11.6179C19.6665 11.9641 19.8627 12.4337 19.8627 12.9233V17.8462C19.8627 18.3359 19.6665 18.8054 19.3174 19.1516C18.9682 19.4979 18.4946 19.6924 18.0008 19.6924C17.507 19.6924 17.0334 19.4979 16.6842 19.1516C16.335 18.8054 16.1388 18.3359 16.1388 17.8462ZM20.4834 24C20.4834 24.4868 20.3378 24.9627 20.065 25.3675C19.7922 25.7723 19.4045 26.0878 18.9508 26.2741C18.4972 26.4604 17.998 26.5091 17.5164 26.4142C17.0349 26.3192 16.5925 26.0847 16.2453 25.7405C15.8981 25.3963 15.6617 24.9577 15.5659 24.4802C15.4701 24.0027 15.5193 23.5078 15.7072 23.058C15.8951 22.6082 16.2133 22.2238 16.6215 21.9533C17.0298 21.6828 17.5098 21.5385 18.0008 21.5385C18.6592 21.5385 19.2907 21.7978 19.7562 22.2594C20.2218 22.7211 20.4834 23.3471 20.4834 24Z" fill="url(%23paint0_linear_1961_2162)"/>%0A<defs>%0A<linearGradient id="paint0_linear_1961_2162" x1="31.9286" y1="41.4118" x2="59.399" y2="-19.7692" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%233B76EA"/>%0A<stop offset="0.515625" stop-color="%2300BCEB"/>%0A<stop offset="1" stop-color="%2363FFF7"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
  }
});

// src/modules/container/index.ts
var container_exports = {};
__export(container_exports, {
  ShellBreadcrumbs: () => ShellBreadcrumbs,
  ShellContainer: () => ShellContainer,
  ShellEvent: () => ShellEvent,
  ShellEventTypes: () => ShellEventTypes,
  ShellPageHeader: () => ShellPageHeader,
  generateCSP: () => generateCSP,
  getAppBasedLink: () => getAppBasedLink,
  getAppName: () => getAppName,
  getSelectedApplication: () => getSelectedApplication,
  getTimeRange: () => getTimeRange,
  useApplicationName: () => useApplicationName,
  useApplicationsList: () => useApplicationsList,
  useSelectedApplication: () => useSelectedApplication,
  useSetBreadcrumbs: () => useSetBreadcrumbs,
  useSetPageContext: () => useSetPageContext,
  useShellTimeRange: () => useShellTimeRange,
  useUpdateBreadcrumbs: () => useUpdateBreadcrumbs,
  useUpdatePageTitle: () => useUpdatePageTitle,
  useUpdatePageTitleActions: () => useUpdatePageTitleActions
});
module.exports = __toCommonJS(container_exports);

// src/modules/container/container/ShellContainer.tsx
var import_react_router_dom2 = require("react-router-dom");
var import_react54 = require("react");
var import_uik92 = require("@appd/uik");

// src/modules/featureFlags/FLAG_DEFINITIONS.ts
var FLAG_DEFINITIONS_exports = {};
__export(FLAG_DEFINITIONS_exports, {
  BRUM_SESSION_TROUBLESHOOTING: () => BRUM_SESSION_TROUBLESHOOTING,
  DASHBOARDS_ENABLED: () => DASHBOARDS_ENABLED,
  DEMO_ENABLE_AWS_OVERVIEW: () => DEMO_ENABLE_AWS_OVERVIEW,
  ENABLE_AI_ASSISTANT: () => ENABLE_AI_ASSISTANT,
  ENABLE_AI_MODAL: () => ENABLE_AI_MODAL,
  ENABLE_AI_TRAINING: () => ENABLE_AI_TRAINING,
  FSOMON_ENABLED: () => FSOMON_ENABLED,
  LIGHT_THEME: () => LIGHT_THEME,
  LOG_PROCESSING_ENABLED: () => LOG_PROCESSING_ENABLED,
  MASKING_CONFIG_ENABLED: () => MASKING_CONFIG_ENABLED,
  METRIC_EXPLORER_ENABLED: () => METRIC_EXPLORER_ENABLED,
  PAGE_HEADER_ENABLED: () => PAGE_HEADER_ENABLED,
  QUERY_BUILDER_ENABLED: () => QUERY_BUILDER_ENABLED,
  SCHEMA_BROWSER_ENABLED: () => SCHEMA_BROWSER_ENABLED,
  SHOW_TEMPLATE_AUTHORING: () => SHOW_TEMPLATE_AUTHORING,
  TELEMETRY_ENABLED: () => TELEMETRY_ENABLED,
  Z__DEMO_HIDE_DEV_TOOL_STATUS__: () => Z__DEMO_HIDE_DEV_TOOL_STATUS__,
  Z__DEMO_TEST_FLAG_FOR_NEXT__: () => Z__DEMO_TEST_FLAG_FOR_NEXT__,
  Z__GRID_ELEMENT_LIMITER__: () => Z__GRID_ELEMENT_LIMITER__,
  Z__TEST_NUMBER_FLAG__: () => Z__TEST_NUMBER_FLAG__,
  Z__TEST_STRING_FLAG__: () => Z__TEST_STRING_FLAG__
});

// src/modules/featureFlags/createFlag.ts
function createFlag(definition) {
  return Object.freeze({
    defaultValue: definition.defaultValue,
    description: definition.description,
    remoteFlagName: definition.remoteFlagName ?? ""
  });
}
__name(createFlag, "createFlag");

// src/modules/featureFlags/FLAG_DEFINITIONS.ts
var LIGHT_THEME = createFlag({
  remoteFlagName: "ui.lighttheme.enabled",
  description: "Enable light theme",
  defaultValue: true
});
var DASHBOARDS_ENABLED = createFlag({
  remoteFlagName: "ui.dashboards.features",
  description: "Toggle all dashboards related features",
  defaultValue: true
});
var SCHEMA_BROWSER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.schema-browser.enabled",
  description: "feature flag to enable and disable schema browser",
  defaultValue: false
});
var QUERY_BUILDER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.query-builder.enabled",
  description: "feature flag to enable and disable query builder",
  defaultValue: false
});
var METRIC_EXPLORER_ENABLED = createFlag({
  remoteFlagName: "tools.melt.metric-explorer.enabled",
  description: "feature flag to enable and disable metric explorer",
  defaultValue: false
});
var LOG_PROCESSING_ENABLED = createFlag({
  remoteFlagName: "log.processing.enabled",
  description: "faeture flag to enable and disable Log processing page",
  defaultValue: true
});
var SHOW_TEMPLATE_AUTHORING = createFlag({
  description: "Show the Authoring Editor for Templates. Hide URL in LeftNav + avoid rendering on /authoring",
  defaultValue: false,
  remoteFlagName: "ui.template.authoring.enabled"
});
var FSOMON_ENABLED = createFlag({
  remoteFlagName: "ui.dashboards.fsomon",
  description: "Toggle FSO Platform Monitoring",
  defaultValue: false
});
var DEMO_ENABLE_AWS_OVERVIEW = createFlag({
  description: "DEMO - Show the aws overview on left nav",
  defaultValue: false
});
var BRUM_SESSION_TROUBLESHOOTING = createFlag({
  description: "Enables Session troubleshooting feature to become visible in the UI",
  defaultValue: false,
  remoteFlagName: "brum.session.troubleshooting.enabled"
});
var MASKING_CONFIG_ENABLED = createFlag({
  remoteFlagName: "masking.config.enabled",
  description: "faeture flag to enable and disable data masking configuration",
  defaultValue: true
});
var PAGE_HEADER_ENABLED = createFlag({
  description: "feature flag to enable page header with title, breadcrumbs and time range",
  defaultValue: true,
  remoteFlagName: "page.header.enabled"
});
var ENABLE_AI_ASSISTANT = createFlag({
  description: "Flag to enable AI assistant",
  defaultValue: false,
  remoteFlagName: "ai.assistant.enabled"
});
var ENABLE_AI_MODAL = createFlag({
  description: "feature flag to enable ai modal from the top nav",
  defaultValue: false,
  remoteFlagName: "ai.modal.enabled"
});
var ENABLE_AI_TRAINING = createFlag({
  description: "feature flag to enable ai training from the ai modal",
  defaultValue: false,
  remoteFlagName: "ai.training.enabled"
});
var TELEMETRY_ENABLED = createFlag({
  description: "feature flag to enable telemetry",
  defaultValue: false,
  remoteFlagName: "ui.tracking.next-ui.enabled"
});
var Z__GRID_ELEMENT_LIMITER__ = createFlag({
  description: "Enable the flag via enabled and change count of grid rows via value for /dev/tool grid",
  defaultValue: { value: 5, enabled: false }
});
var Z__TEST_STRING_FLAG__ = createFlag({
  description: "DO NOT DELETE THIS FLAG",
  defaultValue: { value: "test" }
});
var Z__TEST_NUMBER_FLAG__ = createFlag({
  description: "DO NOT DELETE THIS FLAG",
  defaultValue: { value: 0 }
});
var Z__DEMO_HIDE_DEV_TOOL_STATUS__ = createFlag({
  description: "DEMO - Hide the DevTool status on /dev/tool",
  defaultValue: false
});
var Z__DEMO_TEST_FLAG_FOR_NEXT__ = createFlag({
  description: "DEMO flag for testing in Next",
  defaultValue: true,
  remoteFlagName: "test.demo.flag"
});

// src/modules/featureFlags/FeatureFlagsUtils.ts
var getFeatureFlags = /* @__PURE__ */ __name((featureFlagsStoreKey) => {
  const featureFlags = localStorage.getItem(featureFlagsStoreKey);
  return featureFlags === null ? void 0 : JSON.parse(featureFlags);
}, "getFeatureFlags");
var setDefaultFeatureFlags = /* @__PURE__ */ __name((featureFlagsStoreKey, flagDefinitionsFromConfig) => {
  const flagNameWithCurrentValue = defaultValuesFromDefinitions(
    Object.keys(FLAG_DEFINITIONS_exports),
    flagDefinitionsFromConfig
  );
  updateLocalStorage(featureFlagsStoreKey, flagNameWithCurrentValue);
}, "setDefaultFeatureFlags");
var updateFeatureFlagsFromDefinitions = /* @__PURE__ */ __name((featureFlagsStoreKey, flagDefinitionsFromConfig) => {
  const flagsFromLocalStorage = getFeatureFlags(featureFlagsStoreKey);
  if (flagsFromLocalStorage !== void 0) {
    const newFlags = Object.keys({ ...FLAG_DEFINITIONS_exports, ...flagDefinitionsFromConfig }).filter(
      (key) => !Object.keys(flagsFromLocalStorage).includes(key)
    );
    const flagsWithDefaultValues = defaultValuesFromDefinitions(newFlags, flagDefinitionsFromConfig);
    const updatedFeatureFlagsToBeStored = {
      ...flagsWithDefaultValues,
      ...flagsFromLocalStorage
    };
    updateLocalStorage(featureFlagsStoreKey, updatedFeatureFlagsToBeStored);
  }
}, "updateFeatureFlagsFromDefinitions");
var setDefaultFlagValue = /* @__PURE__ */ __name((featureFlagsStoreKey, flagName, value) => {
  const defaultFlags = getFeatureFlags(featureFlagsStoreKey);
  if (defaultFlags !== void 0 && defaultFlags[flagName] != null) {
    defaultFlags[flagName].value = value;
    updateLocalStorage(featureFlagsStoreKey, defaultFlags);
  }
}, "setDefaultFlagValue");
var getFlagValue = /* @__PURE__ */ __name((featureFlagsStoreKey, flagName, updatedFeatureFlags) => {
  const defaultFlags = updatedFeatureFlags ?? getFeatureFlags(featureFlagsStoreKey);
  if (defaultFlags !== void 0 && defaultFlags[flagName] != null) {
    const overrideValueFromLocalStorage = defaultFlags[flagName].overriddenValue;
    if (overrideValueFromLocalStorage == null) {
      return defaultFlags[flagName].value;
    }
    return overrideValueFromLocalStorage;
  }
  return FLAG_DEFINITIONS_exports[flagName]?.defaultValue;
}, "getFlagValue");
function defaultValuesFromDefinitions(flags, definitionsFromConfig) {
  const mergedKeys = [.../* @__PURE__ */ new Set([...flags, ...Object.keys(definitionsFromConfig || {})])];
  return mergedKeys.reduce((prevObj, cur) => {
    const defaultValue = definitionsFromConfig?.[cur]?.defaultValue ?? FLAG_DEFINITIONS_exports[cur].defaultValue;
    return {
      ...prevObj,
      [cur]: {
        value: defaultValue
      }
    };
  }, {});
}
__name(defaultValuesFromDefinitions, "defaultValuesFromDefinitions");
function updateLocalStorage(featureFlagsStoreKey, flagNameWithCurrentValue) {
  localStorage.setItem(featureFlagsStoreKey, JSON.stringify(flagNameWithCurrentValue));
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: featureFlagsStoreKey,
      newValue: JSON.stringify(flagNameWithCurrentValue)
    })
  );
}
__name(updateLocalStorage, "updateLocalStorage");

// src/modules/featureFlags/hooks/useFlagValue.ts
var import_react = require("react");

// src/modules/featureFlags/FeatureFlags.ts
var OLD_NEXT_FEATURE_FLAG_STORE_KEY = "feature-flags-store";

// src/modules/featureFlags/components/DevTool.tsx
var import_uik8 = require("@appd/uik");
var import_react7 = require("react");

// src/modules/featureFlags/components/DevToolBar.tsx
var import_uik = require("@appd/uik");
var import_jsx_runtime = require("react/jsx-runtime");
var {
  TYPOGRAPHY: { P3_EMPHASIS },
  COLORS: { CONTROL_BORDER_WEAK, DEFAULT_TEXT, DEFAULT_TEXT_MEDIUM, INTERACT_TEXT_HOVER },
  SPACING
} = import_uik.MAGNETIC_TOKENS;
var { DEV_WARNING, FLAGS_BUTTON, DEV_INFO } = {
  DEV_WARNING: import_uik.css.Styles({
    alignItems: "center",
    color: DEFAULT_TEXT_MEDIUM,
    display: "flex",
    font: P3_EMPHASIS,
    height: 34,
    justifyContent: "space-between",
    marginRight: 30,
    width: "100%"
  }),
  DEV_INFO: import_uik.css.Styles({
    gap: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexGrow: 1,
    height: "100%",
    ":hover": {
      color: DEFAULT_TEXT_MEDIUM
    }
  }),
  FLAGS_BUTTON: import_uik.css.Styles({
    background: "transparent",
    border: "none",
    borderBottomStyle: "solid",
    borderBottomWidth: 3,
    borderBottomColor: CONTROL_BORDER_WEAK,
    color: DEFAULT_TEXT,
    cursor: "pointer",
    font: P3_EMPHASIS,
    paddingTop: SPACING[2],
    paddingBottom: SPACING[2],
    paddingLeft: SPACING[4],
    paddingRight: SPACING[4],
    ":hover": {
      color: INTERACT_TEXT_HOVER
    }
  })
};

// src/modules/featureFlags/components/DevToolContent.tsx
var import_uik7 = require("@appd/uik");
var import_react6 = require("react");

// src/modules/featureFlags/components/DevToolHeader.tsx
var import_uik2 = require("@appd/uik");
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
var {
  COLORS: {
    CONTROL_BG_WEAK,
    CONTROL_BORDER_MEDIUM,
    CONTROL_BORDER_MEDIUM_FOCUS,
    CONTROL_ICON_MEDIUM,
    CONTROL_ICON_MEDIUM_FOCUS,
    CONTROL_ICON_MEDIUM_HOVER,
    DEFAULT_TEXT: DEFAULT_TEXT2,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM2
  },
  RADIUS,
  TYPOGRAPHY: { P3_DEFAULT },
  SPACING: SPACING2
} = import_uik2.MAGNETIC_TOKENS;
var { INPUT_BOX, SEARCH_ICON, CLEAR_ICON, INPUT, HEADER, RIGHT_CONTAINER, LEFT_CONTAINER } = {
  INPUT_BOX: (focus) => import_uik2.css.Styles({
    backgroundColor: CONTROL_BG_WEAK,
    color: DEFAULT_TEXT_MEDIUM2,
    font: P3_DEFAULT,
    minWidth: 200,
    height: 29,
    paddingLeft: SPACING2[1],
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: focus ? CONTROL_BORDER_MEDIUM_FOCUS : CONTROL_BORDER_MEDIUM,
    borderRadius: RADIUS.DEFAULT,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  SEARCH_ICON: (focus) => import_uik2.css.Styles({
    paddingLeft: SPACING2[1],
    paddingRight: SPACING2[1],
    "& > svg > path": {
      fill: focus ? CONTROL_ICON_MEDIUM_FOCUS : CONTROL_ICON_MEDIUM
    }
  }),
  CLEAR_ICON: (focus) => import_uik2.css.Styles({
    display: "flex",
    alignItems: "center",
    borderRightStyle: "solid",
    borderRightWidth: 1,
    borderRightColor: focus ? CONTROL_BORDER_MEDIUM_FOCUS : CONTROL_BORDER_MEDIUM,
    height: "100%",
    paddingRight: SPACING2[1],
    cursor: "pointer",
    "& > svg > path": {
      fill: focus ? CONTROL_ICON_MEDIUM_FOCUS : CONTROL_ICON_MEDIUM
    },
    ":hover": {
      "& > svg > path": {
        fill: CONTROL_ICON_MEDIUM_HOVER
      }
    }
  }),
  INPUT: import_uik2.css.Styles({
    paddingLeft: SPACING2[1],
    color: DEFAULT_TEXT_MEDIUM2,
    backgroundColor: "transparent",
    flex: 1,
    font: P3_DEFAULT,
    border: "none",
    overflow: "hidden",
    ":focus": {
      color: DEFAULT_TEXT2,
      outline: "none"
    }
  }),
  HEADER: import_uik2.css.Styles({
    cursor: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingTop: SPACING2[2],
    paddingBottom: SPACING2[2],
    paddingLeft: SPACING2[3],
    paddingRight: SPACING2[3]
  }),
  RIGHT_CONTAINER: import_uik2.css.Styles({
    display: "inline-flex",
    alignItems: "center",
    gap: SPACING2[4]
  }),
  LEFT_CONTAINER: import_uik2.css.Styles({
    font: P3_DEFAULT
  })
};

// src/modules/featureFlags/components/FeatureFlagGrid.tsx
var import_uik6 = require("@appd/uik");
var import_react4 = require("react");

// src/modules/featureFlags/components/gridCellRenderer/RemoteFlagRenderer.tsx
var import_uik3 = require("@appd/uik");
var import_jsx_runtime3 = require("react/jsx-runtime");
var {
  SPACING: SPACING3,
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS2 }
} = import_uik3.MAGNETIC_TOKENS;
var REMOTE_WRAPPER = {
  alignItems: "center",
  display: "flex",
  font: P3_EMPHASIS2,
  gap: SPACING3[1]
};

// src/modules/featureFlags/components/gridCellRenderer/SelectValueRenderer.tsx
var import_uik5 = require("@appd/uik");
var import_react3 = require("react");

// src/modules/featureFlags/components/SelectGridTrigger.tsx
var import_uik4 = require("@appd/uik");
var import_jsx_runtime4 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM3, INTERACT_BG_WEAK, INTERACT_BORDER_WEAK }
} = import_uik4.MAGNETIC_TOKENS;
var { SELECT_VALUE_BUTTON, DISPLAY_VALUE, DROPDOWN_ICON } = {
  SELECT_VALUE_BUTTON: import_uik4.css.Styles({
    width: 285,
    background: INTERACT_BG_WEAK,
    borderBottomSize: 1,
    borderBottomStyle: "solid",
    borderBottomColor: INTERACT_BORDER_WEAK,
    borderRadius: 0
  }),
  DISPLAY_VALUE: import_uik4.css.Styles({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  DROPDOWN_ICON: import_uik4.css.Styles({
    color: DEFAULT_TEXT_MEDIUM3
  })
};
var SelectGridTrigger = import_uik4.utils.forwardRef(
  ({ toggle, selected }, ref) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik4.Button, { type: "MENU_ITEM", className: (0, import_uik4.css)({ ...SELECT_VALUE_BUTTON }), ref, onClick: toggle, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: (0, import_uik4.css)({ ...DISPLAY_VALUE }), children: [
    typeof selected === "string" ? selected : JSON.stringify(selected),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_uik4.Icon, { className: (0, import_uik4.css)({ ...DROPDOWN_ICON }), type: "Navigation.ArrowDropDown" })
  ] }) })
);

// src/modules/featureFlags/components/gridCellRenderer/SelectValueRenderer.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var { SPACING: SPACING4 } = import_uik5.MAGNETIC_TOKENS;
var { MULTIVARIATE_WRAPPER, MULTIVARIATE_INPUT } = {
  MULTIVARIATE_WRAPPER: import_uik5.css.Styles({ display: "flex", gap: SPACING4[1], width: "100%" }),
  MULTIVARIATE_INPUT: import_uik5.css.Styles({ width: "100%", maxWidth: 250 })
};

// src/modules/featureFlags/components/FeatureFlagGrid.tsx
var import_jsx_runtime6 = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  require("react/jsx-runtime")
);

// src/modules/featureFlags/FeatureFlagContext.ts
var import_react5 = require("react");
var FeatureFlagContext = (0, import_react5.createContext)(void 0);

// src/modules/featureFlags/components/DevToolContent.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var SPINNER = import_uik7.css.Styles({
  display: "flex",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "center",
  height: 200
});

// src/modules/container/constant/CONSTANTS.ts
var CONSTANTS;
((CONSTANTS2) => {
  CONSTANTS2.DEFAULT_APP_NAME = "cco";
  CONSTANTS2.APPD_NEXT_TENANT_ID = "appd-next-tenant-id";
  CONSTANTS2.APPD_NEXT_PRINCIPAL_ID = "appd-next-principal-id";
  CONSTANTS2.PLATFORM_APP_LAYERID = "platformapp";
  CONSTANTS2.SHELL_APP = "shell";
  CONSTANTS2.IDENTITY_API_URL_FOR_LOCAL = "https://identity-api.saas.appd-test.com/v3.0/accounts/sessions/me";
  CONSTANTS2.IDENTITY_API_URL = "https://identity-api.appdynamics.com/v3.0/accounts/sessions/me";
  CONSTANTS2.ZODIAC_MATCH_REGEX = "/app/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)/([a-zA-Z0-9-_]*)";
  CONSTANTS2.DIABLO_MATCH_REGEX = "/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)";
  CONSTANTS2.SHELL_FLAGS_STORE_KEY = "shell-feature-flags-store";
  CONSTANTS2.TRACE_PARENT = "traceparent";
  CONSTANTS2.TRACE_STATE = "tracestate";
  CONSTANTS2.TRACE_STATE_NAMESPACE = "ui";
  CONSTANTS2.COP_TENANT_ID = "COP_TENANT_ID";
})(CONSTANTS || (CONSTANTS = {}));

// src/modules/container/constant/ShellEventTypes.ts
var ShellEventTypes = {
  HELP_CENTER_OPEN: "HELP_CENTER_OPEN",
  HELP_CENTER_CLOSED: "HELP_CENTER_CLOSED",
  HELP_CENTER_AI_LINK_CLICKED: "HELP_CENTER_AI_LINK_CLICKED",
  HELP_CENTER_SHOW_AI_TOUR: "HELP_CENTER_SHOW_AI_TOUR",
  HELP_CENTER_AI_TOUR_COMPLETED: "HELP_CENTER_AI_TOUR_COMPLETED",
  EXCHANGE_ICON_CLICKED: "EXCHANGE_ICON_CLICKED",
  EXCHANGE_APP_LINK_CLICKED: "EXCHANGE_APP_LINK_CLICKED",
  REPLAY_TOUR_CLICKED: "REPLAY_TOUR_CLICKED",
  PAGE_TITLE_UPDATED: "PAGE_TITLE_UPDATED"
};

// src/modules/featureFlags/components/DevTool.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK2, DEFAULT_BG }
} = import_uik8.MAGNETIC_TOKENS;
var { RENDER_DEV_TOOL, DEV_TOOL_WRAPPER } = {
  RENDER_DEV_TOOL: (open) => import_uik8.css.Styles({
    display: open ? "block" : "none",
    transition: "height 200ms ease-out 0s"
  }),
  DEV_TOOL_WRAPPER: (showDevTool) => import_uik8.css.Styles({
    display: showDevTool ? "block" : "none",
    backgroundColor: DEFAULT_BG,
    borderSize: 2,
    borderStyle: "solid",
    borderColor: CONTROL_BORDER_WEAK2,
    cursor: "pointer"
  })
};

// src/modules/featureFlags/components/FeatureFlagsProvider.tsx
var import_lib_featureflag = require("@appd/lib-featureflag");
var import_react8 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
var LAUNCH_DARKLY_CELL_ATTR_NAME = "cell";
var FeatureFlagsProvider = /* @__PURE__ */ __name(({
  enabled = false,
  config,
  children
}) => {
  const [flags, setFlags] = (0, import_react8.useState)();
  const [isLoading, setIsLoading] = (0, import_react8.useState)(true);
  (0, import_react8.useEffect)(() => {
    if (!enabled || config?.tenantId === "" || config?.tenantId === void 0 || config.launchDarklyClientId === "") {
      setIsLoading(false);
      return;
    }
    const isLocal2 = globalThis.location?.hostname === "localhost" || globalThis.location?.hostname === "127.0.0.1";
    const baseUrl2 = isLocal2 ? "https://app.launchdarkly.com" : `${globalThis.location.origin}/session/api/ext/featureFlags/v2`;
    const context = new import_lib_featureflag.FlagContext.Builder().setRegion(config.launchDarklyRegion).setTenant(config.tenantId).setCustomAttrs((/* @__PURE__ */ new Map()).set(LAUNCH_DARKLY_CELL_ATTR_NAME, config.cell)).build();
    globalThis.remoteFlagsPromise = import_lib_featureflag.FeatureFlag.getInstance(
      context,
      config.launchDarklyClientId,
      baseUrl2,
      void 0,
      void 0,
      !isLocal2,
      // send LD events only on non-local environments
      false
    );
    globalThis.remoteFlagsPromise.then((remoteFlags) => {
      initOrUpdateFlags(config.flagsStoreKey, config.flagDefinitions);
      setDefaultsFromRemote(config.flagsStoreKey, remoteFlags, config.flagDefinitions);
      setFlags(remoteFlags);
    }).catch(console.error).finally(() => setIsLoading(false));
  }, [enabled, config]);
  if (!enabled) {
    return children;
  }
  return isLoading ? null : /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(FeatureFlagContext.Provider, { value: flags, children });
}, "FeatureFlagsProvider");
function setDefaultsFromRemote(flagsStoreKey, flags, flagDefinitions) {
  Object.entries({ ...FLAG_DEFINITIONS_exports, ...flagDefinitions || {} }).map(
    ([localFlagName, { defaultValue, remoteFlagName }]) => remoteFlagName && setDefaultFlagValue(
      flagsStoreKey,
      localFlagName,
      typeof defaultValue === "boolean" ? flags.getBooleanFlagVariationDetail(remoteFlagName, String(defaultValue).toLowerCase() === "true").getValue() : flags.getJSONFlagVariationDetail(remoteFlagName, defaultValue).getValue()
    )
  );
}
__name(setDefaultsFromRemote, "setDefaultsFromRemote");
function migrateFeatureFlags(featureFlagsStoreKey) {
  const oldFeatureFlagData = globalThis.localStorage.getItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY);
  if (oldFeatureFlagData) {
    globalThis.localStorage.setItem(featureFlagsStoreKey, oldFeatureFlagData);
    globalThis.localStorage.removeItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY);
  }
}
__name(migrateFeatureFlags, "migrateFeatureFlags");
function initOrUpdateFlags(featureFlagsStoreKey, flagDefinitionsFromConfig) {
  if (globalThis.localStorage.getItem(featureFlagsStoreKey)) {
    updateFeatureFlagsFromDefinitions(featureFlagsStoreKey, flagDefinitionsFromConfig);
  } else if (featureFlagsStoreKey === "next-ui-feature-flags-store" && globalThis.localStorage.getItem(OLD_NEXT_FEATURE_FLAG_STORE_KEY)) {
    migrateFeatureFlags(featureFlagsStoreKey);
  } else {
    setDefaultFeatureFlags(featureFlagsStoreKey, flagDefinitionsFromConfig);
  }
}
__name(initOrUpdateFlags, "initOrUpdateFlags");

// src/modules/container/builder/TopNavBuilder.tsx
var import_uik61 = require("@appd/uik");
var import_react34 = require("react");

// src/modules/container/components/label/LabelComponent.tsx
var import_uik9 = require("@appd/uik");
var import_jsx_runtime10 = (
  // default styles which can be overridden by style props
  require("react/jsx-runtime")
);
var {
  COLORS: { INVERSE_TEXT }
} = import_uik9.MAGNETIC_TOKENS;
var LabelComponent = /* @__PURE__ */ __name(({ style, text }) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { style: { fontSize: 19, color: INVERSE_TEXT, whiteSpace: "nowrap", ...style }, "data-testid": "label", children: text }), "LabelComponent");
var LabelComponent_default = LabelComponent;

// src/modules/container/components/refresh/RefreshComponent.tsx
var import_react9 = require("react");
var import_uik11 = require("@appd/uik");

// src/modules/container/event/ShellEvent.ts
var ShellEvent = {
  eventList: /* @__PURE__ */ new Map(),
  on(eventType, eventAction) {
    if (!this.eventList.has(eventType)) {
      this.eventList.set(eventType, []);
    }
    if (this.eventList.get(eventType)) {
      this.eventList.get(eventType).push(eventAction);
    }
    return this;
  },
  un(eventType, eventAction) {
    if (this.eventList.get(eventType)) {
      const index = this.eventList.get(eventType).indexOf(eventAction);
      if (index > -1) {
        this.eventList.get(eventType).splice(index, 1);
      }
    }
  },
  emit(eventType, ...args) {
    if (this.eventList.get(eventType)) {
      this.eventList.get(eventType).forEach((callback) => {
        callback(...args);
      });
    }
  }
};

// src/modules/container/components/style/button/ButtonStyles.tsx
var import_uik10 = require("@appd/uik");
var ButtonStyles = {
  SHELL_BUTTON_STYLES: import_uik10.css.Styles({
    ":hover": {
      backgroundColor: "#4C416F"
    }
  })
};

// src/modules/container/components/refresh/RefreshComponent.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var STYLES = {
  ICON_REFRESH: import_uik11.css.Styles({
    backgroundColor: "transparent"
  })
};
var {
  STATIC: { HEADER_ICON }
} = import_uik11.MAGNETIC_TOKENS;
var RefreshComponent = /* @__PURE__ */ __name(({ style, onClickEvent, triggerRefreshEvent }) => {
  const triggerRefresh = (0, import_react9.useCallback)(() => {
    console.log("Refresh Triggered in Shell");
  }, []);
  (0, import_react9.useEffect)(() => {
    ShellEvent.on(triggerRefreshEvent, triggerRefresh);
    return () => {
      ShellEvent.un(triggerRefreshEvent, triggerRefresh);
    };
  }, [triggerRefresh, triggerRefreshEvent]);
  const onClickHandler = /* @__PURE__ */ __name(() => {
    if (onClickEvent) {
      ShellEvent.emit(onClickEvent);
    }
  }, "onClickHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_uik11.Tooltip, { value: "Refresh to see the latest data", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    import_uik11.Button,
    {
      style,
      className: (0, import_uik11.css)({ ...STYLES.ICON_REFRESH, ...ButtonStyles.SHELL_BUTTON_STYLES }),
      icon: "Action.Refresh",
      iconColor: HEADER_ICON,
      type: "TERTIARY",
      onClick: onClickHandler,
      tabIndex: 0,
      "data-testid": "refresh"
    }
  ) });
}, "RefreshComponent");
var RefreshComponent_default = RefreshComponent;

// src/modules/container/components/logout/LogoutComponent.tsx
var import_uik12 = require("@appd/uik");

// src/modules/container/auth/auth.util.ts
var SignInUrl = "/session/api/auth/start";
var SignOutUrl = "/session/api/auth/sign_out";
function signIn(callbackUrl) {
  if (callbackUrl) {
    globalThis.location.href = `${SignInUrl}?rd=${callbackUrl}`;
  } else {
    const currentLocation = encodeURIComponent(globalThis.location.href);
    globalThis.location.href = `${SignInUrl}?rd=${currentLocation}`;
  }
}
__name(signIn, "signIn");
function signOut(logoutUrl) {
  const currentLocation = encodeURIComponent(globalThis.location.href);
  const redirectUrl = encodeURIComponent(`${logoutUrl}?target=${currentLocation}`);
  const sessionSignoutUrl = `${SignOutUrl}?rd=${redirectUrl}`;
  globalThis.location.href = sessionSignoutUrl;
}
__name(signOut, "signOut");

// src/modules/container/components/logout/LogoutComponent.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var LogoutComponent = /* @__PURE__ */ __name(({ logoutUrl, style }) => /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { style, "data-testid": "logout", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_uik12.Button, { onClick: () => signOut(logoutUrl), children: "Logout" }) }), "LogoutComponent");
var LogoutComponent_default = LogoutComponent;

// src/modules/container/components/breadcrumbs/BreadcrumbsComponent.tsx
var import_uik13 = require("@appd/uik");
var import_react10 = require("react");
var import_jsx_runtime13 = require("react/jsx-runtime");
var {
  SPACING: SPACING5,
  COLORS: { INVERSE_TEXT: INVERSE_TEXT2 },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT2 }
} = import_uik13.MAGNETIC_TOKENS;
var arrowStyle = (0, import_uik13.css)({
  display: "flex",
  paddingLeft: SPACING5[1],
  paddingRight: SPACING5[1],
  "> svg > path": {
    fill: INVERSE_TEXT2
  }
});
var anchorStyle = (0, import_uik13.css)({
  // maxWidth: 400, // DASHBASE-2203
  color: INVERSE_TEXT2,
  font: P3_DEFAULT2,
  whiteSpace: "nowrap",
  textDecorationLine: "none",
  ":hover": {
    textDecorationLine: "underline",
    color: "#6C9EF5"
  }
});
var textStyle = (0, import_uik13.css)({
  maxWidth: 400,
  color: INVERSE_TEXT2,
  font: P3_DEFAULT2,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textDecorationLine: "none",
  ":last-child": {
    fontWeight: 500,
    color: "#fff"
  }
});
function BreadcrumbsComponent({ items, onClickEvent, style }) {
  const [stateItems, setStateItems] = (0, import_react10.useState)(items);
  (0, import_react10.useEffect)(() => {
    const updateBreadcrumbs = /* @__PURE__ */ __name((newItems) => {
      setStateItems(newItems);
    }, "updateBreadcrumbs");
    ShellEvent.on("stateBreadcrumbItemsUpdated", updateBreadcrumbs);
    return () => {
      ShellEvent.un("stateBreadcrumbItemsUpdated", updateBreadcrumbs);
    };
  }, []);
  (0, import_react10.useEffect)(() => {
    setStateItems(items);
  }, [items]);
  if (stateItems.length === 0) {
    return null;
  }
  const onClickHandler = /* @__PURE__ */ __name((item) => {
    if (onClickEvent) {
      ShellEvent.emit(onClickEvent, item);
    }
  }, "onClickHandler");
  const renderedItems = stateItems.flatMap((item, index, { length }) => {
    const itemKey = `${item.href}-${index}`;
    if (index === length - 1) {
      return [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_uik13.Tooltip, { value: item.label, "data-testid": "tooltip-breadcrumb", children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: textStyle, "data-testid": "last-breadcrumb-label", children: item.label }) }, itemKey)
      ];
    }
    return [
      item.href !== "" ? /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "a",
        {
          href: item.href,
          className: anchorStyle,
          title: item.title,
          onClick: (event) => {
            if (onClickEvent) {
              event.preventDefault();
              onClickHandler(item);
            }
          },
          children: item.label
        },
        itemKey
      ) : /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_uik13.Tooltip, { value: item.label, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: textStyle, "data-testid": "breadcrumbNoLink", children: item.label }, itemKey) }, itemKey),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className: arrowStyle, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_uik13.Icon.Navigation.Slash, { size: "SMALL", fill: INVERSE_TEXT2 }) }, `chevron:${itemKey}`)
    ];
  });
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
    "div",
    {
      style,
      className: (0, import_uik13.css)({ display: "flex", alignItems: "center" }),
      "data-testid": "breadcrumbs",
      children: renderedItems
    },
    "Breadcrumbs"
  );
}
__name(BreadcrumbsComponent, "BreadcrumbsComponent");

// src/modules/container/components/miniProfile/MiniProfile.tsx
var import_uik30 = require("@appd/uik");
var import_react21 = require("react");

// src/modules/container/utils/hooks/fetchHooks.ts
var import_swr = __toESM(require("swr"));

// src/modules/container/utils/fetch/shellFetch.ts
var import_uik14 = require("@appd/uik");
var commonErrorHandler;
var criticalAPIUrl = ["initConfig", "uishell:appSwitcher", "uishell:navItems"];
var execeptionAPIList = ["me"];
function setCommonErrorHandler(handler) {
  commonErrorHandler = handler;
}
__name(setCommonErrorHandler, "setCommonErrorHandler");
var errHandler = /* @__PURE__ */ __name((err, url) => {
  const apiName = url.split("/").pop();
  if (execeptionAPIList.includes(apiName)) {
    return;
  }
  (0, import_uik14.toast)({
    description: `${url}, ${err.message}`,
    icon: "ERROR",
    title: "API Error"
  });
  if (criticalAPIUrl.includes(apiName) && commonErrorHandler) {
    commonErrorHandler();
  }
}, "errHandler");
function shellFetch(url, option) {
  try {
    return fetch(url, option).then((result) => {
      if (result.status !== 200 && result.status !== 401 && result.status !== 202) {
        errHandler(new Error("API Error"), url);
      }
      return result;
    }).catch((err) => {
      errHandler(err, url);
    });
  } catch (err) {
    errHandler(err, url);
    return Promise.reject(err);
  }
}
__name(shellFetch, "shellFetch");

// src/modules/container/utils/hooks/fetchHooks.ts
var fetcher = /* @__PURE__ */ __name((url) => shellFetch(url, {
  credentials: "include"
}).then((res) => res.json()), "fetcher");
var useSWRPreConfigured = /* @__PURE__ */ __name((url) => {
  const { data, error, isLoading } = (0, import_swr.default)(url, fetcher, {
    shouldRetryOnError: false
  });
  return {
    data,
    isLoading,
    error
  };
}, "useSWRPreConfigured");

// src/modules/container/utils/prependScheme.ts
var prependScheme = /* @__PURE__ */ __name((url, scheme = "https") => {
  if (url.match(/^http(s?):\/\//)) {
    return url;
  }
  return `${scheme}://${url}`;
}, "prependScheme");

// src/modules/container/utils/selectedApplication.ts
var selectedAppData = {
  tenantId: "",
  theme: void 0,
  appName: "",
  appTitle: "",
  site: "",
  appNavItems: void 0,
  appHelpCenterItems: void 0,
  appVersion: ""
};
var getSelectedApplication = /* @__PURE__ */ __name(() => selectedAppData, "getSelectedApplication");
var setSelectedApplication = /* @__PURE__ */ __name((item, tenantId) => {
  selectedAppData.appName = item.layerId;
  selectedAppData.appTitle = item.data.title;
  selectedAppData.site = item.data.homePageUri.site;
  selectedAppData.tenantId = tenantId;
}, "setSelectedApplication");
var setSelectedAppNavItems = /* @__PURE__ */ __name((navItems) => {
  selectedAppData.appNavItems = navItems;
}, "setSelectedAppNavItems");
var setSelectedAppHelpCenterItems = /* @__PURE__ */ __name((helpCenterItems) => {
  selectedAppData.appHelpCenterItems = helpCenterItems;
}, "setSelectedAppHelpCenterItems");
var setSelectedAppVersion = /* @__PURE__ */ __name((version) => {
  selectedAppData.appVersion = version;
}, "setSelectedAppVersion");
var setSelectedAppTheme = /* @__PURE__ */ __name((theme) => {
  selectedAppData.appHelpCenterItems = theme;
}, "setSelectedAppTheme");

// src/modules/container/utils/urlUtils.ts
var import_cloneDeep = __toESM(require("lodash/cloneDeep"));
var getFullPathFromUrl = /* @__PURE__ */ __name((urlObject, appName2 = "") => {
  let fullPath = urlObject.site ?? "";
  if (urlObject.appAware) {
    fullPath += `/${appName2}`;
  }
  if (urlObject.path) {
    fullPath += `${urlObject.path}`;
  }
  if (urlObject.query) {
    const queryParams = Object.entries(urlObject.query).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
    fullPath += `?${queryParams}`;
  }
  return fullPath;
}, "getFullPathFromUrl");
var currentUrlInList = /* @__PURE__ */ __name((urls) => {
  const currentUrl = window.location.href;
  if (urls) {
    return urls.some((url) => currentUrl.includes(url));
  }
  return false;
}, "currentUrlInList");
var appName = "";
var setAppName = /* @__PURE__ */ __name((path) => {
  appName = path;
  sessionStorage.setItem("appName", path);
}, "setAppName");
var getAppName = /* @__PURE__ */ __name(() => appName, "getAppName");
var timeRange = {
  now: (/* @__PURE__ */ new Date()).toISOString(),
  input: {
    since: "-PT1H"
  }
};
var getTimeRange = /* @__PURE__ */ __name(() => timeRange, "getTimeRange");
var getAppBasedLink = /* @__PURE__ */ __name((site, path, applicationName) => {
  let appNamePath = applicationName ? `/${applicationName}` : `/${appName}`;
  appNamePath = appNamePath === "/" ? "" : appNamePath;
  return `${site}${appNamePath}${path}`;
}, "getAppBasedLink");
var getAppHomePageLink = /* @__PURE__ */ __name((homePageUri, appNameForPrefix) => {
  const prefix = homePageUri.appAware ? `${homePageUri.site}/${appNameForPrefix}` : homePageUri.site;
  const path = homePageUri.path ?? "";
  const hash = homePageUri.hash ? `#${homePageUri.hash}` : "";
  const query = homePageUri.query ? `?${new URLSearchParams(homePageUri.query).toString()}` : "";
  return `${prefix}${path}${hash}${query}`;
}, "getAppHomePageLink");
var isSiteBasedNavigation = /* @__PURE__ */ __name((targetSiteName) => {
  const { pathname } = window.location;
  const path = pathname.replace("/session/api/ext", "");
  const zodiacMatch = path.match(CONSTANTS.ZODIAC_MATCH_REGEX);
  const diabloMatch = path.match(CONSTANTS.DIABLO_MATCH_REGEX);
  if (zodiacMatch) {
    return zodiacMatch.slice(1, 4).some((match) => targetSiteName === `/${match}`);
  }
  if (diabloMatch) {
    return targetSiteName === `/${diabloMatch[1]}`;
  }
  return false;
}, "isSiteBasedNavigation");
var getApplicationNameFromUrl = /* @__PURE__ */ __name(() => {
  const pathname = window.location.pathname.replace("/session/api/ext", "");
  const zodiacMatch = pathname.match(CONSTANTS.ZODIAC_MATCH_REGEX);
  const diabloMatch = pathname.match(CONSTANTS.DIABLO_MATCH_REGEX);
  return zodiacMatch ? zodiacMatch[3] : diabloMatch ? diabloMatch[2] : "";
}, "getApplicationNameFromUrl");
var isLocal = /* @__PURE__ */ __name(() => window.location.host.includes("localhost"), "isLocal");
var isAppdTest = /* @__PURE__ */ __name(() => window.location.hostname.includes("appd-test.com"), "isAppdTest");

// src/modules/container/utils/generateUuid.ts
function generateUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
__name(generateUuid, "generateUuid");

// src/modules/container/utils/getFeatureFlagsConfig.ts
var getFeatureFlagsConfig = /* @__PURE__ */ __name((initConfig, flagsStoreKey, flagDefinitions) => ({
  cell: initConfig.cell,
  launchDarklyClientId: initConfig.integrations?.launchDarklyClientId ?? "",
  launchDarklyRegion: initConfig.integrations?.launchDarklyRegion ?? "",
  flagsStoreKey,
  tenantId: initConfig.tenantId,
  flagDefinitions
}), "getFeatureFlagsConfig");

// src/modules/container/components/miniProfile/AccountManagement/AccountManagement.tsx
var import_uik16 = require("@appd/uik");

// src/modules/container/components/miniProfile/getStyles.ts
var import_uik15 = require("@appd/uik");
var {
  COLORS: { INTERACT_TEXT },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT3 },
  SPACING: SPACING6
} = import_uik15.MAGNETIC_TOKENS;
var getStyles = /* @__PURE__ */ __name(() => import_uik15.css.Styles({
  LINK_GROUP: import_uik15.css.Styles({
    paddingTop: SPACING6[1],
    paddingBottom: SPACING6[1],
    "> .link": {
      display: "block",
      font: P3_DEFAULT3,
      paddingTop: SPACING6[2],
      paddingBottom: SPACING6[2],
      paddingLeft: SPACING6[4],
      paddingRight: SPACING6[4],
      color: INTERACT_TEXT,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  })
}), "getStyles");

// src/modules/container/components/miniProfile/AccountManagement/AccountManagement.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var accountPortal = import_uik16.format.message`Account Management Portal`.description("manage text of Account Management Portal");
var { LINK_GROUP } = getStyles();
var AccountManagement = /* @__PURE__ */ __name(({ accountsOverviewUrl }) => /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { className: (0, import_uik16.css)(LINK_GROUP), "data-testid": "accountManagement", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("a", { className: "link", href: accountsOverviewUrl, target: "_blank", rel: "noreferrer", children: accountPortal() }) }), "AccountManagement");

// src/modules/container/components/miniProfile/TenantsList/TenantsList.tsx
var import_uik18 = require("@appd/uik");

// src/modules/container/components/inlineError/InlineError.tsx
var import_uik17 = require("@appd/uik");
var import_jsx_runtime15 = require("react/jsx-runtime");
var DEFAULT_MESSAGE = "Unable to load data";
var { SPACING: SPACING7 } = import_uik17.MAGNETIC_TOKENS;
var InlineError = /* @__PURE__ */ __name(({ style }) => /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("span", { style: { display: "flex", alignItems: "center", ...style }, "data-testid": "inlineError", children: [
  /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(import_uik17.Icon.Status.Error, { size: "SMALL" }),
  /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("span", { style: { lineHeight: "18px", paddingLeft: SPACING7[2] }, children: DEFAULT_MESSAGE })
] }), "InlineError");

// src/modules/container/components/miniProfile/TenantsList/TenantsList.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");
var {
  COLORS: { INTERACT_TEXT: INTERACT_TEXT2 },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT4 },
  SPACING: SPACING8
} = import_uik18.MAGNETIC_TOKENS;
var padding = /* @__PURE__ */ __name((showViewAll) => import_uik18.css.Styles({
  paddingTop: SPACING8[2],
  paddingBottom: showViewAll ? SPACING8[2] : SPACING8[0],
  paddingLeft: SPACING8[4],
  paddingRight: SPACING8[4]
}), "padding");
var linkGroup = import_uik18.css.Styles({
  "> .link": {
    color: INTERACT_TEXT2,
    display: "block",
    font: P3_DEFAULT4,
    paddingTop: SPACING8[2],
    paddingBottom: SPACING8[2],
    paddingLeft: SPACING8[4],
    paddingRight: SPACING8[4],
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});
var TenantsList = /* @__PURE__ */ __name(({ error, isLoading, tenants, maxTenantItems }) => {
  if (isLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("div", { className: (0, import_uik18.css)(padding(false)), "data-testid": "loading", children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_uik18.Spinner, { size: "SMALL", description: "loading..." }) });
  }
  if (error) {
    return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("div", { className: (0, import_uik18.css)(padding(tenants.length > maxTenantItems)), "data-testid": "error", children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(InlineError, {}) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("div", { className: (0, import_uik18.css)(linkGroup), "data-testid": "linkGroup", children: tenants.slice(0, maxTenantItems).map(({ label, url }) => /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("a", { className: "link", href: url, target: "_blank", rel: "noreferrer", children: label }, label)) });
}, "TenantsList");

// src/modules/container/components/miniProfile/TenantsSection/TenantsSection.tsx
var import_uik19 = require("@appd/uik");
var import_jsx_runtime17 = require("react/jsx-runtime");
var {
  COLORS: { INTERACT_TEXT: INTERACT_TEXT3, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM4 },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT5, P4_DEFAULT },
  SPACING: SPACING9
} = import_uik19.MAGNETIC_TOKENS;
var tenantGroup = {
  paddingTop: SPACING9[3],
  paddingBottom: SPACING9[3],
  "> .link": {
    display: "block",
    font: P3_DEFAULT5,
    paddingTop: SPACING9[2],
    paddingLeft: SPACING9[4],
    paddingRight: SPACING9[4],
    paddingBottom: SPACING9[2],
    color: INTERACT_TEXT3,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  "> .tenantGroupContent": {
    "> .tenantGroupTitle": {
      color: DEFAULT_TEXT_MEDIUM4,
      font: P4_DEFAULT,
      paddingLeft: SPACING9[4],
      paddingRight: SPACING9[4],
      paddingBottom: SPACING9[1]
    },
    "> .viewAllLink": {
      color: INTERACT_TEXT3,
      display: "block",
      paddingTop: SPACING9[2],
      paddingLeft: SPACING9[4],
      paddingRight: SPACING9[4],
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }
};
var viewAllLink = import_uik19.format.message`View All`.description("manage text of view all link");
var TenantsSection = /* @__PURE__ */ __name((props) => {
  const { children, title, viewAllTenantsUrl, showViewAll } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { className: (0, import_uik19.css)(tenantGroup), "data-testid": "tenantsSection", children: /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { className: "tenantGroupContent", children: [
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { className: "tenantGroupTitle", children: title }),
    children,
    showViewAll && /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("a", { className: "viewAllLink", href: viewAllTenantsUrl, target: "_blank", rel: "noreferrer", children: viewAllLink() })
  ] }) });
}, "TenantsSection");

// src/modules/container/components/miniProfile/CloudTenants/prepareCloudTenantsForProps.ts
var prepareCloudTenantsForProps = /* @__PURE__ */ __name((tenantsPayload) => tenantsPayload.map((tenant) => ({
  label: tenant.name,
  url: prependScheme(tenant.vanityURL)
})), "prepareCloudTenantsForProps");

// src/modules/container/components/miniProfile/CloudTenants/CloudTenants.tsx
var import_jsx_runtime18 = require("react/jsx-runtime");
var MAX_TENANT_ITEMS = 3;
var CloudTenants = /* @__PURE__ */ __name(({ accountsViewAllUrl, cloudTenantApiUrl }) => {
  const tenantData = useSWRPreConfigured(cloudTenantApiUrl);
  if (tenantData == null) {
    return null;
  }
  const { data, error, isLoading } = tenantData;
  const tenants = data ? prepareCloudTenantsForProps(data) : [];
  return tenants.length || error || isLoading ? /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    TenantsSection,
    {
      title: "Observability Platform Tenants",
      showViewAll: tenants.length > MAX_TENANT_ITEMS,
      viewAllTenantsUrl: accountsViewAllUrl,
      "data-testid": "cloudTenants",
      children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(TenantsList, { tenants, isLoading, error, maxTenantItems: MAX_TENANT_ITEMS })
    }
  ) : null;
}, "CloudTenants");

// src/modules/container/components/miniProfile/Logout/Logout.tsx
var import_uik20 = require("@appd/uik");
var import_jsx_runtime19 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_ICON_WEAK, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM5, INTERACT_BG_WEAK_HOVER },
  SPACING: SPACING10
} = import_uik20.MAGNETIC_TOKENS;
var logout = {
  paddingTop: SPACING10[1],
  paddingBottom: SPACING10[1],
  overflow: "hidden",
  "> .logoutButton": {
    width: "100%",
    display: "flex",
    paddingLeft: SPACING10[2],
    paddingRight: SPACING10[2],
    paddingTop: SPACING10[2],
    paddingBottom: SPACING10[2],
    alignItems: "center",
    cursor: "pointer",
    color: DEFAULT_TEXT_MEDIUM5,
    border: "none",
    background: "none",
    "> .logoutIcon": {
      paddingLeft: SPACING10[1],
      paddingRight: SPACING10[1],
      "& path": {
        fill: CONTROL_ICON_WEAK
      }
    },
    "&:hover": {
      backgroundColor: INTERACT_BG_WEAK_HOVER
    }
  }
};
var logoutLink = import_uik20.format.message`Sign out`.description("manage text of sign out link");
var Logout = /* @__PURE__ */ __name(({ logoutUrl, onLogoutClickEvent }) => /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("div", { className: (0, import_uik20.css)(logout), children: /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(
  "button",
  {
    type: "button",
    className: "logoutButton",
    onClick: () => {
      if (onLogoutClickEvent) {
        ShellEvent.emit(onLogoutClickEvent);
      }
      signOut(logoutUrl);
    },
    "data-testid": "logoutButton",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("span", { className: "logoutIcon", "data-testid": "logoutIcon", children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(import_uik20.Icon.Action.Logout, { size: "SMALL" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("span", { "data-testid": "logoutLink", children: logoutLink() })
    ]
  }
) }), "Logout");

// src/modules/container/components/miniProfile/Resources/Resources.tsx
var import_uik21 = require("@appd/uik");
var import_jsx_runtime20 = require("react/jsx-runtime");
var helpAndSupportLink = import_uik21.format.message`Help & Support`.description("manage text of help & support link");
var universityLink = import_uik21.format.message`University`.description("manage text of university link");
var communityLink = import_uik21.format.message`Community`.description("manage text of community link");
var { LINK_GROUP: LINK_GROUP2 } = getStyles();
var Resources = /* @__PURE__ */ __name(({ communityUrl, helpUrl, universityUrl }) => /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("div", { className: (0, import_uik21.css)(LINK_GROUP2), "data-testid": "resources", children: [
  /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("a", { className: "link", href: helpUrl, target: "_blank", rel: "noreferrer", "data-testid": "helpandsupport", children: helpAndSupportLink() }),
  /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("a", { className: "link", href: universityUrl, target: "_blank", rel: "noreferrer", "data-testid": "university", children: universityLink() }),
  /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("a", { className: "link", href: communityUrl, target: "_blank", rel: "noreferrer", "data-testid": "community", children: communityLink() })
] }), "Resources");

// src/modules/container/components/miniProfile/SaasTenants/prepareSaasTenantsForProps/TENANT_USER_ROLE.ts
var TENANT_USER_ROLE = "tenant-user";

// src/modules/container/components/miniProfile/SaasTenants/prepareSaasTenantsForProps/filterSaasTenants.ts
var filterSaasTenants = /* @__PURE__ */ __name((tenants, userEmail) => tenants.filter(
  ({ contacts }) => contacts.some(({ email, roles }) => email === userEmail && roles.includes(TENANT_USER_ROLE))
), "filterSaasTenants");

// src/modules/container/components/miniProfile/SaasTenants/prepareSaasTenantsForProps/saasTenantUrl.ts
var saasTenantUrl = /* @__PURE__ */ __name((launchUrl, id) => `${launchUrl}/${id}/launch`, "saasTenantUrl");

// src/modules/container/components/miniProfile/SaasTenants/prepareSaasTenantsForProps/formatSaasTenants.ts
var formatSaasTenants = /* @__PURE__ */ __name((tenants, launchUrl) => tenants.map((t) => {
  const hostname = t.deployment?.saas_attributes?.hostname;
  const root = t.controller?.root_vip;
  const label = hostname !== void 0 && root !== void 0 ? `${hostname}.${root}` : "";
  const url = t.id !== void 0 ? saasTenantUrl(launchUrl, t.id) : "";
  return { label, url };
}), "formatSaasTenants");

// src/modules/container/components/miniProfile/SaasTenants/prepareSaasTenantsForProps/prepareSaasTenantsForProps.ts
var prepareSaasTenantsForProps = /* @__PURE__ */ __name((tenantsPayload, userPayload, launchUrl) => {
  const filteredTenants = filterSaasTenants(tenantsPayload.results, userPayload.user.email);
  return formatSaasTenants(filteredTenants, launchUrl);
}, "prepareSaasTenantsForProps");

// src/modules/container/components/miniProfile/SaasTenants/SaasTenants.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
var MAX_TENANT_ITEMS2 = 3;
var SaasTenants = /* @__PURE__ */ __name(({
  accountsLaunchUrl,
  accountsViewAllUrl,
  identityApiUrl,
  saasTenantApiUrl
}) => {
  const userData = useSWRPreConfigured(identityApiUrl);
  const saasData = useSWRPreConfigured(saasTenantApiUrl);
  if (saasData == null || userData == null) {
    return null;
  }
  const { data: userInfo, error: userInfoError, isLoading: isLoadingUserInfo } = userData;
  const { data: saasTenants, error: saasTenantsError, isLoading: isLoadingSaasTenants } = saasData;
  const tenants = saasTenants && userInfo ? prepareSaasTenantsForProps(saasTenants, userInfo, accountsLaunchUrl) : [];
  const error = userInfoError || saasTenantsError;
  const isLoading = isLoadingUserInfo || isLoadingSaasTenants;
  return tenants.length || error || isLoading ? /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    TenantsSection,
    {
      title: "Controller Tenants",
      showViewAll: tenants.length > MAX_TENANT_ITEMS2,
      viewAllTenantsUrl: accountsViewAllUrl,
      children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(TenantsList, { tenants, isLoading, error, maxTenantItems: MAX_TENANT_ITEMS2 })
    }
  ) : null;
}, "SaasTenants");

// src/modules/container/components/miniProfile/UserInfoSection/UserInfoSection.tsx
var import_uik23 = require("@appd/uik");

// src/modules/container/components/miniProfile/UserInfoSection/UserInfo.tsx
var import_uik22 = require("@appd/uik");
var import_jsx_runtime22 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT3, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM6 },
  SPACING: SPACING11,
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT6 }
} = import_uik22.MAGNETIC_TOKENS;
var userInformation = {
  "> .fullName": {
    color: DEFAULT_TEXT3,
    font: P3_DEFAULT6,
    marginBottom: SPACING11[1],
    "> .email": {
      color: DEFAULT_TEXT_MEDIUM6
    }
  }
};
var UserInfo = /* @__PURE__ */ __name(({ identityApiUrl }) => {
  const userData = useSWRPreConfigured(identityApiUrl);
  if (userData == null) {
    return null;
  }
  const { data, error, isLoading } = userData;
  if (isLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(import_uik22.Spinner, { size: "SMALL", description: "loading..." });
  }
  if (error) {
    return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(InlineError, {});
  }
  if (data && data.user) {
    const { user } = data;
    const fullName = `${user.first_name} ${user.last_name}`;
    return /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)("div", { className: (0, import_uik22.css)(userInformation), "data-testid": "userinformation", children: [
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("div", { className: "fullName", "data-testid": "fullname", children: fullName }),
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("div", { className: "email", "data-testid": "useremail", children: user.email })
    ] });
  }
  return null;
}, "UserInfo");

// src/modules/container/components/miniProfile/UserInfoSection/UserInfoSection.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT4, INTERACT_BG_WEAK: INTERACT_BG_WEAK2, INTERACT_BG_WEAK_HOVER: INTERACT_BG_WEAK_HOVER2 },
  SPACING: SPACING12,
  STATIC: { PROFILE_ICON, PROFILE_ICON_FILL },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT7 }
} = import_uik23.MAGNETIC_TOKENS;
var userInfoWrapper = {
  display: "flex",
  flexDirection: "column",
  paddingTop: SPACING12[5],
  paddingRight: SPACING12[3],
  paddingBottom: SPACING12[3],
  paddingLeft: SPACING12[3],
  "> .userInfoContent": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "> *": {
      marginLeft: SPACING12[3]
    },
    "> .profileImage": {
      padding: SPACING12[1],
      borderRadius: "50%",
      backgroundColor: PROFILE_ICON,
      "& path": {
        fill: PROFILE_ICON_FILL
      }
    }
  },
  "> .manageProfileLink": {
    color: DEFAULT_TEXT4,
    font: P3_DEFAULT7,
    textDecoration: "none",
    marginTop: 8,
    alignSelf: "center",
    "> .manageProfileLinkButton": {
      color: DEFAULT_TEXT4,
      width: "100%",
      borderRadius: 3,
      lineHeight: "30px",
      marginTop: SPACING12[4],
      marginBottom: SPACING12[1],
      textAlign: "center",
      backgroundColor: INTERACT_BG_WEAK2,
      border: "none",
      "&:hover": {
        backgroundColor: INTERACT_BG_WEAK_HOVER2,
        cursor: "pointer"
      }
    }
  }
};
var manageProfile = import_uik23.format.message`Manage My Profile`.description("manage text of edit profile-button");
var UserInfoSection = /* @__PURE__ */ __name(({ accountsManageProfileUrl, identityApiUrl }) => /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("div", { className: (0, import_uik23.css)(userInfoWrapper), children: [
  /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("div", { className: "userInfoContent", "data-testid": "userinfocontent", children: [
    /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("div", { className: "profileImage", "data-testid": "profileimage", children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_uik23.Icon.Location.Eum, { style: { width: 34, height: 34 } }) }),
    /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(UserInfo, { identityApiUrl })
  ] }),
  /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    "a",
    {
      className: "manageProfileLink",
      href: accountsManageProfileUrl,
      target: "_blank",
      rel: "noreferrer",
      "data-testid": "manageProfileLink",
      children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_uik23.Button, { type: "SECONDARY", "data-testid": "manageprofile", children: manageProfile() })
    }
  )
] }), "UserInfoSection");

// src/modules/container/components/miniProfile/themeSwitcher/ThemeSwitcher.tsx
var import_uik27 = require("@appd/uik");
var import_react19 = require("react");

// src/modules/preferences/orion/orionInterface.ts
var isShellPreferencesData = /* @__PURE__ */ __name((data) => data !== void 0 && "shellPreferences" in data, "isShellPreferencesData");
var SOLUTION_NAME = "uishell";
var DEFAULT_FILTER = "";

// src/modules/preferences/utils.ts
var baseUrl = `/session/api/ext/objstore/v1beta`;
var filterPreferencesByLayerType = /* @__PURE__ */ __name((items, layerType) => items.find((item) => item.layerType === layerType), "filterPreferencesByLayerType");

// src/modules/preferences/orion/headerGenerator.ts
function getHeadersAtLayer(method, layer, layerId) {
  const headers = /* @__PURE__ */ new Map([
    ["Content-Type", "application/json"],
    ["Accept", "application/".concat(method === "PATCH" ? "merge-patch+" : "").concat("json")],
    ["layer-type", layer],
    ["layer-id", layerId]
  ]);
  return headers;
}
__name(getHeadersAtLayer, "getHeadersAtLayer");

// src/modules/preferences/orion/orionService.ts
async function doRequest(method, urlprefix, headersMap, body) {
  const requestURL = baseUrl.concat(urlprefix);
  try {
    const response = await fetch(requestURL, {
      method,
      headers: {
        ...Object.fromEntries(headersMap)
      },
      body
    });
    if (!response.ok && !(response.status === 303 && method === "PUT")) {
      throw new Error(`${method} Request error: ${response.statusText}`);
    }
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    }
    return await response.text();
  } catch (error) {
    console.error(error);
    throw error;
  }
}
__name(doRequest, "doRequest");
async function getPreferencesInternal(preferenceType, layer, layerId, filter = DEFAULT_FILTER) {
  let url = `/objects/${preferenceType}`;
  if (filter !== "") {
    url = url.concat(`?filter=${filter}`);
  }
  const headers = getHeadersAtLayer("GET", layer, layerId);
  return doRequest("GET", url, headers);
}
__name(getPreferencesInternal, "getPreferencesInternal");
async function postPreferences(preferenceType, layer, layerId, body) {
  const url = `/objects/${preferenceType}`;
  const headers = getHeadersAtLayer("POST", layer, layerId);
  return doRequest("POST", url, headers, body);
}
__name(postPreferences, "postPreferences");
async function putPreferences(preferenceType, layer, layerId, body, idToUpdate) {
  const url = `/objects/${preferenceType}/${idToUpdate}`;
  const headers = getHeadersAtLayer("PUT", layer, layerId);
  return doRequest("PUT", url, headers, body);
}
__name(putPreferences, "putPreferences");
async function getRecentPreferences(preferenceType, layerType, layerId, filter = DEFAULT_FILTER) {
  return getPreferencesInternal(preferenceType, layerType, layerId, filter);
}
__name(getRecentPreferences, "getRecentPreferences");

// src/modules/preferences/genericPreferences/genericPreferences.ts
async function getGenericPreferences(preferencesType, layerId, layerType, filter = DEFAULT_FILTER) {
  try {
    return (await getRecentPreferences(preferencesType, layerType, layerId, filter)).items;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
__name(getGenericPreferences, "getGenericPreferences");
async function setGenericPreferences(preferencesType, layerId, newPreferencesToUpdate) {
  try {
    const { layerType: layerTypeOfRecordToBeUpdated, id } = newPreferencesToUpdate;
    if (id) {
      return await putPreferences(
        preferencesType,
        layerTypeOfRecordToBeUpdated,
        layerId,
        JSON.stringify(newPreferencesToUpdate.data),
        id
      );
    }
    return await postPreferences(
      preferencesType,
      "LOCALUSER" /* LOCALUSER */,
      layerId,
      JSON.stringify(newPreferencesToUpdate.data)
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
}
__name(setGenericPreferences, "setGenericPreferences");

// src/modules/preferences/timerangePresets/timerangePresetsPreferences.ts
var PREFERENCES_TYPE = `${SOLUTION_NAME}:${"timerangePresets" /* timerangePresets */}`;

// src/modules/preferences/timerangeRecents/timerangeRecentsPreferences.ts
var PREFERENCES_TYPE2 = `${SOLUTION_NAME}:${"timerangeRecents" /* timerangeRecents */}`;
async function getTimerangeRecents(layerId, layerType, filter = DEFAULT_FILTER) {
  return getGenericPreferences(PREFERENCES_TYPE2, layerId, layerType, filter);
}
__name(getTimerangeRecents, "getTimerangeRecents");
async function setTimerangeRecents(layerId, newTimeRangeItem) {
  return setGenericPreferences(PREFERENCES_TYPE2, layerId, newTimeRangeItem);
}
__name(setTimerangeRecents, "setTimerangeRecents");

// src/modules/preferences/preferences/preferences.ts
var PREFERENCES_TYPE3 = `${SOLUTION_NAME}:${"preferences" /* preferences */}`;
async function getSolutionDefaultsPreferences(filter = DEFAULT_FILTER) {
  return getGenericPreferences(PREFERENCES_TYPE3, SOLUTION_NAME, "SOLUTION" /* SOLUTION */, filter);
}
__name(getSolutionDefaultsPreferences, "getSolutionDefaultsPreferences");
async function getPreferences(layerId, layerType, filter = DEFAULT_FILTER) {
  return getGenericPreferences(PREFERENCES_TYPE3, layerId, layerType, filter);
}
__name(getPreferences, "getPreferences");
async function setPreferences(layerId, newPreferences) {
  return setGenericPreferences(PREFERENCES_TYPE3, layerId, newPreferences);
}
__name(setPreferences, "setPreferences");
function usePreferences(layerId, layerType) {
  const getSolutionDefaultsPreferencesInternal = /* @__PURE__ */ __name(async (filter = DEFAULT_FILTER) => getSolutionDefaultsPreferences(filter), "getSolutionDefaultsPreferencesInternal");
  const getPreferencesInternal2 = /* @__PURE__ */ __name(async (filter = DEFAULT_FILTER) => getPreferences(layerId, layerType, filter), "getPreferencesInternal");
  const setPreferencesInternal = /* @__PURE__ */ __name(async (newPreferencesToUpdate) => setPreferences(layerId, newPreferencesToUpdate), "setPreferencesInternal");
  return {
    getSolutionDefaultsPreferences: getSolutionDefaultsPreferencesInternal,
    getPreferences: getPreferencesInternal2,
    setPreferences: setPreferencesInternal
  };
}
__name(usePreferences, "usePreferences");

// src/modules/preferences/shellPreferences/shellPreferences.ts
var PREFERENCES_TYPE4 = `${SOLUTION_NAME}:${"shellPreferences" /* shellPreferences */}`;
async function getSolutionDefaultsShellPreferences(filter = DEFAULT_FILTER) {
  return getGenericPreferences(PREFERENCES_TYPE4, SOLUTION_NAME, "SOLUTION" /* SOLUTION */, filter);
}
__name(getSolutionDefaultsShellPreferences, "getSolutionDefaultsShellPreferences");
async function getShellPreferences(layerId, layerType, filter = DEFAULT_FILTER) {
  return getGenericPreferences(PREFERENCES_TYPE4, layerId, layerType, filter);
}
__name(getShellPreferences, "getShellPreferences");
async function setShellPreferences(layerId, newPreferences) {
  return setGenericPreferences(PREFERENCES_TYPE4, layerId, newPreferences);
}
__name(setShellPreferences, "setShellPreferences");
function useShellPreferences(layerId, layerType) {
  const getSolutionDefaultsPreferencesInternal = /* @__PURE__ */ __name(async (filter = DEFAULT_FILTER) => getSolutionDefaultsShellPreferences(filter), "getSolutionDefaultsPreferencesInternal");
  const getPreferencesInternal2 = /* @__PURE__ */ __name(async (filter = DEFAULT_FILTER) => getShellPreferences(layerId, layerType, filter), "getPreferencesInternal");
  const setPreferencesInternal = /* @__PURE__ */ __name(async (newPreferencesToUpdate) => setShellPreferences(layerId, newPreferencesToUpdate), "setPreferencesInternal");
  return {
    getSolutionDefaultsShellPreferences: getSolutionDefaultsPreferencesInternal,
    getShellPreferences: getPreferencesInternal2,
    setShellPreferences: setPreferencesInternal
  };
}
__name(useShellPreferences, "useShellPreferences");

// src/modules/container/container/ShellContainerProvider.tsx
var import_react_router_dom = require("react-router-dom");
var import_uik24 = require("@appd/uik");
var import_react18 = require("react");

// src/modules/telemetry/telemetry/services/TrackingService.ts
var import_merge = __toESM(require("lodash/merge"));

// src/modules/telemetry/utils.ts
var globalWindowWithSmartlook = globalThis;

// src/modules/telemetry/telemetry/services/TrackingService.ts
var TrackingService = class {
  /**
   * When set to true, this will allow tracking events to be sent to the server.
   * When false, this will make tracking events a no-op.
   */
  static setEnabled(value) {
    this.enabled = value;
  }
  static getEnabled() {
    return this.enabled;
  }
  /**
   * Timestamp for the session.
   * @param value - the unix timestamp (in ms)
   */
  static setSessionId(value) {
    this.sessionId = value;
  }
  static getSessionId() {
    return this.sessionId;
  }
  /**
   * This method sets the default properties for all events sent through the tracking service.
   * Examples:  `{ tenant_id: 123456 }`
   * @param properties - properties that correspond to the event schema,
   * that are common across events.   One time properties should not
   * be set here.   For example don't set route or URL since they change from event to event.
   */
  static setDefaultEventProperties(properties) {
    this.defaultEventProperties = properties;
  }
  static getDefaultEventProperties() {
    return this.defaultEventProperties;
  }
  /**
   * Called to identify the current user.
   * This method should be called when logging in or when updating user traits in the Admin screen.
   * These traits are merged with the default tracking properties to create more ways of grouping users.
   * @param userId - unique identifier for this user.
   * @param traits - arbitrary object that represents traits for a
   * @returns a promise which resolves when the operation has successfully completed
   * @deprecated
   */
  static identify(userId, traits) {
    return new Promise((resolve) => {
      if (this.enabled) {
        const mergedMap = (0, import_merge.default)({}, this.defaultEventProperties, traits);
        if (typeof analytics !== "undefined") {
          analytics.identify(userId, mergedMap, this.getSegmentOptions(), () => {
            resolve();
          });
        }
      } else {
        resolve();
      }
    });
  }
  /**
   * Called to identify a full route transition in the app.
   * This should be called *after* the route changes.  URL tracking is done internally.
   * @param options - the current options for the page transition.
   * the properties should reflect the new page being visited.
   * @returns a promise which resolves when the operation has successfully completed
   * @deprecated
   */
  static page(options) {
    return new Promise((resolve) => {
      if (this.enabled) {
        const mergedMap = (0, import_merge.default)({}, this.defaultEventProperties, options);
        if (typeof analytics !== "undefined") {
          analytics.page(options.page, mergedMap, this.getSegmentOptions(), () => {
            resolve();
          });
        }
      } else {
        resolve();
      }
    });
  }
  /**
   * Sets the current users groups. Groups need to have unique id.
   * This trait object can hold any of the properties defined on the
   * the tracking event properties interface to enable more in depth grouping.
   * @param options - The options that define the group.
   * @returns a promise which resolves when the operation has successfully completed
   */
  static group(options) {
    return new Promise((resolve) => {
      if (this.enabled) {
        if (typeof analytics !== "undefined") {
          analytics.group(options.id, options, this.getSegmentOptions(), () => {
            resolve();
          });
        }
      } else {
        resolve();
      }
    });
  }
  /**
   * Associate two existing user ids to the same person.
   * @param userId - The current user's id.
   * @param previousId - The id the user has also been associated with in the past.
   * @returns a promise which resolves when the operation has successfully completed
   */
  static alias(userId, previousId) {
    return new Promise((resolve) => {
      if (this.enabled) {
        if (typeof analytics !== "undefined") {
          analytics.alias(userId, previousId, this.getSegmentOptions(), () => {
            resolve();
          });
        }
      } else {
        resolve();
      }
    });
  }
  /**
   * Called to send a new tracking event to the tracking service.
   * @param options - any properties that provide context for the event.
   *  This is automatically merged with the default properties.
   * @returns A promise which is resolved upon success, or rejected
   * if default tracking properties aren't set via the setDefaultEventProperties() call.
   */
  static sendEvent(options) {
    return new Promise((resolve, reject) => {
      if (globalWindowWithSmartlook?.smartlook) {
        const { event, ...payload } = options;
        globalWindowWithSmartlook?.smartlook("track", event, payload.properties);
        resolve();
        return;
      }
      if (this.enabled) {
        if (!this.defaultEventProperties) {
          reject(new Error("Default tracking properties not set.  Use setDefaultEventProperties() to set them."));
        }
        const mergedMap = (0, import_merge.default)({}, this.defaultEventProperties, options);
        const { event, ...newMergedMap } = mergedMap;
        if (typeof analytics !== "undefined") {
          analytics.track(event, newMergedMap, this.getSegmentOptions(), () => {
            resolve();
          });
        }
      } else {
        resolve();
      }
    });
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  static getSegmentOptions() {
    return {
      integrations: {
        Amplitude: {
          session_id: this.getSessionId()
        }
      }
    };
  }
};
__name(TrackingService, "TrackingService");
__publicField(TrackingService, "defaultEventProperties");
__publicField(TrackingService, "enabled", false);
__publicField(TrackingService, "sessionId");

// src/modules/telemetry/hooks/useTelemetryInitialization.ts
var import_react12 = require("react");

// src/modules/telemetry/hooks/useUserInfo.ts
var import_react11 = require("react");

// src/modules/container/components/context/IsAdminContext.tsx
var import_react13 = __toESM(require("react"));
var IsAdminContext = import_react13.default.createContext({
  isAdmin: false,
  // eslint-disable-next-line unused-imports/no-unused-vars
  setIsAdmin: (value) => {
  },
  // eslint-disable-next-line unused-imports/no-unused-vars
  selectAppByName: (name) => {
  }
});

// src/modules/container/orion/headerGenerator.ts
function getHeadersAtLayer2(method) {
  const headers = /* @__PURE__ */ new Map([
    ["Content-Type", "application/json"],
    ["Accept", "application/".concat(method === "PATCH" ? "merge-patch+" : "").concat("json")]
  ]);
  return headers;
}
__name(getHeadersAtLayer2, "getHeadersAtLayer");

// src/modules/container/orion/orionService.ts
async function doRequest2(method, urlprefix, headersMap, baseUrl2 = "/session/api/ext/objstore/v1beta", body) {
  const requestURL = baseUrl2.concat(urlprefix);
  try {
    const response = await shellFetch(requestURL, {
      method,
      headers: {
        ...Object.fromEntries(headersMap)
      },
      body
    });
    if (!response.ok && !(response.status === 303 && method === "PUT")) {
      throw new Error(`${method} Request error: ${response.statusText}`);
    }
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    }
    return await response.text();
  } catch (error) {
    console.error(error);
    throw error;
  }
}
__name(doRequest2, "doRequest");
async function getAppSwitcherInternal(tenantId) {
  const url = "/objects/uishell:appSwitcher";
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2("GET", url, headers);
}
__name(getAppSwitcherInternal, "getAppSwitcherInternal");
async function getNavItemsInternal(tenantId, filter = "") {
  let url = "/objects/uishell:navItems";
  if (filter !== "") {
    url = url.concat(`?filter=${filter}`);
  }
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2("GET", url, headers);
}
__name(getNavItemsInternal, "getNavItemsInternal");
async function getHelpCenterItems(tenantId, filter = "") {
  let url = "/objects/uishell:helpCenterItems";
  if (filter !== "") {
    url = url.concat(`?filter=${filter}`);
  }
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2("GET", url, headers);
}
__name(getHelpCenterItems, "getHelpCenterItems");
async function getProductTour(tenantId, filter = "") {
  let url = "/objects/uishell:productTour";
  if (filter !== "") {
    url = url.concat(`?filter=${filter}`);
  }
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2("GET", url, headers);
}
__name(getProductTour, "getProductTour");
async function getSolutionVersion(tenantId, filter = "") {
  let url = "/objects/extensibility:solutionInstall";
  if (filter !== "") {
    url = url.concat(`?order=desc&filter=${filter}`);
  }
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2(
    "GET",
    url,
    headers,
    "/session/api/ext/knowledge-store/v1"
  );
}
__name(getSolutionVersion, "getSolutionVersion");
async function getSolutionSubscription(tenantId, solutionName = "") {
  if (!solutionName) {
    throw new Error("solutionName is required for getting the solution subscription.");
  }
  const url = `/objects/extensibility:solution/${solutionName}?fields=data`;
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", "TENANT");
  headers.set("Layer-Id", tenantId);
  return doRequest2(
    "GET",
    url,
    headers,
    "/session/api/ext/knowledge-store/v1"
  );
}
__name(getSolutionSubscription, "getSolutionSubscription");
async function getRecentlyVisitedItem(objectType, layerId, layer, filter = "") {
  let url = `/objects/${objectType}`;
  if (filter !== "") {
    url = url.concat(`?filter=${filter}`);
  }
  const headers = getHeadersAtLayer2("GET");
  headers.set("Layer-Type", layer);
  headers.set("Layer-Id", layerId);
  return doRequest2("GET", url, headers);
}
__name(getRecentlyVisitedItem, "getRecentlyVisitedItem");
async function putRecentlyVisitedItem(objectType, layerId, layer, body, idToUpdate) {
  const url = `/objects/${objectType}/${idToUpdate}`;
  const headers = getHeadersAtLayer2("PUT");
  headers.set("Layer-Type", layer);
  headers.set("Layer-Id", layerId);
  return doRequest2("PUT", url, headers, void 0, body);
}
__name(putRecentlyVisitedItem, "putRecentlyVisitedItem");
async function postRecentlyVisitedItem(objectType, layerId, layer, body) {
  const url = `/objects/${objectType}`;
  const headers = getHeadersAtLayer2("POST");
  headers.set("Layer-Type", layer);
  headers.set("Layer-Id", layerId);
  return doRequest2("POST", url, headers, void 0, body);
}
__name(postRecentlyVisitedItem, "postRecentlyVisitedItem");

// src/modules/container/container/utils/container.util.ts
var getDefaultTheme = /* @__PURE__ */ __name((isLightTheme) => {
  const LIGHT_THEME2 = "light";
  const DARK_THEME = "dark";
  return isLightTheme ? LIGHT_THEME2 : DARK_THEME;
}, "getDefaultTheme");
var fetchAppswitcher = /* @__PURE__ */ __name(async (tenantId) => {
  try {
    const allAppSwitcher = await getAppSwitcherInternal(tenantId);
    const itemData = [];
    let selectedAppItem;
    let defaultAppItem;
    allAppSwitcher.items.forEach((item) => {
      item.data.name = item.layerId;
      if (item.layerId === CONSTANTS.PLATFORM_APP_LAYERID) {
        itemData.splice(0, 0, item.data);
      } else {
        itemData.push(item.data);
      }
      if (getApplicationNameFromUrl() === item.layerId) {
        selectedAppItem = item;
      }
      if (item.layerId === CONSTANTS.DEFAULT_APP_NAME) {
        defaultAppItem = item;
      }
    });
    return {
      selectedAppItem,
      defaultAppItem,
      appSwitcherConfig: {
        name: "appSwitcher",
        visible: true,
        props: {
          apps: itemData
        }
      }
    };
  } catch (e) {
    return {};
  }
}, "fetchAppswitcher");
var fetchAllPreferences = /* @__PURE__ */ __name(async (applicationName, getPreferences2, getShellPreferences2, isLightTheme) => {
  const allPreferences = await getPreferences2(`data.appName eq "${CONSTANTS.SHELL_APP}"`);
  const allShellPreferences = await getShellPreferences2(
    `data.appName eq "${applicationName !== void 0 && applicationName !== "" ? applicationName : CONSTANTS.DEFAULT_APP_NAME}"`
  );
  const shellApp = await getShellPreferences2(`data.appName eq "${CONSTANTS.SHELL_APP}"`);
  const shellAppUserPref = filterPreferencesByLayerType(shellApp, "LOCALUSER" /* LOCALUSER */);
  const defaultTheme = getDefaultTheme(isLightTheme);
  const filterShellAppPreferences = filterPreferencesByLayerType(shellApp, "LOCALUSER" /* LOCALUSER */) ?? filterPreferencesByLayerType(shellApp, "SOLUTION" /* SOLUTION */);
  const filterPreference = filterPreferencesByLayerType(allPreferences, "LOCALUSER" /* LOCALUSER */) ?? filterPreferencesByLayerType(allPreferences, "SOLUTION" /* SOLUTION */);
  const filteredShellPreferences = filterPreferencesByLayerType(allShellPreferences, "LOCALUSER" /* LOCALUSER */) ?? filterPreferencesByLayerType(allShellPreferences, "SOLUTION" /* SOLUTION */);
  let currentTheme;
  let theme;
  let selectedAppTheme;
  if (isShellPreferencesData(shellAppUserPref?.data)) {
    const preferencesTheme = shellAppUserPref?.data.shellPreferences.theme;
    const fetchedTheme = preferencesTheme !== void 0 && preferencesTheme !== "" ? preferencesTheme : defaultTheme;
    currentTheme = fetchedTheme;
    theme = fetchedTheme;
    selectedAppTheme = fetchedTheme;
  } else if (isShellPreferencesData(filteredShellPreferences?.data)) {
    const preferencesTheme = filteredShellPreferences?.data.shellPreferences.theme;
    const fetchedTheme = preferencesTheme !== void 0 && preferencesTheme !== "" ? preferencesTheme : defaultTheme;
    currentTheme = fetchedTheme;
    theme = fetchedTheme;
    selectedAppTheme = fetchedTheme;
  } else {
    currentTheme = defaultTheme;
    theme = defaultTheme;
    selectedAppTheme = defaultTheme;
  }
  return {
    shellAppPreferences: filterShellAppPreferences ?? void 0,
    shellPreferences: filteredShellPreferences ?? void 0,
    preferences: filterPreference ?? {},
    currentTheme,
    theme,
    selectedAppTheme
  };
}, "fetchAllPreferences");

// src/modules/telemetry/smartlook/useSmartlookInitializer.ts
var import_react14 = require("react");
var TELEMETRY_SOURCE = "FSOUI";
var useSmartlookInitializer = /* @__PURE__ */ __name((initConfig, flagsStoreKey) => {
  const { tenantId } = initConfig;
  const smartlookKey = initConfig.integrations?.smartlookKey;
  const isTrackingEnabled = !!getFlagValue(flagsStoreKey, "TELEMETRY_ENABLED");
  const isLocalHost = isLocal();
  const smartlookObj = globalWindowWithSmartlook.smartlook;
  const [isSmartlookInitialized, setIsSmartlookInitialized] = (0, import_react14.useState)(false);
  const addSmartLookScript = (0, import_react14.useCallback)(() => {
    if (!smartlookKey) {
      return;
    }
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.id = "smartlook_script";
    script.innerHTML = `
      window.smartlook||(function(d) {
        var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
        var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
        c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
        })(document);
        smartlook('init', '${smartlookKey}', { region: 'eu', persistentGlobalEventProperties: true, additionalPageParams: true });
      `;
    head?.appendChild(script);
  }, [smartlookKey]);
  const initializeSmartlook = (0, import_react14.useCallback)(
    (smartlook) => {
      const generalProperties = {
        tenantId,
        environment: process.env.NODE_ENV,
        event_source: TELEMETRY_SOURCE
      };
      smartlook("properties", generalProperties);
      smartlook("record", { numbers: true });
      setIsSmartlookInitialized(true);
    },
    [tenantId]
  );
  (0, import_react14.useEffect)(() => {
    if (!isTrackingEnabled || !smartlookKey || !tenantId || isLocalHost) {
      return;
    }
    if (!smartlookObj) {
      addSmartLookScript();
      return;
    }
    if (!isSmartlookInitialized) {
      initializeSmartlook(smartlookObj);
    }
  }, [
    smartlookObj,
    smartlookKey,
    tenantId,
    isLocalHost,
    isSmartlookInitialized,
    initializeSmartlook,
    isTrackingEnabled,
    addSmartLookScript
  ]);
  return isSmartlookInitialized;
}, "useSmartlookInitializer");

// src/modules/brum/useBrumInitializer.ts
var import_react15 = require("react");
var useBrumInitializer = /* @__PURE__ */ __name((initConfig) => {
  const { tenantId } = initConfig;
  const brumAppName = initConfig.integrations?.brumAppName;
  const isLocalHost = isLocal();
  const [isBrumLoaded, setIsBrumLoaded] = (0, import_react15.useState)(false);
  const addBrumScript = (0, import_react15.useCallback)(() => {
    if (!brumAppName) {
      return;
    }
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.id = "brum_script";
    script.innerHTML = `
    window.adrum||(function(d) {
      var o=adrum=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
      var c=d.createElement('script');o.api=[];c.async=true;c.type='text/javascript';
      c.crossOrigin='anonymous';c.src='https://cdn.appdynamics.com/adrum-otel/latest/adrum.js';h.appendChild(c);
    })(document);
    adrum('init', {
      appName: '${brumAppName}',
      url: 'https://snoopy.observe.appdynamics.com'
    });
      `;
    head?.appendChild(script);
    setIsBrumLoaded(true);
  }, [brumAppName]);
  (0, import_react15.useEffect)(() => {
    if (!brumAppName || !tenantId || isLocalHost) {
      console.log("Skipping Initalization for Brum");
      return;
    }
    if (!isBrumLoaded) {
      addBrumScript();
    }
  }, [tenantId, brumAppName, addBrumScript, isLocalHost, setIsBrumLoaded, isBrumLoaded]);
  return isBrumLoaded;
}, "useBrumInitializer");

// src/modules/container/components/pageHeader/PageHeaderContext.tsx
var import_react16 = require("react");
var PageHeaderContext = (0, import_react16.createContext)({
  pageTitle: void 0,
  // eslint-disable-next-line unused-imports/no-unused-vars
  setPageTitle: (_newPageTitle) => {
  },
  breadcrumbItems: [],
  // eslint-disable-next-line unused-imports/no-unused-vars
  setBreadcrumbItems: (_items) => {
  },
  pageName: "",
  // eslint-disable-next-line unused-imports/no-unused-vars
  setPageName: (_newPageName) => {
  },
  pageNavGroupId: "",
  // eslint-disable-next-line unused-imports/no-unused-vars
  setPageNavGroupId: (_groupId) => {
  },
  pagePathname: "",
  pageParams: "",
  actionComponents: void 0,
  // eslint-disable-next-line unused-imports/no-unused-vars
  setActionComponents: (_components) => {
  }
});

// src/modules/container/components/timeRangeV2/TimeRangeContext.tsx
var import_react17 = require("react");
var TimeRangeContext = (0, import_react17.createContext)({
  timeRange: {
    input: { since: "-PT1H" },
    now: (/* @__PURE__ */ new Date()).toISOString()
  },
  setTimeRange: () => {
  },
  timeRangeEventSource: void 0,
  setTimeRangeEventSource: () => {
  },
  shellPreferences: void 0
});

// src/modules/container/container/ShellContainerProvider.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
var ShellContainerContext = (0, import_react18.createContext)({
  appName: "",
  appTitle: "",
  site: "",
  shellPreferences: void 0,
  shellAppPreferences: void 0,
  preferences: void 0,
  theme: "light",
  appSwitcher: void 0,
  tenantId: "",
  flagsStoreKey: "",
  initConfig: {}
});
var usePrevious = /* @__PURE__ */ __name((value) => {
  const ref = (0, import_react18.useRef)();
  (0, import_react18.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}, "usePrevious");
var useHasChanged = /* @__PURE__ */ __name((val) => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
}, "useHasChanged");
function ShellContainerProvider({
  configAppName,
  flagsStoreKey,
  tenantId,
  children,
  setShellInitialized,
  initConfig
}) {
  const location = (0, import_react_router_dom.useLocation)();
  useSmartlookInitializer(initConfig, flagsStoreKey ?? CONSTANTS.SHELL_FLAGS_STORE_KEY);
  useBrumInitializer(initConfig);
  const [isAdmin, setIsAdmin] = (0, import_react18.useState)(false);
  const { setCurrentTheme } = (0, import_react18.useContext)(import_uik24.css.CONTEXT);
  const isLightTheme = flagsStoreKey ? getFlagValue(flagsStoreKey, "LIGHT_THEME") : false;
  const [theme, setTheme] = (0, import_react18.useState)(getDefaultTheme(isLightTheme));
  const [shellPreferences, setShellPreferences2] = (0, import_react18.useState)();
  const [shellAppPreferences, setShellAppPreferences] = (0, import_react18.useState)();
  const [preferences, setPreferences2] = (0, import_react18.useState)();
  const [appName2, setAppName2] = (0, import_react18.useState)(configAppName);
  const [appTitle, setAppTitle] = (0, import_react18.useState)("");
  const [site, setSite] = (0, import_react18.useState)("");
  const [pageTitle, setPageTitle] = (0, import_react18.useState)(void 0);
  const [actionComponents, setActionComponents] = (0, import_react18.useState)(void 0);
  const [pageName, setPageName] = (0, import_react18.useState)("");
  const [pageNavGroupId, setPageNavGroupId] = (0, import_react18.useState)("");
  const [breadcrumbItems, setBreadcrumbItems] = (0, import_react18.useState)([]);
  const [timeRange2, setTimeRange] = (0, import_react18.useState)({
    input: { since: "-PT1H" },
    now: (/* @__PURE__ */ new Date()).toISOString()
  });
  const [timeRangeEventSource, setTimeRangeEventSource] = (0, import_react18.useState)();
  const { getShellPreferences: getShellPreferences2 } = useShellPreferences(
    `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
    "LOCALUSER" /* LOCALUSER */
  );
  const { getPreferences: getPreferences2 } = usePreferences(
    `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
    "LOCALUSER" /* LOCALUSER */
  );
  const [appSwitcher, setAppSwitcher] = (0, import_react18.useState)();
  const [pagePathname, setPagePathname] = (0, import_react18.useState)("");
  const [pageParams, setPageParams] = (0, import_react18.useState)("");
  const hasParamsChanged = useHasChanged(window.location.search);
  const hasPathnameChanged = useHasChanged(window.location.pathname);
  const getAllPreferences = /* @__PURE__ */ __name(async (applicationName) => {
    const preferencesObj = await fetchAllPreferences(
      applicationName,
      getPreferences2,
      getShellPreferences2,
      isLightTheme
    );
    setShellAppPreferences(preferencesObj.shellAppPreferences);
    setShellPreferences2(preferencesObj.shellPreferences);
    setPreferences2(preferencesObj.preferences);
    setCurrentTheme(preferencesObj.currentTheme);
    setTheme(preferencesObj.theme);
    setSelectedAppTheme(preferencesObj.selectedAppTheme);
  }, "getAllPreferences");
  const selectApp = /* @__PURE__ */ __name((item) => {
    setAppName2(item.layerId);
    setAppName(item.layerId);
    setSite(item.data.homePageUri.site);
    getAllPreferences(item.layerId).catch(reportError);
    setAppTitle(item.data.title);
    setSelectedApplication(item, tenantId);
  }, "selectApp");
  const selectAppByName = (0, import_react18.useCallback)(
    (name) => {
      if (appSwitcher === void 0 || appSwitcher.props === void 0) {
        return;
      }
      appSwitcher.props.apps.forEach((data) => {
        if (data.name === name) {
          selectApp({
            layerId: data.name,
            data
          });
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appSwitcher]
  );
  const getAppSwitcher = /* @__PURE__ */ __name(async () => {
    const appSwitcherObj = await fetchAppswitcher(tenantId);
    if (appSwitcherObj.selectedAppItem !== void 0) {
      selectApp(appSwitcherObj.selectedAppItem);
    } else if (appSwitcherObj.defaultAppItem !== void 0) {
      selectApp(appSwitcherObj.defaultAppItem);
    }
    if (appSwitcherObj.appSwitcherConfig) {
      setAppSwitcher(appSwitcherObj.appSwitcherConfig);
    }
  }, "getAppSwitcher");
  (0, import_react18.useEffect)(() => {
    if (hasPathnameChanged) {
      setPagePathname(window.location.pathname);
    }
    if (hasParamsChanged) {
      setPageParams(window.location.search);
    }
  }, [hasParamsChanged, hasPathnameChanged]);
  (0, import_react18.useEffect)(() => {
    if (tenantId) {
      getAppSwitcher().catch(reportError);
    }
  }, [tenantId]);
  (0, import_react18.useEffect)(() => {
    if (appName2) {
      const telemetryProperties = {
        event: "COP Page Visited",
        properties: {
          page: location.pathname,
          applicationName: appName2,
          url: window.location.href
        }
      };
      TrackingService.sendEvent(telemetryProperties).catch((error) => console.error(error));
    }
  }, [location, appName2]);
  (0, import_react18.useEffect)(() => {
    if (appSwitcher) {
      setShellInitialized(true);
    }
    const layout = window.document.getElementById("fso-layout");
    if (layout) {
      layout.style.display = "none";
    }
  }, [appSwitcher, setShellInitialized]);
  const pageHeaderValue = (0, import_react18.useMemo)(
    () => ({
      pageTitle,
      setPageTitle,
      actionComponents,
      setActionComponents,
      breadcrumbItems,
      setBreadcrumbItems,
      pageName,
      setPageName,
      pageNavGroupId,
      setPageNavGroupId,
      pagePathname,
      pageParams
    }),
    [actionComponents, breadcrumbItems, pageName, pageNavGroupId, pageParams, pagePathname, pageTitle]
  );
  const timeRangeContextValue = (0, import_react18.useMemo)(() => {
    const { shellPreferences: initConfigShellPreferences } = initConfig;
    let shellAppShellPreferences;
    let appSolutionShellPreferences;
    if (initConfigShellPreferences) {
      const AppShellPreferences = initConfigShellPreferences.items.filter(
        (eachItem) => eachItem.data.appName === appName2
      );
      appSolutionShellPreferences = filterPreferencesByLayerType(AppShellPreferences, "SOLUTION" /* SOLUTION */);
      shellAppShellPreferences = filterPreferencesByLayerType(
        initConfigShellPreferences.items.filter((eachItem) => eachItem.data.appName === CONSTANTS.SHELL_APP),
        "LOCALUSER" /* LOCALUSER */
      );
    }
    return {
      timeRange: timeRange2,
      setTimeRange,
      timeRangeEventSource,
      setTimeRangeEventSource,
      shellPreferences: shellAppShellPreferences ?? appSolutionShellPreferences
    };
  }, [appName2, initConfig, timeRange2, timeRangeEventSource]);
  const isAdminValue = (0, import_react18.useMemo)(
    () => ({ isAdmin, setIsAdmin, selectAppByName }),
    [isAdmin, setIsAdmin, selectAppByName]
  );
  const value = (0, import_react18.useMemo)(
    () => ({
      appName: appName2,
      appTitle,
      site,
      shellPreferences,
      shellAppPreferences,
      preferences,
      theme,
      appSwitcher,
      tenantId,
      flagsStoreKey: flagsStoreKey || "",
      initConfig
    }),
    [
      appName2,
      appTitle,
      site,
      shellPreferences,
      shellAppPreferences,
      preferences,
      theme,
      appSwitcher,
      tenantId,
      flagsStoreKey,
      initConfig
    ]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(ShellContainerContext.Provider, { value, children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(IsAdminContext.Provider, { value: isAdminValue, children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(PageHeaderContext.Provider, { value: pageHeaderValue, children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(TimeRangeContext.Provider, { value: timeRangeContextValue, children }) }) }) });
}
__name(ShellContainerProvider, "ShellContainerProvider");

// src/modules/container/components/miniProfile/themeSwitcher/MESSAGES.ts
var import_uik25 = require("@appd/uik");
var MESSAGES = {
  THEME: import_uik25.format.message`Appearance`.description("Descriptor of theme switcher"),
  FAILED_TO_SAVE: import_uik25.format.message`Unable to save the appearance.`.description(
    "Error message when failed to save theme preference"
  ),
  FAILED_TO_GET: import_uik25.format.message`Unable to get the appearance.`.description(
    "Error message when failed to get theme preference"
  )
};

// src/modules/container/components/miniProfile/themeSwitcher/STYLES.ts
var import_uik26 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_IN_WEAK, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM7 },
  TYPOGRAPHY: { P4_DEFAULT: P4_DEFAULT2 },
  SPACING: SPACING13
} = import_uik26.MAGNETIC_TOKENS;
var STYLES2 = {
  LABEL: import_uik26.css.Styles({
    color: DEFAULT_TEXT_MEDIUM7,
    font: P4_DEFAULT2,
    paddingLeft: SPACING13[4],
    paddingRight: SPACING13[4]
  }),
  SWITCH: {
    marginTop: SPACING13[2],
    color: DEFAULT_TEXT_IN_WEAK
  },
  BANNER: {
    margin: SPACING13[2],
    borderRadius: SPACING13[2]
  },
  marginTop: SPACING13[2],
  marginBottom: SPACING13[2]
};

// src/modules/container/components/miniProfile/themeSwitcher/ThemeSwitcher.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
var ThemeSwitcher = /* @__PURE__ */ __name(({ onToggle }) => {
  const { theme, tenantId } = (0, import_react19.useContext)(ShellContainerContext);
  const { setCurrentTheme } = (0, import_react19.useContext)(import_uik27.css.CONTEXT);
  const [error, setError] = (0, import_react19.useState)(void 0);
  const { LABEL, SWITCH, BANNER, ...HOST2 } = STYLES2;
  const { THEME, FAILED_TO_SAVE, FAILED_TO_GET } = MESSAGES;
  const { setShellPreferences: setShellPreferences2 } = useShellPreferences(
    `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
    "LOCALUSER" /* LOCALUSER */
  );
  const { getShellPreferences: getShellPreferences2 } = useShellPreferences(
    `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
    "LOCALUSER" /* LOCALUSER */
  );
  const savePlatformAppTheme = (0, import_react19.useCallback)(
    (updatedTheme) => {
      getShellPreferences2(`data.appName eq "${CONSTANTS.SHELL_APP}"`).then((items) => {
        const platformAppPreferences = items.filter((item) => item.layerType === "LOCALUSER");
        if (platformAppPreferences && platformAppPreferences.length) {
          const platformAppPref = platformAppPreferences[0];
          const curUserPlatformAppData = {
            ...platformAppPref ?? { data: { shellPreferences: {} } }
          };
          const shellPref = curUserPlatformAppData.data;
          const updatedUserPlatformAppPreference = {
            ...curUserPlatformAppData,
            data: {
              ...curUserPlatformAppData.data,
              shellPreferences: { ...shellPref.shellPreferences, theme: updatedTheme }
            }
          };
          setShellPreferences2({
            data: updatedUserPlatformAppPreference.data,
            layerType: "LOCALUSER" /* LOCALUSER */,
            layerId: updatedUserPlatformAppPreference.layerId,
            id: updatedUserPlatformAppPreference.id
          }).catch(() => {
            setError(FAILED_TO_SAVE);
          });
        } else {
          setShellPreferences2({
            data: {
              appName: CONSTANTS.SHELL_APP,
              shellPreferences: {
                theme: updatedTheme
              }
            },
            layerType: "LOCALUSER" /* LOCALUSER */,
            layerId: `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`
          }).catch(() => {
            setError(FAILED_TO_SAVE);
          });
        }
      }).catch(() => {
        setError(FAILED_TO_GET);
      });
    },
    [FAILED_TO_SAVE, FAILED_TO_GET, getShellPreferences2, tenantId, setError, setShellPreferences2]
  );
  const onThemeChange = /* @__PURE__ */ __name((updatedTheme) => {
    setError(void 0);
    savePlatformAppTheme(updatedTheme);
    setCurrentTheme(updatedTheme);
    if (onToggle) {
      ShellEvent.emit(onToggle, updatedTheme);
    }
  }, "onThemeChange");
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)("div", { className: (0, import_uik27.css)(HOST2), children: [
    /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("span", { className: (0, import_uik27.css)(LABEL), children: THEME() }),
    error && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(import_uik27.Banner, { className: (0, import_uik27.css)(BANNER), type: "ERROR", "data-testid": "error-banner", children: error }),
    /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("div", { className: (0, import_uik27.css)(SWITCH), children: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(import_uik27.ThemeSwitch, { theme, onThemeChange }) })
  ] });
}, "ThemeSwitcher");

// src/modules/container/components/miniProfile/Notification/Notification.tsx
var import_uik28 = require("@appd/uik");
var import_react20 = require("react");
var import_jsx_runtime26 = require("react/jsx-runtime");
var { SPACING: SPACING14 } = import_uik28.MAGNETIC_TOKENS;
var inputStyle = {
  marginBlock: SPACING14[5]
};
var contentStyle = {
  padding: "0 24px"
};
var { LINK_GROUP: LINK_GROUP3 } = getStyles();
var SeverityOption = [
  { label: "INFO", value: "info" },
  { label: "ERROR", value: "error" },
  { label: "WARNING", value: "warning" },
  { label: "CRITICAL", value: "critical" }
];
var Notification = /* @__PURE__ */ __name(() => {
  const [open, setOpen] = (0, import_react20.useState)(false);
  const [notification, setNotification] = (0, import_react20.useState)();
  const [title, setTitle] = (0, import_react20.useState)("");
  const [message, setMessage] = (0, import_react20.useState)("");
  const [displayBanner, setDisplayBanner] = (0, import_react20.useState)(true);
  const [severity, setSeverity] = (0, import_react20.useState)("");
  const fetchNotification = /* @__PURE__ */ __name(async () => {
    try {
      const response = await shellFetch("/session/api/ext/ui/api/dashui/system/notifications", {
        headers: {
          Accept: "application/json"
        }
      });
      const notifications = await response.json();
      const newNotification = notifications.items.length > 0 && notifications.items[0].data ? notifications.items[0].data : void 0;
      if (newNotification !== void 0) {
        setNotification(newNotification);
        setTitle(newNotification.title);
        setMessage(newNotification.message);
        setDisplayBanner(newNotification.displayBanner);
        setSeverity(newNotification.severity);
      }
    } catch (e) {
    }
  }, "fetchNotification");
  (0, import_react20.useEffect)(() => {
    if (open) {
      fetchNotification();
    }
  }, [open]);
  const onCloseHandler = /* @__PURE__ */ __name(async (kind) => {
    if (kind === "ACTION" && title && message && severity) {
      const body = {
        title,
        message,
        displayBanner,
        severity,
        id: generateUuid()
      };
      let toastIcon = "INFO";
      let toastTitle = "Notification submitted";
      let isSaved = true;
      if (notification && notification.id) {
        body.id = void 0;
        const response = await shellFetch(`/session/api/ext/ui/api/dashui/system/notifications/${notification.id}`, {
          method: "PATCH",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/merge-patch+json",
            Accept: "application/json"
          }
        });
        body.id = notification.id;
        if (!response.ok) {
          toastIcon = "ERROR";
          toastTitle = "Failed to modify notification";
          isSaved = false;
        }
      } else {
        const response = await shellFetch(`/session/api/ext/ui/api/dashui/system/notifications`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          toastIcon = "ERROR";
          toastTitle = "Failed to create notification";
          isSaved = false;
        }
      }
      if (isSaved) {
        setNotification(body);
      }
      (0, import_uik28.toast)({
        icon: toastIcon,
        title: toastTitle
      });
      setOpen(false);
    } else if (kind === "CANCEL") {
      setOpen(false);
    }
  }, "onCloseHandler");
  const findSelectedIndex = /* @__PURE__ */ __name(() => {
    let index = -1;
    SeverityOption.forEach((option, i) => {
      if (option.value === severity) {
        index = i;
      }
    });
    return index;
  }, "findSelectedIndex");
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("div", { className: (0, import_uik28.css)({ ...LINK_GROUP3, cursor: "pointer" }), "data-testid": "notification-title", children: [
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("div", { className: "link", "aria-hidden": "true", onClick: () => setOpen((prev) => !prev), "data-testid": "notification-link", children: "Configure Notification" }),
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
      import_uik28.Dialog,
      {
        action: "Submit",
        cancel: "Cancel",
        closeBehavior: { BACKDROP: "IGNORE" },
        onClose: onCloseHandler,
        open,
        hideClose: true,
        size: "SMALL",
        title: "Configure Notification",
        children: /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("div", { className: (0, import_uik28.css)(contentStyle), children: [
          /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            import_uik28.Input,
            {
              className: (0, import_uik28.css)(inputStyle),
              label: "Title",
              onChange: (e) => setTitle(e.target.value),
              required: true,
              value: title
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            import_uik28.Textarea,
            {
              className: (0, import_uik28.css)(inputStyle),
              onChange: (e) => setMessage(e.target.value),
              maxRows: 15,
              required: true,
              label: "Message",
              rows: 3,
              value: message
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            import_uik28.Select,
            {
              className: (0, import_uik28.css)(inputStyle),
              label: "Severity",
              required: true,
              onChange: (value) => setSeverity(SeverityOption[value[0]].value),
              value: [findSelectedIndex()],
              children: SeverityOption.map(({ label }) => /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(import_uik28.Select.Option, { children: label }, label))
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(import_uik28.Checkbox, { label: "Display Banner", checked: displayBanner, onChange: () => setDisplayBanner((prev) => !prev) })
        ] })
      }
    )
  ] });
}, "Notification");

// src/modules/container/components/separator/SeparatorComponent.tsx
var import_uik29 = require("@appd/uik");
var import_jsx_runtime27 = require("react/jsx-runtime");
var {
  COLORS: { INVERSE_TEXT: INVERSE_TEXT3 }
} = import_uik29.MAGNETIC_TOKENS;
var SeparatorComponent = /* @__PURE__ */ __name(({ style }) => /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { style: { borderLeft: `1px solid ${INVERSE_TEXT3}`, height: 24, ...style }, "data-testid": "separator" }), "SeparatorComponent");
var SeparatorComponent_default = SeparatorComponent;

// src/modules/container/components/miniProfile/MiniProfile.tsx
var import_jsx_runtime28 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_BG_WEAK: CONTROL_BG_WEAK2, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK3, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM8, INVERSE_TEXT: INVERSE_TEXT4 },
  STATIC: { HEADER_ICON: HEADER_ICON2 },
  TYPOGRAPHY: { P3_DEFAULT: P3_DEFAULT8 },
  EFFECT: { SHADOW }
} = import_uik30.MAGNETIC_TOKENS;
var STYLES3 = {
  MINI_PROFILE_BUTTON: import_uik30.css.Styles({
    backgroundColor: "transparent"
  }),
  MINI_PROFILE: {
    backgroundColor: CONTROL_BG_WEAK2,
    borderRadius: 3,
    border: "none",
    color: DEFAULT_TEXT_MEDIUM8,
    display: "flex",
    flexDirection: "column",
    font: P3_DEFAULT8,
    width: "100%",
    "> :not(:last-child)": {
      borderBottom: `1px solid ${CONTROL_BORDER_WEAK3}`
    }
  },
  MINI_PROFILE_CONTAINER: (0, import_uik30.css)({
    padding: 0,
    width: 325,
    boxShadow: SHADOW.DEFAULT,
    maxHeight: "50vh",
    overflowY: "auto"
  }),
  MINI_PROFILE_DROPDOWN_ARROW: import_uik30.css.Styles({
    '& svg[uik="Icon.Navigation.ChevronDown"]': {
      marginLeft: "12px"
    }
  }),
  MINI_PROFILE_USER_NAME: import_uik30.css.Styles({
    lineHeight: "20px",
    fontWeight: "600",
    textAlign: "center",
    maxWidth: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  })
};
var MiniProfile = /* @__PURE__ */ __name(({ onLogoutClickEvent, style }) => {
  let logoutUrl = "https://login.appdynamics.com/sso/logout/";
  let accountsLaunchUrl = "https://accounts.appdynamics.com/license-usage";
  let accountsManageProfileUrl = "https://accounts.appdynamics.com/personal-summary";
  let accountsOverviewUrl = "https://accounts.appdynamics.com/overview";
  let accountsViewAllUrl = "https://accounts.appdynamics.com/personal-summary/subscriptions";
  let cloudTenantApiUrl = "https://tenant-provision-apis.saas.appdynamics.com/levitate/v1/tenants";
  let communityUrl = "https://community.appdynamics.com";
  let helpUrl = "https://www.appdynamics.com/support";
  let identityApiUrl = CONSTANTS.IDENTITY_API_URL;
  let saasTenantApiUrl = "https://portal.appdynamics.com/api/rest/v2/licenses/search?page_size=20&page=1&deployment=saas";
  let universityUrl = "https://university.appdynamics.com";
  const [visible, setVisible] = (0, import_react21.useState)(false);
  const isLocal2 = window.location.hostname.includes("localhost");
  const isAppdTest2 = window.location.hostname.includes("appd-test.com");
  if (isLocal2 || isAppdTest2) {
    logoutUrl = "https://login-staging.saas.appd-test.com/sso/logout";
    accountsLaunchUrl = "https://accounts-staging.saas.appd-test.com/license-usage";
    accountsManageProfileUrl = "https://accounts-staging.saas.appd-test.com/personal-summary";
    accountsOverviewUrl = "https://accounts-staging.saas.appd-test.com/overview";
    accountsViewAllUrl = "https://accounts-staging.saas.appd-test.com/personal-summary/subscriptions";
    cloudTenantApiUrl = "https://levitate-apis.saas.appd-test.com/levitate/v1/tenants";
    communityUrl = "https://community-staging.appdynamics.com";
    helpUrl = "https://www.appdynamics.com/support";
    identityApiUrl = CONSTANTS.IDENTITY_API_URL_FOR_LOCAL;
    saasTenantApiUrl = "https://portal-staging.saas.appd-test.com/api/rest/v2/licenses/search?page_size=20&page=1&deployment=saas";
    universityUrl = "https://learn-staging.saas.appd-test.com";
  }
  const { isAdmin, setIsAdmin } = (0, import_react21.useContext)(IsAdminContext);
  const [isSystemAdmin, setIsSystemAdmin] = (0, import_react21.useState)(false);
  const [userDisplayName, setUserDisplayName] = (0, import_react21.useState)("");
  (0, import_react21.useEffect)(() => {
    const fetchIsSystemAdmin = /* @__PURE__ */ __name(async () => {
      try {
        const response = await shellFetch("/session/api/ext/ui/api/dashui/system/isSystemTenant", {
          headers: {
            Accept: "application/json"
          }
        });
        const flag = await response.json();
        setIsSystemAdmin(flag.is_system_tenant);
      } catch (e) {
      }
    }, "fetchIsSystemAdmin");
    fetchIsSystemAdmin();
    const fetchIdentity = /* @__PURE__ */ __name(() => {
      shellFetch(identityApiUrl, {
        credentials: "include",
        method: "GET"
      }).then((result) => {
        if (result.status === 401 && !isLocal2) {
          signOut(logoutUrl);
        } else if (result.status === 200 && !isLocal2) {
          result.json().then((userInfo) => {
            setUserDisplayName(userInfo.user.first_name);
            const value = userInfo.user.is_admin === "true";
            if (value !== isAdmin) {
              setIsAdmin(value);
            }
          }).catch(() => {
          });
        }
      }).catch((e) => {
        if (!isLocal2) {
          console.error(e);
        }
      });
    }, "fetchIdentity");
    fetchIdentity();
    if (isLocal2) {
      return () => {
      };
    }
    const intervalId = setInterval(fetchIdentity, 15e3);
    return () => clearInterval(intervalId);
  }, [identityApiUrl, isLocal2, logoutUrl]);
  const trigger = /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { className: (0, import_uik30.css)({ display: "flex", gap: 12, alignItems: "center", flexDirection: "row" }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(SeparatorComponent_default, {}),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
      import_uik30.Button,
      {
        style,
        className: (0, import_uik30.css)({
          ...STYLES3.MINI_PROFILE_BUTTON,
          ...ButtonStyles.SHELL_BUTTON_STYLES,
          ...STYLES3.MINI_PROFILE_DROPDOWN_ARROW
        }),
        icon: "Location.Eum",
        iconRight: "Navigation.ChevronDown",
        iconColor: HEADER_ICON2,
        type: "TERTIARY",
        onClick: () => setVisible(!visible),
        "data-testid": "MiniProfileTrigger",
        children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
          "div",
          {
            style: {
              fontSize: 11,
              color: INVERSE_TEXT4,
              whiteSpace: "nowrap",
              textAlign: "left",
              fontWeight: "normal",
              ...style
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("div", { className: (0, import_uik30.css)({ ...STYLES3.MINI_PROFILE_USER_NAME }), "data-testid": "userDisplayName", children: userDisplayName })
          }
        )
      }
    )
  ] });
  const content = /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { className: (0, import_uik30.css)({ ...STYLES3.MINI_PROFILE }), "data-testid": "MiniProfilePopover", children: [
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(UserInfoSection, { accountsManageProfileUrl, identityApiUrl }),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(AccountManagement, { accountsOverviewUrl }),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
      SaasTenants,
      {
        accountsLaunchUrl,
        accountsViewAllUrl,
        identityApiUrl,
        saasTenantApiUrl
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(CloudTenants, { accountsViewAllUrl, cloudTenantApiUrl }),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(Resources, { communityUrl, helpUrl, universityUrl }),
    isSystemAdmin ? /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(Notification, {}) : null,
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(ThemeSwitcher, { onToggle: "triggerThemeSwitch" }),
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(Logout, { onLogoutClickEvent, logoutUrl })
  ] });
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
    import_uik30.Popover,
    {
      arrow: false,
      content,
      contentClassName: STYLES3.MINI_PROFILE_CONTAINER,
      onVisibleChange: setVisible,
      position: "BOTTOM",
      trigger: "CLICK",
      visible,
      children: trigger
    }
  );
}, "MiniProfile");

// src/modules/container/components/shareButton/ShareButtonComponent.tsx
var import_uik31 = require("@appd/uik");
var import_future = require("@appd/uik/@future");
var import_react22 = require("react");
var import_jsx_runtime29 = require("react/jsx-runtime");
var {
  STATIC: { HEADER_ICON: HEADER_ICON3 }
} = import_uik31.MAGNETIC_TOKENS;
var SINCE_PARAM = "since";
var UNTIL_PARAM = "until";
var NOW_PARAM = "now";
var convertTimerange = /* @__PURE__ */ __name((searchParams) => {
  if (searchParams.has(SINCE_PARAM)) {
    const urlSinceTimeRange = searchParams.get(SINCE_PARAM) ?? "";
    let urlUntilTimeRange;
    let urlNowTimeRange = (/* @__PURE__ */ new Date()).toISOString();
    if (searchParams.has(UNTIL_PARAM)) {
      urlUntilTimeRange = searchParams.get(UNTIL_PARAM) ?? urlUntilTimeRange;
    }
    if (searchParams.has(NOW_PARAM)) {
      urlNowTimeRange = searchParams.get(NOW_PARAM) ?? urlNowTimeRange;
    }
    const { since: resolvedSince, until: resolvedUntil } = import_future.TimeRangeSelector.TimeRange.resolve({
      input: { since: urlSinceTimeRange, until: urlUntilTimeRange },
      now: urlNowTimeRange
    });
    searchParams.delete(SINCE_PARAM);
    if (searchParams.has(UNTIL_PARAM)) {
      searchParams.delete(UNTIL_PARAM);
    }
    if (searchParams.has(NOW_PARAM)) {
      searchParams.delete(NOW_PARAM);
    }
    searchParams.set(SINCE_PARAM, encodeURIComponent(resolvedSince));
    searchParams.set(UNTIL_PARAM, encodeURIComponent(resolvedUntil));
    return searchParams.toString();
  }
  return "";
}, "convertTimerange");
var ShareButtonComponent = /* @__PURE__ */ __name(({ url, style }) => {
  const [tooltipText, setTooltipText] = (0, import_react22.useState)("Share this Link");
  const copyContent = /* @__PURE__ */ __name(async (userUrl) => {
    try {
      const copyUrl = new URL(userUrl ?? window.location.href);
      const searchParams = new URLSearchParams(copyUrl.search);
      copyUrl.search = convertTimerange(searchParams);
      await navigator.clipboard.writeText(copyUrl.toString());
      setTooltipText("Link copied to clipboard");
    } catch (err) {
      setTooltipText("Unable to copy");
    }
  }, "copyContent");
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(import_uik31.Tooltip, { onMouseOver: () => setTooltipText("Share this Link"), value: tooltipText, children: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
    import_uik31.Button,
    {
      style,
      className: (0, import_uik31.css)(ButtonStyles.SHELL_BUTTON_STYLES),
      icon: "Action.Share",
      iconColor: HEADER_ICON3,
      type: "TERTIARY",
      onClick: () => {
        copyContent(url).catch((error) => console.log(error));
      },
      tabIndex: 0,
      "data-testid": "share"
    }
  ) });
}, "ShareButtonComponent");
var ShareButtonComponent_default = ShareButtonComponent;

// src/modules/container/components/display/DisplayComponent.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
function DisplayComponent({ component, style }) {
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("div", { style, "data-testid": "display", children: component });
}
__name(DisplayComponent, "DisplayComponent");

// src/modules/container/components/exchange/ExchangeComponent.tsx
var import_uik32 = require("@appd/uik");
var import_react23 = require("react");
var import_react_dom = __toESM(require("react-dom"));
var import_jsx_runtime31 = require("react/jsx-runtime");
var {
  STATIC: { HEADER_ICON: HEADER_ICON4 }
} = import_uik32.MAGNETIC_TOKENS;
var STYLES4 = {
  BUTTON_EXCHANGE: import_uik32.css.Styles({
    backgroundColor: "transparent"
  }),
  EXCHANGE_MODAL_ROOT: import_uik32.css.Styles({
    inset: 0,
    position: "absolute",
    width: "100%",
    animation: "fadeInFromNone 400ms cubic-bezier(0, 0, 0.2, 1)"
  }),
  EXCHANGE_MODAL: import_uik32.css.Styles({
    borderWidth: 0,
    position: "fixed",
    width: "100%",
    height: "100%"
  }),
  HEADER_CLOSE_BUTTON: import_uik32.css.Styles({
    background: "none",
    padding: 0,
    position: "absolute",
    top: "25px",
    right: "25px"
  })
};
var ExchangeModal = /* @__PURE__ */ __name((portalToggleProps) => {
  const { closed, children } = portalToggleProps;
  const portalRef = (0, import_react23.useRef)(null);
  if (closed) {
    return null;
  }
  portalRef.current = document.getElementById("fso-shell-modal-root");
  if (portalRef == null || portalRef.current == null) {
    return null;
  }
  const portalElement = /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("div", { className: (0, import_uik32.css)({ ...STYLES4.EXCHANGE_MODAL_ROOT }), children }, "exchange-modal-root");
  return import_react_dom.default.createPortal(portalElement, portalRef.current);
}, "ExchangeModal");
var sendTelemetryEvent = /* @__PURE__ */ __name((pageName) => {
  const telemetryProperties = {
    event: "Exchange",
    properties: {
      page: pageName,
      clickSection: "Exchange icon"
    }
  };
  TrackingService.sendEvent(telemetryProperties).catch((error) => console.error(error));
}, "sendTelemetryEvent");
var ExchangeComponent = /* @__PURE__ */ __name(({ pageName, style }) => {
  const [closed, setClosed] = (0, import_react23.useState)(true);
  const [appUrl, setAppUrl] = (0, import_react23.useState)("");
  const iframeSrc = appUrl !== "" ? `/exchange${appUrl}` : "/exchange";
  const onToggle = (0, import_react23.useCallback)(() => {
    setClosed(!closed);
  }, [closed]);
  const onAppClick = (0, import_react23.useCallback)(
    (url) => {
      setAppUrl(url);
      onToggle();
    },
    [onToggle]
  );
  const onIconClick = /* @__PURE__ */ __name(() => {
    sendTelemetryEvent(pageName ?? "");
    onToggle();
  }, "onIconClick");
  (0, import_react23.useEffect)(() => {
    ShellEvent.on(ShellEventTypes.EXCHANGE_ICON_CLICKED, onToggle);
    ShellEvent.on(ShellEventTypes.EXCHANGE_APP_LINK_CLICKED, onAppClick);
    return () => {
      ShellEvent.un(ShellEventTypes.EXCHANGE_ICON_CLICKED, onToggle);
      ShellEvent.un(ShellEventTypes.EXCHANGE_APP_LINK_CLICKED, onAppClick);
    };
  }, [onToggle, onAppClick]);
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(import_jsx_runtime31.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_uik32.Tooltip, { value: "Cisco Observability Platform Exchange", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
      import_uik32.Button,
      {
        style,
        className: (0, import_uik32.css)({ ...STYLES4.BUTTON_EXCHANGE, ...ButtonStyles.SHELL_BUTTON_STYLES }),
        icon: "Location.GetApplication",
        iconColor: HEADER_ICON4,
        type: "TERTIARY",
        onClick: onIconClick,
        tabIndex: 0,
        "data-testid": "exchangeToggle"
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(ExchangeModal, { closed, children: [
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        "iframe",
        {
          src: iframeSrc,
          title: "Cisco Observability Platform Exchange",
          className: (0, import_uik32.css)({ ...STYLES4.EXCHANGE_MODAL }),
          "data-testid": "exchangeContent"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
        import_uik32.Button,
        {
          className: (0, import_uik32.css)({ ...STYLES4.HEADER_CLOSE_BUTTON }),
          onClick: onToggle,
          type: "TERTIARY",
          icon: "Action.Disable"
        }
      )
    ] })
  ] });
}, "ExchangeComponent");
var ExchangeComponent_default = ExchangeComponent;

// src/modules/container/components/timeRangeV2/TimeRangeComponentV2.tsx
var import_future2 = require("@appd/uik/@future");
var import_react24 = require("react");
var import_uik34 = require("@appd/uik");

// src/modules/container/components/timeRangeV2/getStyles.ts
var import_uik33 = require("@appd/uik");
var {
  COLORS: { INVERSE_TEXT: INVERSE_TEXT5, INVERSE_TEXT_DISABLED, INVERSE_ICON_DISABLED, INVERSE_BORDER_HOVER }
} = import_uik33.MAGNETIC_TOKENS;
var getStyles2 = /* @__PURE__ */ __name(() => ({
  TIMERANGEPICKER: (0, import_uik33.css)({
    "& > button": {
      backgroundColor: "transparent",
      border: `2px solid ${INVERSE_TEXT5}`,
      color: INVERSE_TEXT5,
      "&:hover:not(:focus)": {
        borderColor: INVERSE_BORDER_HOVER
      },
      "&:disabled": {
        borderColor: INVERSE_TEXT_DISABLED,
        "&:hover:not(:focus)": {
          borderBottomColor: INVERSE_TEXT_DISABLED
        },
        color: INVERSE_TEXT_DISABLED,
        "& svg": {
          opacity: 1
        },
        "& svg path": {
          fill: INVERSE_ICON_DISABLED
        }
      }
    }
  }),
  REFRESH: (0, import_uik33.css)({
    '& div[uik="TimeRangeSelector.Refresh"]': {
      "& > div": { backgroundColor: INVERSE_TEXT5 },
      "&:hover": { "& > div": { backgroundColor: INVERSE_BORDER_HOVER } },
      "& > button:first-child": {
        borderRight: "none"
      },
      "& > button:last-child": {
        "& > div": { backgroundColor: "transparent" },
        borderLeft: "none"
      },
      "& > button": {
        backgroundColor: "transparent",
        border: `2px solid ${INVERSE_TEXT5}`,
        "&:hover": {
          borderColor: INVERSE_BORDER_HOVER
        },
        "&:disabled": {
          borderColor: INVERSE_ICON_DISABLED,
          "&:hover": {
            backgroundColor: INVERSE_ICON_DISABLED
          },
          color: INVERSE_TEXT_DISABLED,
          "& svg": {
            opacity: 1
          },
          "& svg path": {
            fill: INVERSE_ICON_DISABLED
          }
        }
      }
    }
  })
}), "getStyles");

// src/modules/container/components/timeRangeV2/DEFAULT_PRESETS.ts
var DEFAULT_PRESETS = [
  {
    since: "-PT5M",
    title: "Last 5 Minutes"
  },
  {
    since: "-PT15M",
    title: "Last 15 Minutes"
  },
  {
    since: "-PT1H",
    title: "Last 1 Hour"
  },
  {
    since: "-PT3H",
    title: "Last 3 Hours"
  },
  {
    since: "-PT6H",
    title: "Last 6 Hours"
  },
  {
    since: "-PT12H",
    title: "Last 12 Hours"
  },
  {
    since: "-P1D",
    title: "Last 1 Day"
  },
  {
    since: "-P3D",
    title: "Last 3 Days"
  },
  {
    since: "-P14D",
    title: "Last 14 Days"
  },
  {
    since: "-P1W",
    title: "Last 1 Week"
  },
  {
    since: "-P2W",
    title: "Last 2 Weeks"
  },
  {
    since: "-P30D",
    title: "Last 1 Month"
  },
  {
    since: "-P90D",
    title: "Last 3 Months"
  },
  {
    since: "-P180D",
    title: "Last 6 Months"
  },
  {
    since: "-P365D",
    title: "Last 1 Year"
  }
];

// src/modules/container/components/timeRangeV2/TimeRangeComponentV2.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
var PRESETS_PREFERENCE_TYPE = "uishell:timerangePresets";
var DEFAULT_RECENTS_COUNT = 5;
var { TIMERANGEPICKER, REFRESH } = getStyles2();
var REGEX_FOR_SINCE = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)([DW]))?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;
var TimeRangeComponentV2 = /* @__PURE__ */ __name(({ displayFormat, style }) => {
  const [presets, setPresets] = (0, import_react24.useState)();
  const [recents, setRecents] = (0, import_react24.useState)([]);
  const isInitalTimeRangeParamPresent = (0, import_react24.useRef)(true);
  const isInitialLoad = (0, import_react24.useRef)(true);
  const { appName: appName2, tenantId } = (0, import_react24.useContext)(ShellContainerContext);
  const { timeRange: timeRange2, setTimeRange, setTimeRangeEventSource, shellPreferences } = (0, import_react24.useContext)(TimeRangeContext);
  const getTimerangePresets = (0, import_react24.useCallback)(async () => {
    const timerangePresetsResponse = await getGenericPreferences(
      PRESETS_PREFERENCE_TYPE,
      tenantId,
      "TENANT" /* TENANT */,
      `data.appName eq "${appName2}"`
    );
    const timerangePresetsItem = filterPreferencesByLayerType(timerangePresetsResponse, "SOLUTION" /* SOLUTION */);
    if (timerangePresetsItem) {
      const { data: timerangePresetsData } = timerangePresetsItem;
      if ("timerangePresets" in timerangePresetsData) {
        setPresets(timerangePresetsData.timerangePresets);
      }
    } else {
      setPresets(DEFAULT_PRESETS);
    }
  }, [appName2, tenantId]);
  const getTimerangeRecentsFromOrion = (0, import_react24.useCallback)(async () => {
    const timeRangeRecentsResponseFromShell = await getTimerangeRecents(
      `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
      "LOCALUSER" /* LOCALUSER */,
      `data.appName eq "${CONSTANTS.SHELL_APP}"`
    );
    let timerangeRecentsItem = filterPreferencesByLayerType(
      timeRangeRecentsResponseFromShell,
      "LOCALUSER" /* LOCALUSER */
    );
    if (!timerangeRecentsItem) {
      const timerangeRecentsResponseFromApp = await getTimerangeRecents(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        "LOCALUSER" /* LOCALUSER */,
        `data.appName eq "${appName2}"`
      );
      timerangeRecentsItem = filterPreferencesByLayerType(timerangeRecentsResponseFromApp, "LOCALUSER" /* LOCALUSER */);
      if (!timerangeRecentsItem && appName2 === "cco") {
        const deafultTimerangeRecentsResponse = await getTimerangeRecents(
          `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
          "LOCALUSER" /* LOCALUSER */,
          `data.appName eq "cnao"`
        );
        timerangeRecentsItem = filterPreferencesByLayerType(deafultTimerangeRecentsResponse, "LOCALUSER" /* LOCALUSER */);
      }
    }
    return timerangeRecentsItem;
  }, [appName2, tenantId]);
  const getTimerangeRecents2 = (0, import_react24.useCallback)(async () => {
    const timerangeRecentsItem = await getTimerangeRecentsFromOrion();
    if (timerangeRecentsItem) {
      const { data: timerangeRecentsData } = timerangeRecentsItem;
      if ("timerangeRecents" in timerangeRecentsData) {
        setRecents(timerangeRecentsData.timerangeRecents);
      }
    }
  }, [getTimerangeRecentsFromOrion]);
  const saveTimerangeRecents = (0, import_react24.useCallback)(
    async (input) => {
      let updatedRecents = [];
      const layerId = `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`;
      const timeRangeRecentsItem = await getTimerangeRecentsFromOrion();
      const { data: timeRangeRecentsData } = timeRangeRecentsItem ?? {
        data: {
          appName: CONSTANTS.SHELL_APP,
          timerangeRecents: []
        }
      };
      updatedRecents = [
        input,
        ...timeRangeRecentsData.timerangeRecents.filter(
          (recent) => !import_future2.TimeRangeSelector.TimeRange.isEqualInput(input, recent)
        )
      ];
      updatedRecents = updatedRecents.slice(0, DEFAULT_RECENTS_COUNT);
      if (timeRangeRecentsItem && timeRangeRecentsItem.data.appName === CONSTANTS.SHELL_APP) {
        await setTimerangeRecents(layerId, {
          ...timeRangeRecentsItem,
          data: {
            ...timeRangeRecentsItem.data,
            timerangeRecents: updatedRecents
          }
        });
      } else {
        await setTimerangeRecents(layerId, {
          data: {
            appName: CONSTANTS.SHELL_APP,
            timerangeRecents: updatedRecents
          }
        });
      }
      setRecents(updatedRecents);
    },
    [getTimerangeRecentsFromOrion, tenantId]
  );
  const saveTimerangeToPreferences = (0, import_react24.useCallback)(
    async (newTimeRange) => {
      const shellApp = await getShellPreferences(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        "LOCALUSER" /* LOCALUSER */,
        `data.appName eq "${CONSTANTS.SHELL_APP}"`
      );
      const shellAppUserPref = filterPreferencesByLayerType(shellApp, "LOCALUSER" /* LOCALUSER */) ?? { data: { appName: CONSTANTS.SHELL_APP, shellPreferences: {} } };
      const updatedShellPreferences = {
        ...shellAppUserPref,
        data: {
          ...shellAppUserPref.data,
          shellPreferences: {
            ...shellAppUserPref.data.shellPreferences,
            selectedTimerange: newTimeRange
          }
        }
      };
      await setShellPreferences(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        updatedShellPreferences
      );
    },
    [tenantId]
  );
  const onSelectedTimeRangeChange = (0, import_react24.useCallback)(
    (newTimeRange) => {
      setTimeRange(newTimeRange.value);
      ShellEvent.emit("timeRangeChanged", newTimeRange);
      setTimeRangeEventSource(newTimeRange.eventSource);
      if (newTimeRange.eventSource === "INPUT") {
        saveTimerangeRecents(newTimeRange.value.input).catch(reportError);
      }
      if (newTimeRange.eventSource !== "AUTO_REFRESH" && newTimeRange.eventSource !== "REFRESH") {
        saveTimerangeToPreferences(newTimeRange.value.input).catch(reportError);
      }
    },
    [saveTimerangeRecents, saveTimerangeToPreferences, setTimeRange, setTimeRangeEventSource]
  );
  const getInitialTimeRange = (0, import_react24.useCallback)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const timeRangeValueFromUrl = import_future2.TimeRangeSelector.TimeRange?.valueFromSearchParams(queryParams);
    if (!isInitalTimeRangeParamPresent.current || !timeRangeValueFromUrl) {
      isInitalTimeRangeParamPresent.current = false;
      isInitialLoad.current = false;
      if (shellPreferences && isShellPreferencesData(shellPreferences.data)) {
        const appSelectedTimeRange = shellPreferences.data.shellPreferences.selectedTimerange;
        if (appSelectedTimeRange && REGEX_FOR_SINCE.test(appSelectedTimeRange.since)) {
          setTimeRange((prevTimeRange) => {
            if (!import_future2.TimeRangeSelector.TimeRange.isEqualInput(prevTimeRange.input, appSelectedTimeRange)) {
              return {
                input: appSelectedTimeRange,
                now: (/* @__PURE__ */ new Date()).toISOString()
              };
            }
            return prevTimeRange;
          });
        }
      }
    } else if (isInitialLoad.current) {
      isInitialLoad.current = false;
      setTimeRange((prevTimeRange) => {
        if (!import_future2.TimeRangeSelector.TimeRange.isEqualInput(prevTimeRange.input, timeRangeValueFromUrl.input)) {
          return timeRangeValueFromUrl;
        }
        return prevTimeRange;
      });
    }
  }, [shellPreferences, setTimeRange]);
  (0, import_react24.useEffect)(() => {
    getTimerangePresets().catch(reportError);
    getTimerangeRecents2().catch(reportError);
  }, [getTimerangePresets, getTimerangeRecents2]);
  (0, import_react24.useEffect)(() => {
    getInitialTimeRange();
  }, [getInitialTimeRange]);
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)("div", { style: { ...style }, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)("div", { className: (0, import_uik34.css)({ display: "flex", gap: 12, alignItems: "center", flexDirection: "row" }), children: presets && /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
    import_future2.TimeRangeSelector,
    {
      displayFormat,
      onSelectedTimeRangeChange,
      presets,
      recents,
      triggerTheme: "DARK",
      selectedTimeRange: timeRange2,
      "data-testid": "timeRange",
      className: (0, import_uik34.css)(TIMERANGEPICKER, REFRESH)
    }
  ) }) });
}, "TimeRangeComponentV2");
var TimeRangeComponentV2_default = TimeRangeComponentV2;

// src/modules/container/components/appSwitcher/appSwitcher.tsx
var import_uik36 = require("@appd/uik");
var import_react25 = require("react");

// src/modules/container/components/appSwitcher/STYLES.tsx
var import_uik35 = require("@appd/uik");
var {
  COLORS: { INVERSE_TEXT: INVERSE_TEXT6, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK4 },
  SPACING: SPACING15
} = import_uik35.MAGNETIC_TOKENS;
var STYLES5 = {
  APP_SWITCHER_ICON_STYLE: import_uik35.css.Styles({
    height: 24,
    width: 24,
    marginLeft: 0,
    marginRight: 6,
    cursor: "pointer",
    color: INVERSE_TEXT6
  }),
  APP_SWITCHER_MENU_BUTTON: import_uik35.css.Styles({
    height: 36,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: SPACING15[2],
    backgroundColor: "#474398",
    // replace with tokens after it has been added to Magnetic library
    ":hover": {
      backgroundColor: "#858BEE"
    }
  }),
  APP_SWITCHER_TRIGGER_TEXT: import_uik35.css.Styles({
    color: INVERSE_TEXT6,
    marginLeft: SPACING15[1],
    fontSize: 14,
    lineHeight: 20,
    fontWeight: 600,
    letterSpacing: 0
  }),
  APP_SWITCHER_CARET_ICON: import_uik35.css.Styles({
    // this will break if uik decides to change the icon name,
    // however this is the only way to change the styles without using `!important`
    '& svg[uik="Icon.Navigation.ArrowDropDown"]': {
      height: 16,
      width: 16,
      paddingLeft: SPACING15[2],
      paddingRight: SPACING15[2]
    },
    '& svg path[fill="#fff"]': {
      fill: "#fff",
      // this is needed to override the default `--control-icon-weak`
      fillOpacity: 1
    }
  }),
  APP_SWITCHER_APPLICATION_DIVIDER: import_uik35.css.Styles({
    lineHeight: "1px",
    height: "1px",
    backgroundColor: CONTROL_BORDER_WEAK4,
    marginTop: "0px",
    marginBottom: "0px"
  }),
  APP_SWITCHER_SELECTED_APP: import_uik35.css.Styles({
    marginLeft: 3,
    marginRight: 4,
    '& svg path[fill="#fff"]': {
      fill: "green"
    }
  })
};

// src/modules/container/components/appSwitcher/appSwitcher.tsx
var import_jsx_runtime33 = require("react/jsx-runtime");
var {
  TYPOGRAPHY: { ELLIPSES }
} = import_uik36.MAGNETIC_TOKENS;
var iconStyle = (0, import_uik36.css)({
  marginLeft: 3,
  marginRight: 4,
  cursor: "pointer"
});
var AppSwitcherComponent = /* @__PURE__ */ __name(({ apps }) => {
  const ADMIN_PAGES = [CONSTANTS.PLATFORM_APP_LAYERID];
  const [triggerText, setTriggerText] = (0, import_react25.useState)("");
  const [triggerTextIcon, setTriggerTextIcon] = (0, import_react25.useState)("");
  const { isAdmin, selectAppByName } = (0, import_react25.useContext)(IsAdminContext);
  (0, import_react25.useEffect)(() => {
    const NoSelectedText = "No Selected App";
    let defaultText = NoSelectedText;
    let defaultTextIcon = "Icon.Object.Interactions";
    const pathname = window.location.pathname.replace("/session/api/ext", "");
    const zodiacMatch = pathname.match("/app/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)/([a-zA-Z0-9-_]*)");
    const diabloMatch = pathname.match("/([a-zA-Z0-9_]*)/([a-zA-Z0-9-_]*)");
    const appName2 = zodiacMatch ? zodiacMatch[3] : diabloMatch ? diabloMatch[2] : "";
    apps.forEach(({ name }, index) => {
      if (apps[index].name === CONSTANTS.DEFAULT_APP_NAME && defaultText === NoSelectedText) {
        defaultText = apps[index].title;
        defaultTextIcon = apps[index].icon;
      }
      if (appName2 !== "" && appName2 === name) {
        if (!isAdmin && ADMIN_PAGES.includes(name)) {
          selectAppByName(CONSTANTS.DEFAULT_APP_NAME);
          return;
        }
        if (ADMIN_PAGES.includes(name)) {
          selectAppByName(name);
        }
        defaultText = apps[index].title;
        defaultTextIcon = apps[index].icon;
      }
    });
    setTriggerText(defaultText);
    setTriggerTextIcon(defaultTextIcon);
  }, [apps, isAdmin]);
  const trigger = /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { "data-testid": "appSwitcherButton", children: /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)(
    import_uik36.Button,
    {
      type: "MENU",
      className: (0, import_uik36.css)({
        ...ButtonStyles.SHELL_BUTTON_STYLES,
        ...STYLES5.APP_SWITCHER_MENU_BUTTON,
        ...ELLIPSES.END,
        ...STYLES5.APP_SWITCHER_CARET_ICON
      }),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_uik36.Icon, { className: (0, import_uik36.css)(STYLES5.APP_SWITCHER_ICON_STYLE), size: "SMALL", type: triggerTextIcon }),
        " ",
        /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)("div", { className: (0, import_uik36.css)(STYLES5.APP_SWITCHER_TRIGGER_TEXT), children: [
          " ",
          triggerText,
          " "
        ] })
      ]
    }
  ) });
  const onSelect = /* @__PURE__ */ __name(([index], [value]) => {
    const title = value.split("]")[1];
    let homePageUri;
    let name;
    apps.forEach((app) => {
      if (app.title === title) {
        homePageUri = app.homePageUri;
        name = app.name;
      }
    });
    if (homePageUri === void 0 || name === void 0) {
      return;
    }
    const prefix = homePageUri.appAware ? `${homePageUri.site}/${name}` : homePageUri.site;
    const path = homePageUri.path ?? "";
    const hash = homePageUri.hash ? `#${homePageUri.hash}` : "";
    const query = homePageUri.query ? `?${new URLSearchParams(homePageUri.query).toString()}` : "";
    window.location.href = `${prefix}${path}${hash}${query}`;
  }, "onSelect");
  const getApplication = /* @__PURE__ */ __name((title, icon, index, name) => {
    if (name && ADMIN_PAGES.includes(name) && !isAdmin) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_uik36.Menu.Option, { style: { height: 45 }, children: /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)("div", { style: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_uik36.Icon, { className: iconStyle, size: "MEDIUM", type: icon }),
      /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { className: (0, import_uik36.css)({ ...ELLIPSES.END, marginLeft: 5 }), children: title }),
      triggerText === title ? /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
        "div",
        {
          className: (0, import_uik36.css)({
            width: "25%",
            textAlign: "right",
            paddingTop: "5px",
            ...STYLES5.APP_SWITCHER_SELECTED_APP
          }),
          children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_uik36.Icon, { size: "SMALL", type: "Action.Enable" })
        }
      ) : ""
    ] }) }, `appSwitcherKey-${index}`);
  }, "getApplication");
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)(import_uik36.Menu, { onSelect, trigger, className: (0, import_uik36.css)({ width: 300 }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
      "div",
      {
        className: (0, import_uik36.css)({
          width: 300,
          height: "45px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          marginLeft: 5
        }),
        children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { style: { padding: "0px 12px" }, children: " Applications" })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { className: (0, import_uik36.css)(STYLES5.APP_SWITCHER_APPLICATION_DIVIDER) }),
    apps.map(({ title, icon, name }, index) => getApplication(title, icon, index, name))
  ] });
}, "AppSwitcherComponent");
var appSwitcher_default = AppSwitcherComponent;

// src/modules/container/builder/STYLES.tsx
var import_uik37 = require("@appd/uik");
var { SPACING: SPACING16 } = import_uik37.MAGNETIC_TOKENS;
var STYLES6 = {
  TOP_NAV: import_uik37.css.Styles({
    background: "linear-gradient(to right, #423781, #39285d)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 56,
    gridArea: "top"
  }),
  LEFT_CONTAINER: import_uik37.css.Styles({
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    marginLeft: 10,
    marginRight: 35 * 2,
    gap: SPACING16[3]
  }),
  RIGHT_CONTAINER: import_uik37.css.Styles({
    display: "flex",
    alignItems: "center",
    marginRight: SPACING16[6],
    gap: SPACING16[3],
    "& > *": {
      padding: SPACING16[1],
      "&:hover": {
        borderRadius: 3
      }
    }
  })
};

// src/modules/container/builder/pluginSort.tsx
function pluginSort(pluginsArray, section) {
  const leftPluginOrdering = {
    label: null,
    appSwitcher: null,
    separator: null,
    breadcrumbs: null,
    display: null,
    custom: null
  };
  const rightPluginOrdering = {
    refresh: null,
    timeRangeV2: null,
    aiModal: null,
    shareButton: null,
    exchange: null,
    helpCenter: null,
    miniProfile: null,
    logout: null,
    display: null,
    custom: null
  };
  const pluginMap = section === "left" ? leftPluginOrdering : rightPluginOrdering;
  pluginsArray.forEach((plugin) => {
    if (plugin.name in pluginMap) {
      pluginMap[plugin.name] = { ...plugin };
    }
  });
  return Object.values(pluginMap).filter((plugin) => plugin != null);
}
__name(pluginSort, "pluginSort");

// src/modules/container/components/helpCenterV2/HelpCenterV2.tsx
var import_uik56 = require("@appd/uik");
var import_react31 = require("react");
var import_react_dom2 = __toESM(require("react-dom"));
var import_fso_ui_shell_ai_assistant = require("@appd/fso-ui-shell-ai-assistant");

// src/modules/container/components/helpCenterV2/STYLES.ts
var import_uik38 = require("@appd/uik");
var {
  COLORS: {
    CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK5,
    CONTROL_BG_WEAK: CONTROL_BG_WEAK3,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK2,
    DEFAULT_BG_DISABLED,
    DEFAULT_TEXT: DEFAULT_TEXT5,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM9
  },
  SPACING: SPACING17,
  TYPOGRAPHY: { HEADING_PRIMARY }
} = import_uik38.MAGNETIC_TOKENS;
var STYLES7 = {
  BUTTON_HELP: {
    backgroundColor: "transparent"
  },
  HELP_CENTER_CONTAINER: (0, import_uik38.css)({
    padding: SPACING17[5]
  }),
  HELP_CENTER_HEADER: (0, import_uik38.css)({
    gridArea: "header",
    paddingTop: SPACING17[4],
    paddingLeft: SPACING17[6],
    paddingRight: SPACING17[6],
    paddingBottom: SPACING17[4],
    borderBottom: "solid 1px",
    borderBottomColor: CONTROL_BORDER_WEAK5,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }),
  HELP_CENTER_HEADER_TEXT: (0, import_uik38.css)({
    flexGrow: 2,
    font: HEADING_PRIMARY
  }),
  HELP_CENTER_HEADER_BACK: (0, import_uik38.css)({
    marginRight: SPACING17[1],
    marginLeft: -SPACING17[3]
  }),
  HELP_CENTER_TOP_CONTENT: (0, import_uik38.css)({
    gridArea: "top"
  }),
  HELP_CENTER_MAIN_CONTENT: (0, import_uik38.css)({
    maxHeight: "100%",
    overflowY: "auto",
    gridArea: "main",
    backgroundColor: DEFAULT_BG_DISABLED
  }),
  HELP_CENTER_FOOTER: (0, import_uik38.css)({
    paddingTop: SPACING17[2],
    paddingBottom: SPACING17[2],
    paddingLeft: SPACING17[5],
    paddingRight: SPACING17[5],
    gridArea: "footer"
  }),
  HELP_CENTER_PORTAL: (0, import_uik38.css)({
    width: 500,
    animation: "fadeInFromNone 400ms cubic-bezier(0, 0, 0.2, 1)",
    height: "calc(100vh - 56px)",
    overflowY: "auto",
    backgroundColor: CONTROL_BG_WEAK3,
    color: DEFAULT_TEXT5,
    display: "grid",
    grid: `
      " header " max-content
      " top   " max-content
      " main   " 1fr
      " footer "max-content
      / 1fr`,
    "& path": {
      fill: CONTROL_ICON_WEAK2
    }
  })
};
var DEFAULT_TEXT_FONT = {
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "18px",
  color: DEFAULT_TEXT_MEDIUM9
};

// src/modules/container/components/helpCenterV2/version/Version.tsx
var import_uik42 = require("@appd/uik");
var import_react27 = require("react");

// src/modules/container/components/helpCenterV2/aboutCompanyDialog/AboutCompanyDialog.tsx
var import_uik40 = require("@appd/uik");
var import_react26 = require("react");

// src/modules/container/components/helpCenterV2/aboutCompanyDialog/STYLES.ts
var import_uik39 = require("@appd/uik");
var {
  TYPOGRAPHY: { TEXT },
  SPACING: SPACING18
} = import_uik39.MAGNETIC_TOKENS;
var STYLES8 = {
  COMPANY_LOGO: (0, import_uik39.css)({
    padding: "32px 0",
    textAlign: "center"
  }),
  APP_NAME_TEXT: (0, import_uik39.css)({
    ...TEXT.DEFAULT,
    textAlign: "center"
  }),
  COPYRIGHT_TEXT: (0, import_uik39.css)({
    ...TEXT.DEFAULT,
    fontWeight: 300,
    textAlign: "center",
    paddingBottom: SPACING18[5]
  }),
  VERSION_TEXT: (0, import_uik39.css)({
    ...TEXT.DEFAULT,
    fontWeight: 300,
    textAlign: "center",
    paddingBottom: SPACING18[4]
  })
};

// src/modules/container/components/helpCenterV2/aboutCompanyDialog/AboutCompanyDialog.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");
var lightLogo = require_Cisco_wht_sm();
var darkLogo = require_Cisco_blue_sm();
var VERSION = import_uik40.format.message`Version`.description("product version");
var TERMS_OF_SERVICE_LABEL = import_uik40.format.message`Terms of service`.description(
  "Terms of service text to be displayed on about company pop up"
);
var ACTION_OK_LABEL = import_uik40.format.message`OK`.description("Text on the button to take the action to confirm something");
var COPYRIGHT_MESSAGE = import_uik40.format.message`©${"$0"} Cisco Systems Inc. All rights reserved.`.description(
  "Copyright text"
);
var sendTelemetryEvent2 = /* @__PURE__ */ __name((pageName) => {
  const telemetryProperties = {
    event: "Help Center",
    properties: {
      page: pageName,
      clickSection: "Terms of service"
    }
  };
  TrackingService.sendEvent(telemetryProperties).catch((error) => console.error(error));
}, "sendTelemetryEvent");
var AboutCompanyDialog = /* @__PURE__ */ __name(({
  appName: appName2,
  showDialog,
  closeDialog,
  productVersion = "local",
  pageName = ""
}) => {
  const { currentTheme } = (0, import_react26.useContext)(import_uik40.css.CONTEXT);
  const appNameText = appName2 ?? "";
  const productVersionText = `${VERSION()}: ${productVersion}`;
  const CISCO_LOGO2 = currentTheme === "light" ? darkLogo : lightLogo;
  const termsOfUseLink = "https://www.appdynamics.com/legal/terms-of-use";
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)(
    import_uik40.Dialog,
    {
      action: ACTION_OK_LABEL(),
      cancel: TERMS_OF_SERVICE_LABEL(),
      onClose: (kind) => {
        if (kind === "CANCEL") {
          sendTelemetryEvent2(pageName);
          window.open(termsOfUseLink, "_blank");
        } else {
          closeDialog();
        }
      },
      open: showDialog,
      size: "MEDIUM",
      title: "",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { className: STYLES8.COMPANY_LOGO, children: /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("img", { src: CISCO_LOGO2, alt: "logo", height: "45", width: "246" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { className: STYLES8.APP_NAME_TEXT, children: appNameText }),
        /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { className: STYLES8.VERSION_TEXT, children: productVersionText }),
        /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { className: STYLES8.COPYRIGHT_TEXT, children: COPYRIGHT_MESSAGE(String((/* @__PURE__ */ new Date()).getFullYear())) })
      ]
    }
  );
}, "AboutCompanyDialog");

// src/modules/container/components/helpCenterV2/version/STYLES.ts
var import_uik41 = require("@appd/uik");
var {
  SPACING: SPACING19,
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT6 },
  TYPOGRAPHY: { TEXT: TEXT2 }
} = import_uik41.MAGNETIC_TOKENS;
var STYLES9 = {
  VERSION: import_uik41.css.Styles({
    color: DEFAULT_TEXT6,
    display: "flex",
    padding: SPACING19[1],
    cursor: "pointer",
    ...TEXT2.DEFAULT
  }),
  VERSION_TEXT: import_uik41.css.Styles({
    marginLeft: SPACING19[2],
    fontWeight: 400,
    fontSize: "12px"
  })
};

// src/modules/container/components/helpCenterV2/version/Version.tsx
var import_jsx_runtime35 = require("react/jsx-runtime");
var CiscoLight = require_Cisco_wht_sm();
var CiscoDark = require_Cisco_blue_sm();
var sendTelemetryEvent3 = /* @__PURE__ */ __name((pageName) => {
  const telemetryProperties = {
    event: "Help Center",
    properties: {
      page: pageName,
      clickSection: "Version"
    }
  };
  TrackingService.sendEvent(telemetryProperties).catch((error) => console.error(error));
}, "sendTelemetryEvent");
var Version = /* @__PURE__ */ __name(({ appName: appName2 = "", productVersion = "", pageName }) => {
  const [showAboutCompanyDialog, setShowAboutCompanyDialog] = (0, import_react27.useState)(false);
  const { currentTheme } = (0, import_react27.useContext)(import_uik42.css.CONTEXT);
  const versionText = `${appName2} Version: ${productVersion}`;
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)(import_jsx_runtime35.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)(
      "div",
      {
        className: (0, import_uik42.css)(STYLES9.VERSION),
        role: "button",
        tabIndex: 0,
        onClick: () => {
          sendTelemetryEvent3(pageName ?? "");
          setShowAboutCompanyDialog(true);
        },
        "data-testid": "cloudVersion",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("img", { src: currentTheme === "light" ? CiscoDark : CiscoLight, alt: "", width: "20" }),
          /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("div", { className: (0, import_uik42.css)(STYLES9.VERSION_TEXT), children: versionText })
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
      AboutCompanyDialog,
      {
        appName: appName2,
        productVersion,
        pageName,
        showDialog: showAboutCompanyDialog,
        closeDialog: () => setShowAboutCompanyDialog(false)
      }
    )
  ] });
}, "Version");

// src/modules/container/components/helpCenterV2/emptyState/EmptyState.tsx
var import_uik44 = require("@appd/uik");

// src/modules/container/components/helpCenterV2/emptyState/STYLES.ts
var import_uik43 = require("@appd/uik");
var {
  COLORS: { DEFAULT_BG_DISABLED: DEFAULT_BG_DISABLED2 },
  SPACING: SPACING20
} = import_uik43.MAGNETIC_TOKENS;
var STYLES10 = {
  CONTAINER: import_uik43.css.Styles({
    maxHeight: "100%",
    overflow: "scroll",
    gridArea: "main",
    backgroundColor: DEFAULT_BG_DISABLED2,
    padding: SPACING20[5],
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }),
  HEADER: import_uik43.css.Styles({
    marginTop: SPACING20[4],
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "25px"
  }),
  BOTTOM: import_uik43.css.Styles({
    width: "250px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "15px",
    paddingTop: SPACING20[2],
    paddingBottom: SPACING20[3]
  })
};

// src/modules/container/components/helpCenterV2/emptyState/EmptyState.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");
var errorImage = require_emptyStateError();
var EmptyState = /* @__PURE__ */ __name(() => {
  const headerText = "This page couldn't be loaded";
  const bottomText = "Try reloading the page. If the issue persists, please contact Support.";
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)("div", { className: (0, import_uik44.css)(STYLES10.CONTAINER), "data-testid": "help-center-empty", children: [
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("img", { src: errorImage, alt: "Error State" }),
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("div", { className: (0, import_uik44.css)(STYLES10.HEADER), children: headerText }),
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("div", { className: (0, import_uik44.css)(STYLES10.BOTTOM), children: bottomText }),
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(import_uik44.Button, { onClick: () => window.location.reload(), children: "Reload" })
  ] });
}, "EmptyState");

// src/modules/container/components/helpCenterV2/defaultPageComponents/DefaultTopContent.tsx
var import_react30 = require("react");

// src/modules/container/components/helpCenterV2/link/HelpCenterLink.tsx
var import_uik47 = require("@appd/uik");
var import_react29 = require("react");

// src/modules/container/components/helpCenterV2/link/getStyles.ts
var import_uik45 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK6, CONTROL_ICON_MEDIUM: CONTROL_ICON_MEDIUM2, CONTROL_ICON_MEDIUM_HOVER: CONTROL_ICON_MEDIUM_HOVER2, DEFAULT_TEXT: DEFAULT_TEXT7, DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM10 },
  SPACING: SPACING21,
  TYPOGRAPHY: {
    A,
    HEADINGS: { H1, H2 }
  }
} = import_uik45.MAGNETIC_TOKENS;
var STYLES11 = {
  TOP_LINK: (0, import_uik45.css)({
    textDecoration: "none",
    fontSize: "14px",
    paddingLeft: SPACING21[6],
    paddingTop: "10px",
    paddingBottom: "10px",
    borderBottom: "solid 1px",
    borderBottomColor: CONTROL_BORDER_WEAK6,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: `${DEFAULT_TEXT7} !important`,
    "& span": {
      paddingLeft: SPACING21[2],
      paddingRight: SPACING21[6]
    }
  }),
  GUIDE_LINK: (0, import_uik45.css)({
    "& a": {
      ...A.DEFAULT,
      textDecoration: "none",
      fontSize: "16px",
      fontWeight: 500,
      color: CONTROL_ICON_MEDIUM2,
      "&:hover": {
        color: CONTROL_ICON_MEDIUM_HOVER2
      }
    }
  })
};
var getStyles3 = /* @__PURE__ */ __name((textStyle2, hasNoUri, uriEmptyString) => {
  const linkHeaderStyles = {
    H1,
    H2: {
      ...H2,
      fontWeight: 500
    },
    H3: {
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "24px"
    },
    H4: {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "18px"
    }
  };
  const baseLinkStyle = {
    ...textStyle2 ? linkHeaderStyles[textStyle2] : DEFAULT_TEXT_FONT,
    textDecoration: "none",
    color: hasNoUri ? DEFAULT_TEXT_MEDIUM10 : CONTROL_ICON_MEDIUM2
  };
  if (hasNoUri) {
    return (0, import_uik45.css)(baseLinkStyle);
  }
  if (uriEmptyString) {
    return (0, import_uik45.css)({
      ...baseLinkStyle,
      cursor: "pointer",
      paddingLeft: "0px",
      backgroundColor: "rgba(255,255,255,0)",
      border: "none",
      "&:hover": {
        color: CONTROL_ICON_MEDIUM_HOVER2,
        backgroundColor: "rgba(255,255,255,0)"
      }
    });
  }
  return (0, import_uik45.css)({
    "& a": {
      ...baseLinkStyle,
      "&:hover": {
        color: CONTROL_ICON_MEDIUM_HOVER2
      }
    }
  });
}, "getStyles");

// src/modules/container/components/common/linkWrapper/LinkWrapper.tsx
var import_uik46 = require("@appd/uik");

// src/modules/container/components/context/RouterContext.tsx
var import_react28 = __toESM(require("react"));
var RouterContext = import_react28.default.createContext(void 0);

// src/modules/container/components/common/linkWrapper/LinkWrapper.tsx
var import_jsx_runtime37 = (
  // eslint-disable-next-line react/jsx-no-target-blank -- linter doesn't catch the conditional
  require("react/jsx-runtime")
);
function LinkWrapper({ href, siteName, className, children, newTab = false }) {
  const onClickHandler = /* @__PURE__ */ __name((event, routerObj, url) => {
    if (!routerObj) {
      return;
    }
    if (routerObj.router && siteName && isSiteBasedNavigation(siteName)) {
      const finalUrl = siteName !== "" ? url.replace(siteName, "") : url;
      void routerObj.router(finalUrl);
      event.preventDefault();
    }
  }, "onClickHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(RouterContext.Consumer, { children: (routerObj) => /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
    "a",
    {
      href,
      onClick: (event) => onClickHandler(event, routerObj, href),
      className: (0, import_uik46.css)({ textDecoration: "none" }, className),
      onKeyUp: ({ key, currentTarget }) => [" ", "Enter"].includes(key) && currentTarget.click(),
      target: newTab ? "_blank" : "_self",
      rel: newTab ? "noreferrer" : void 0,
      children
    }
  ) });
}
__name(LinkWrapper, "LinkWrapper");

// src/modules/container/utils/isDevEnvironment.ts
var isDevEnvironment = /* @__PURE__ */ __name(() => {
  const isLocal2 = window.location.hostname.includes("localhost");
  const isAppdTest2 = window.location.hostname.includes("appd-test.com");
  return isLocal2 || isAppdTest2;
}, "isDevEnvironment");

// src/modules/container/components/helpCenterV2/link/HelpCenterLink.tsx
var import_jsx_runtime38 = require("react/jsx-runtime");
var getUri = /* @__PURE__ */ __name((uri) => {
  if (isDevEnvironment() && uri && uri.includes("accounts.appdynamics.com")) {
    return uri.replace("accounts.appdynamics.com", "accounts-staging.saas.appd-test.com");
  }
  return uri;
}, "getUri");
var HelpCenterLink = /* @__PURE__ */ __name(({
  helpCenterSection,
  text,
  textStyle: textStyle2,
  icon = "",
  uri,
  newTab,
  shellEvent
}) => {
  const { appName: appName2 } = (0, import_react29.useContext)(ShellContainerContext);
  const hasNoUri = uri === void 0;
  const uriIsString = typeof uri === "string";
  const path = uriIsString || !uri ? getUri(uri) : getFullPathFromUrl(uri, appName2);
  const onClickHandler = /* @__PURE__ */ __name((eventString) => {
    if (eventString && eventString !== "") {
      ShellEvent.emit(eventString);
    }
  }, "onClickHandler");
  if (helpCenterSection === "topItems" && typeof uri === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("a", { className: STYLES11.TOP_LINK, href: uri, target: "_blank", rel: "noreferrer", "data-testid": "external-hc-link", children: [
      /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(import_uik47.Icon, { type: icon, "data-testid": "external-hc-link-icon" }),
      /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("span", { children: text }),
      /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(import_uik47.Icon.Navigation.ArrowRight, {})
    ] });
  }
  if (uri === "") {
    return /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("button", { className: getStyles3(textStyle2, false, true), onClick: () => onClickHandler(shellEvent), type: "button", children: text });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("div", { className: getStyles3(textStyle2, hasNoUri, false), "data-testid": "internal-hc-link", children: hasNoUri || uri === "" ? text : /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
    LinkWrapper,
    {
      href: path ?? "",
      siteName: typeof uri === "object" ? uri.site : void 0,
      newTab: uriIsString || newTab,
      children: text
    }
  ) });
}, "HelpCenterLink");

// src/modules/container/components/helpCenterV2/text/getStyles.ts
var import_uik48 = require("@appd/uik");
var {
  TYPOGRAPHY: {
    HEADINGS: { H1: H12, H2: H22 }
  }
} = import_uik48.MAGNETIC_TOKENS;
var getStyles4 = /* @__PURE__ */ __name((textStyle2) => {
  const headerStyles = {
    H1: H12,
    H2: {
      ...H22,
      fontWeight: 500
    },
    H3: {
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "24px"
    },
    H4: {
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "18px"
    }
  };
  if (!textStyle2) {
    return (0, import_uik48.css)(DEFAULT_TEXT_FONT);
  }
  return (0, import_uik48.css)({ ...headerStyles[textStyle2] });
}, "getStyles");

// src/modules/container/components/helpCenterV2/text/HelpCenterText.tsx
var import_jsx_runtime39 = require("react/jsx-runtime");
var HelpCenterText = /* @__PURE__ */ __name(({ text, textStyle: textStyle2 }) => /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: getStyles4(textStyle2), "data-testid": "help-center-text", children: text }), "HelpCenterText");

// src/modules/container/components/helpCenterV2/divider/HelpCenterDivider.tsx
var import_uik49 = require("@appd/uik");
var import_jsx_runtime40 = require("react/jsx-runtime");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK7 },
  SPACING: SPACING22
} = import_uik49.MAGNETIC_TOKENS;
var STYLES12 = (0, import_uik49.css)({
  lineHeight: "1px",
  height: "1px",
  backgroundColor: CONTROL_BORDER_WEAK7,
  marginTop: SPACING22[3],
  marginBottom: SPACING22[3]
});
var HelpCenterDivider = /* @__PURE__ */ __name(() => /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("div", { className: STYLES12, "data-testid": "help-center-divider" }), "HelpCenterDivider");

// src/modules/container/components/helpCenterV2/replayTour/HelpCenterReplayTour.tsx
var import_uik50 = require("@appd/uik");
var import_jsx_runtime41 = require("react/jsx-runtime");
var HelpCenterReplayTour = /* @__PURE__ */ __name(({ title, icon = "" }) => /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
  "div",
  {
    role: "button",
    tabIndex: 0,
    className: (0, import_uik50.css)(STYLES11.TOP_LINK),
    onClick: () => ShellEvent.emit(ShellEventTypes.REPLAY_TOUR_CLICKED),
    "data-testid": "help-center-replay",
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(import_uik50.Icon, { type: icon }),
      /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("span", { children: title }),
      /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(import_uik50.Icon.Navigation.ArrowRight, {})
    ]
  }
), "HelpCenterReplayTour");

// src/modules/container/components/helpCenterV2/itemRender/HelpCenterItemRenderer.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
var HelpCenterItemRenderer = /* @__PURE__ */ __name(({
  item,
  helpCenterSection
}) => {
  switch (item[0]) {
    case "HelpCenterLink":
      return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
        HelpCenterLink,
        {
          icon: item[1].icon,
          uri: item[1].uri,
          text: item[1].text,
          textStyle: item[1].textStyle,
          newTab: item[1].newTab,
          shellEvent: item[1].shellEvent,
          helpCenterSection
        },
        `help-center-link-item-${item[1].text}`
      );
    case "HelpCenterText":
      return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
        HelpCenterText,
        {
          text: item[1].text,
          textStyle: item[1].textStyle
        },
        `help-center-header-item-${item[1].text}`
      );
    case "HelpCenterDivider":
      return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(HelpCenterDivider, {});
    case "HelpCenterNewLine":
      return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("br", {});
    case "HelpCenterReplayTour":
      return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(HelpCenterReplayTour, { title: item[1].text, icon: item[1].icon });
    default:
      return null;
  }
}, "HelpCenterItemRenderer");

// src/modules/container/components/helpCenterV2/aiAssistantLink/HelpCenterAIAssistantLink.tsx
var import_uik51 = require("@appd/uik");
var import_jsx_runtime43 = require("react/jsx-runtime");
var aiLogo = require_ai_logo_small();
var { SPACING: SPACING23 } = import_uik51.TOKENS;
var HelpCenterAIAssistantLink = /* @__PURE__ */ __name(() => {
  const LINK_TEXT = "Ask the AI Assistant";
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: STYLES11.TOP_LINK,
      onClick: () => ShellEvent.emit(ShellEventTypes.HELP_CENTER_AI_LINK_CLICKED),
      "data-testid": "help-center-ai-assistant-link",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("img", { src: aiLogo, alt: "logo" }),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("span", { children: LINK_TEXT }),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("span", { className: (0, import_uik51.css)({ paddingRight: SPACING23[3] }), children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_uik51.Tag.Colored, { color: 7, children: "Beta" }) }),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_uik51.Icon.Navigation.ArrowRight, {})
      ]
    }
  );
}, "HelpCenterAIAssistantLink");

// src/modules/container/components/helpCenterV2/defaultPageComponents/DefaultTopContent.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");
var DefaultTopContent = /* @__PURE__ */ __name(({
  appHelpCenterItems
}) => {
  const { flagsStoreKey } = (0, import_react30.useContext)(ShellContainerContext);
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)("div", { "data-testid": "help-center-default-top-content", children: [
    getFlagValue(flagsStoreKey, "ENABLE_AI_ASSISTANT") && /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(HelpCenterAIAssistantLink, {}),
    appHelpCenterItems && appHelpCenterItems?.topItems ? appHelpCenterItems.topItems.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
      HelpCenterItemRenderer,
      {
        item,
        helpCenterSection: "topItems"
      },
      `help-center-top-${index}`
    )) : null
  ] });
}, "DefaultTopContent");

// src/modules/container/components/helpCenterV2/guide/STYLES.ts
var import_uik52 = require("@appd/uik");
var { SPACING: SPACING24 } = import_uik52.MAGNETIC_TOKENS;
var STYLES13 = {
  HEADER: (0, import_uik52.css)({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "20px"
  }),
  DESCRIPTION: (0, import_uik52.css)({
    ...DEFAULT_TEXT_FONT,
    paddingTop: SPACING24[3]
  })
};

// src/modules/container/components/helpCenterV2/guide/guideSectionItem/STYLES.ts
var import_uik53 = require("@appd/uik");
var { SPACING: SPACING25 } = import_uik53.MAGNETIC_TOKENS;
var STYLES14 = {
  CONTAINER: (0, import_uik53.css)({
    paddingTop: SPACING25[2],
    paddingBottom: SPACING25[2]
  }),
  TITLE: (0, import_uik53.css)({
    paddingBottom: SPACING25[1]
  })
};

// src/modules/container/components/helpCenterV2/guide/guideSectionItem/HelpCenterGuideSectionItem.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");
var HelpCenterGuideSectionItem = /* @__PURE__ */ __name(({ title, items }) => /* @__PURE__ */ (0, import_jsx_runtime45.jsxs)("div", { className: STYLES14.CONTAINER, children: [
  title ? /* @__PURE__ */ (0, import_jsx_runtime45.jsx)("div", { className: STYLES14.TITLE, children: /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(HelpCenterItemRenderer, { item: title, helpCenterSection: "guide" }) }) : null,
  items.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(HelpCenterItemRenderer, { item, helpCenterSection: "guide" }, `help-center-guide-section-item-${index}`)
  ))
] }), "HelpCenterGuideSectionItem");

// src/modules/container/components/helpCenterV2/guide/guideSection/STYLES.ts
var import_uik54 = require("@appd/uik");
var { SPACING: SPACING26 } = import_uik54.MAGNETIC_TOKENS;
var STYLES15 = {
  DESCRIPTION: (0, import_uik54.css)({
    ...DEFAULT_TEXT_FONT,
    paddingTop: SPACING26[3]
  }),
  CONTAINER: (0, import_uik54.css)({
    paddingTop: SPACING26[2],
    paddingBottom: SPACING26[2]
  })
};

// src/modules/container/components/helpCenterV2/guide/guideSection/HelpCenterGuideSection.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
var HelpCenterGuideSection = /* @__PURE__ */ __name(({
  title,
  descriptionText,
  sectionItems
}) => /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("div", { children: [
  /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(HelpCenterDivider, {}),
  /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("div", { className: STYLES15.CONTAINER, children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(HelpCenterItemRenderer, { item: title, helpCenterSection: "guide" }) : null,
    descriptionText ? /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("div", { className: STYLES15.DESCRIPTION, children: descriptionText }) : null
  ] }),
  sectionItems.map((sectionItem, index) => /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
    HelpCenterGuideSectionItem,
    {
      title: sectionItem[1].title,
      items: sectionItem[2]
    },
    `help-center-guide-section-${index}`
  ))
] }), "HelpCenterGuideSection");

// src/modules/container/components/helpCenterV2/guide/HelpCenterGuideComponent.tsx
var import_jsx_runtime47 = require("react/jsx-runtime");
var HelpCenterGuideComponent = /* @__PURE__ */ __name(({ title, descriptionText, sections }) => /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)("div", { children: [
  title ? /* @__PURE__ */ (0, import_jsx_runtime47.jsx)("div", { className: STYLES13.HEADER, children: title }) : null,
  descriptionText ? /* @__PURE__ */ (0, import_jsx_runtime47.jsx)("div", { className: STYLES13.DESCRIPTION, children: descriptionText }) : null,
  sections.map((section, index) => /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    HelpCenterGuideSection,
    {
      title: section[1].title,
      descriptionText: section[1].descriptionText,
      sectionItems: section[2]
    },
    `help-center-guide-section${index}`
  ))
] }), "HelpCenterGuideComponent");

// src/modules/container/components/helpCenterV2/defaultPageComponents/STYLES.ts
var import_uik55 = require("@appd/uik");
var { SPACING: SPACING27 } = import_uik55.MAGNETIC_TOKENS;
var STYLES16 = {
  GUIDE_CONTAINER: (0, import_uik55.css)({
    padding: SPACING27[6]
  })
};

// src/modules/container/components/helpCenterV2/defaultPageComponents/DefaultGuideContent.tsx
var import_jsx_runtime48 = require("react/jsx-runtime");
var DefaultGuideContent = /* @__PURE__ */ __name(({
  appHelpCenterItems
}) => /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("div", { "data-testid": "help-center-default-guide-content", className: STYLES16.GUIDE_CONTAINER, children: appHelpCenterItems && appHelpCenterItems?.guide ? /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
  HelpCenterGuideComponent,
  {
    title: appHelpCenterItems.guide[1].title,
    descriptionText: appHelpCenterItems.guide[1].descriptionText,
    sections: appHelpCenterItems.guide[2]
  }
) : null }), "DefaultGuideContent");

// src/modules/container/components/helpCenterV2/HelpCenterV2.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");
var {
  STATIC: { HEADER_ICON: HEADER_ICON5 }
} = import_uik56.MAGNETIC_TOKENS;
var HelpCenterPortal = /* @__PURE__ */ __name((portalToggleProps) => {
  const { closed, children } = portalToggleProps;
  const portalRef = (0, import_react31.useRef)(null);
  if (closed) {
    return null;
  }
  portalRef.current = document.getElementById("fso-shell-help-center-root");
  if (portalRef == null || portalRef.current == null) {
    return null;
  }
  const portalElement = /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { className: STYLES7.HELP_CENTER_PORTAL, children }, "portal-help-center-root");
  return import_react_dom2.default.createPortal(portalElement, portalRef.current);
}, "HelpCenterPortal");
var sendTelemetryEvent4 = /* @__PURE__ */ __name((pageName) => {
  const telemetryProperties = {
    event: "Help Center",
    properties: {
      page: pageName,
      clickSection: "Help center icon"
    }
  };
  TrackingService.sendEvent(telemetryProperties).catch((error) => console.error(error));
}, "sendTelemetryEvent");
var HelpCenterV2 = /* @__PURE__ */ __name(({ pageName, style }) => {
  const [closed, setClosed] = (0, import_react31.useState)(true);
  const [appVersion, setAppVersion] = (0, import_react31.useState)("");
  const [appHelpCenterItems, setAppHelpCenterItems] = (0, import_react31.useState)();
  const { appName: appName2, appTitle, tenantId } = (0, import_react31.useContext)(ShellContainerContext);
  const [pages, setPages] = (0, import_react31.useState)([]);
  const [currentPreferences, setCurrentPreferences] = (0, import_react31.useState)();
  const layerId = `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`;
  const { getPreferences: getPreferences2, setPreferences: setPreferences2 } = usePreferences(layerId, "LOCALUSER" /* LOCALUSER */);
  const onIconClick = /* @__PURE__ */ __name(() => {
    sendTelemetryEvent4(pageName ?? "");
    ShellEvent.emit(ShellEventTypes.HELP_CENTER_OPEN);
  }, "onIconClick");
  const noItems = /* @__PURE__ */ __name(() => !appHelpCenterItems || appHelpCenterItems.topItems?.length === 0 && !appHelpCenterItems.guide, "noItems");
  const handleErrorSetPrefs = /* @__PURE__ */ __name(() => console.error("Error setting user preferences"), "handleErrorSetPrefs");
  const defaultHelpCenterPage = (0, import_react31.useMemo)(
    () => ({
      title: "Help & Support",
      topContent: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(DefaultTopContent, { appHelpCenterItems }),
      mainContent: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(DefaultGuideContent, { appHelpCenterItems })
    }),
    [appHelpCenterItems]
  );
  const aiPage = (0, import_react31.useMemo)(
    () => ({
      title: "AI Assistant",
      mainContent: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(import_fso_ui_shell_ai_assistant.AIAssistant, { isCSaas: false, isHelpCenter: true })
    }),
    []
  );
  const getAppHelpCenterItems = /* @__PURE__ */ __name(async () => {
    const helpCenterItemsResponse = await getHelpCenterItems(tenantId, `layerId eq "${appName2}"&fields=data`);
    const helpCenterItems = helpCenterItemsResponse.items[0]?.data?.helpCenterItems;
    setAppHelpCenterItems(helpCenterItems);
    setSelectedAppHelpCenterItems(helpCenterItems);
  }, "getAppHelpCenterItems");
  const getAppVersion = /* @__PURE__ */ __name(async () => {
    const appVersionResponse = await getSolutionVersion(
      tenantId,
      `data.solutionName+eq+%22${appName2}%22+and+data.tag+eq+%22stable%22+and+data.isSuccessful+eq+%22true%22&max=1`
    );
    const version = appVersionResponse && appVersionResponse.items && appVersionResponse.items.length ? appVersionResponse.items[0].data.solutionVersion : "-";
    setAppVersion(version);
    setSelectedAppVersion(version);
  }, "getAppVersion");
  (0, import_react31.useEffect)(() => {
    if (tenantId !== "" && appName2 !== "") {
      getAppHelpCenterItems().catch(reportError);
      getAppVersion().catch(reportError);
    }
  }, [tenantId, appName2]);
  (0, import_react31.useEffect)(() => {
    setPages([defaultHelpCenterPage]);
    const openState = /* @__PURE__ */ __name(() => {
      setClosed(false);
    }, "openState");
    const closedState = /* @__PURE__ */ __name(() => {
      setPages([defaultHelpCenterPage]);
      setClosed(true);
    }, "closedState");
    ShellEvent.on(ShellEventTypes.HELP_CENTER_OPEN, openState);
    ShellEvent.on(ShellEventTypes.HELP_CENTER_CLOSED, closedState);
    return () => {
      ShellEvent.un(ShellEventTypes.HELP_CENTER_OPEN, openState);
      ShellEvent.un(ShellEventTypes.HELP_CENTER_CLOSED, closedState);
    };
  }, [defaultHelpCenterPage]);
  (0, import_react31.useEffect)(() => {
    const fetchPreferences = /* @__PURE__ */ __name(async () => {
      const allPreferences = await getPreferences2(`data.appName eq "${CONSTANTS.SHELL_APP}"`);
      return filterPreferencesByLayerType(allPreferences, "LOCALUSER" /* LOCALUSER */);
    }, "fetchPreferences");
    const handleLinkClicked = /* @__PURE__ */ __name(() => {
      fetchPreferences().then((preferences) => {
        if (!preferences || preferences.data.preferences.showAIAssistantTour !== false) {
          setCurrentPreferences(preferences);
          ShellEvent.emit(ShellEventTypes.HELP_CENTER_SHOW_AI_TOUR);
        } else {
          setPages([defaultHelpCenterPage, aiPage]);
        }
      }).catch(() => {
        console.error("Error fetching user preferences");
        setPages([defaultHelpCenterPage, aiPage]);
      });
    }, "handleLinkClicked");
    ShellEvent.on(ShellEventTypes.HELP_CENTER_AI_LINK_CLICKED, handleLinkClicked);
    return () => {
      ShellEvent.un(ShellEventTypes.HELP_CENTER_AI_LINK_CLICKED, handleLinkClicked);
    };
  }, [aiPage, defaultHelpCenterPage, getPreferences2, setCurrentPreferences]);
  (0, import_react31.useEffect)(() => {
    const handleAITourExit = /* @__PURE__ */ __name(() => {
      if (currentPreferences) {
        const preferenceData = currentPreferences.data;
        const updatedPrefs = {
          ...currentPreferences,
          data: {
            ...currentPreferences.data,
            preferences: {
              ...preferenceData.preferences,
              showAIAssistantTour: false
            }
          }
        };
        setPreferences2({
          data: updatedPrefs.data,
          layerType: "LOCALUSER" /* LOCALUSER */,
          layerId: updatedPrefs.layerId,
          id: updatedPrefs.id
        }).catch(handleErrorSetPrefs);
      } else {
        setPreferences2({
          data: {
            appName: CONSTANTS.SHELL_APP,
            preferences: {
              showAIAssistantTour: false
            }
          },
          layerType: "LOCALUSER" /* LOCALUSER */,
          layerId
        }).catch(handleErrorSetPrefs);
      }
      setPages([defaultHelpCenterPage, aiPage]);
    }, "handleAITourExit");
    ShellEvent.on(ShellEventTypes.HELP_CENTER_AI_TOUR_COMPLETED, handleAITourExit);
    return () => {
      ShellEvent.un(ShellEventTypes.HELP_CENTER_AI_TOUR_COMPLETED, handleAITourExit);
    };
  }, [currentPreferences, layerId, setPreferences2, defaultHelpCenterPage, aiPage]);
  const onBackClicked = /* @__PURE__ */ __name(() => {
    const newStack = pages.slice(0, -1);
    if (pages.length > 1) {
      setPages(newStack);
    }
  }, "onBackClicked");
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(import_jsx_runtime49.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(import_uik56.Tooltip, { value: "Help Center", children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
      import_uik56.Button,
      {
        style,
        className: (0, import_uik56.css)({ ...STYLES7.BUTTON_HELP, ...ButtonStyles.SHELL_BUTTON_STYLES }),
        icon: "Action.HelpCenter",
        iconColor: HEADER_ICON5,
        type: "TERTIARY",
        onClick: onIconClick,
        tabIndex: 0,
        "data-testid": "help-center-toggle"
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(HelpCenterPortal, { closed, children: [
      /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)("div", { className: STYLES7.HELP_CENTER_HEADER, children: [
        pages.length > 1 ? /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          import_uik56.Button,
          {
            className: STYLES7.HELP_CENTER_HEADER_BACK,
            onClick: onBackClicked,
            type: "TERTIARY",
            icon: "Navigation.ChevronLeft",
            "data-testid": "help-center-back-btn"
          }
        ) : null,
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { className: STYLES7.HELP_CENTER_HEADER_TEXT, "data-testid": "main-header", children: pages[pages.length - 1]?.title }),
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          import_uik56.Button,
          {
            onClick: () => ShellEvent.emit(ShellEventTypes.HELP_CENTER_CLOSED),
            type: "TERTIARY",
            icon: "Action.Disable"
          }
        )
      ] }),
      noItems() ? /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(EmptyState, {}) : /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(import_jsx_runtime49.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { className: STYLES7.HELP_CENTER_TOP_CONTENT, "data-testid": "help-center-top-content", children: pages[pages.length - 1]?.topContent }),
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { className: STYLES7.HELP_CENTER_MAIN_CONTENT, "data-testid": "help-center-guide-content", children: pages[pages.length - 1]?.mainContent })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { className: STYLES7.HELP_CENTER_FOOTER, children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(Version, { appName: appTitle, productVersion: appVersion }) })
    ] })
  ] });
}, "HelpCenterV2");

// src/modules/container/components/brand/BrandCisco.tsx
var import_uik58 = require("@appd/uik");
var import_react32 = require("react");

// src/modules/container/components/brand/STYLES.tsx
var import_uik57 = require("@appd/uik");
var import_jsx_runtime50 = require("react/jsx-runtime");
var {
  RADIUS: RADIUS2,
  SPACING: SPACING28,
  COLORS: { INVERSE_TEXT: INVERSE_TEXT7 }
} = import_uik57.MAGNETIC_TOKENS;
var defaultLinkStyles = {
  ":focus": {
    boxShadow: "none"
  },
  ":focus-visible": {
    borderRadius: RADIUS2.DEFAULT
  }
};
var STYLES17 = {
  CISCO_STYLES: (0, import_uik57.css)({
    color: "#FFFFFF",
    marginTop: 6,
    marginLeft: 22,
    marginRight: 0,
    "& a": {
      ...defaultLinkStyles,
      "& svg": {
        height: 23
      }
    }
  }),
  TOP_NAV_PROD_LABEL: (0, import_uik57.css)({
    fontSize: 19,
    color: INVERSE_TEXT7,
    whiteSpace: "nowrap",
    marginLeft: 10,
    marginRight: SPACING28[4]
  })
};
var CISCO_LOGO = /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)("svg", { "data-testid": "brand-cisco-logo", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 90 55", children: [
  /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("g", { clipPath: "url(#type-cisco-dark-yes-old-no__a)", children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
    "path",
    {
      fill: "#fff",
      d: "M29.534 31.954h-3.961V47.81h3.96V31.954Zm19.982 7.928c0 5.112 3.914 8.211 8.37 8.211 1.76 0 3.112-.419 3.613-.566V43.27c-.17.089-1.47.839-3.329.839-2.645 0-4.345-1.878-4.345-4.233 0-2.355 1.777-4.232 4.345-4.232 1.89 0 3.17.773 3.33.85v-4.257c-.372-.112-1.754-.566-3.613-.566-4.83 0-8.371 3.465-8.371 8.205v.006Zm-41.37 0c0 5.112 3.908 8.211 8.36 8.211 1.77 0 3.122-.419 3.618-.566V43.27c-.177.089-1.47.839-3.33.839-2.644 0-4.35-1.878-4.35-4.233 0-2.355 1.777-4.232 4.35-4.232 1.89 0 3.165.773 3.33.85v-4.257c-.372-.112-1.753-.566-3.619-.566-4.823 0-8.359 3.465-8.359 8.205v.006Zm65.827-8.205c-4.835 0-8.294 3.671-8.294 8.205 0 4.534 3.465 8.211 8.294 8.211 4.829 0 8.294-3.677 8.294-8.211 0-4.534-3.465-8.205-8.294-8.205Zm0 12.379c-2.356 0-4.103-1.866-4.103-4.174 0-2.308 1.748-4.168 4.103-4.168 2.355 0 4.103 1.872 4.103 4.168 0 2.296-1.754 4.174-4.103 4.174ZM41.93 38.24l-1.092-.353c-.65-.207-1.818-.55-1.818-1.506 0-.767.862-1.304 2.45-1.304 1.364 0 3.04.466 3.1.484v-3.389c-.119-.03-1.931-.507-3.862-.507-3.66 0-5.856 1.995-5.856 4.958 0 2.627 1.848 3.938 4.05 4.634.248.083.608.195.85.278.98.313 1.765.773 1.765 1.57 0 .903-.903 1.482-2.88 1.482-1.73 0-3.395-.502-3.743-.59v3.654c.2.04 2.172.43 4.28.43 3.034 0 6.505-1.34 6.505-5.324 0-1.93-1.175-3.713-3.743-4.534l-.006.018ZM1.972 12.94C.892 12.94 0 13.83 0 14.917v4.162c0 1.104.891 1.984 1.972 1.984 1.08 0 1.965-.88 1.965-1.984v-4.162c0-1.092-.88-1.977-1.965-1.977Zm10.808 8.123c1.087 0 1.972-.88 1.972-1.984V9.451a1.985 1.985 0 0 0-1.972-1.983 1.977 1.977 0 0 0-1.965 1.983v9.628a1.97 1.97 0 0 0 1.966 1.984ZM23.595 0a1.976 1.976 0 0 0-1.972 1.978v21.056c0 1.098.886 1.99 1.972 1.99a1.978 1.978 0 0 0 1.966-1.99V1.978A1.975 1.975 0 0 0 23.595 0ZM36.37 19.08V9.45c0-1.086-.88-1.983-1.966-1.983a1.976 1.976 0 0 0-1.966 1.983v9.628c0 1.104.886 1.984 1.966 1.984s1.965-.88 1.965-1.984Zm8.842-6.14a1.98 1.98 0 0 0-1.971 1.977v4.162c0 1.104.885 1.984 1.971 1.984 1.087 0 1.954-.88 1.954-1.984v-4.162c0-1.092-.88-1.977-1.953-1.977Zm10.815 8.123c1.08 0 1.966-.88 1.966-1.984V9.451c0-1.086-.88-1.983-1.966-1.983a1.97 1.97 0 0 0-1.96 1.983v9.628c0 1.104.874 1.984 1.96 1.984Zm12.775 1.971V1.978A1.966 1.966 0 0 0 66.842 0c-1.086 0-1.96.885-1.96 1.978v21.056c0 1.098.88 1.99 1.96 1.99s1.96-.892 1.96-1.99Zm8.831-1.971a1.97 1.97 0 0 0 1.983-1.984V9.451c0-1.086-.88-1.983-1.983-1.983-1.104 0-1.96.89-1.96 1.983v9.628c0 1.104.88 1.984 1.96 1.984Zm10.82-8.123a1.97 1.97 0 0 0-1.96 1.977v4.162c0 1.104.874 1.984 1.96 1.984 1.087 0 1.96-.88 1.96-1.984v-4.162a1.974 1.974 0 0 0-1.96-1.977Z"
    }
  ) }),
  /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("clipPath", { id: "type-cisco-dark-yes-old-no__a", children: /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("path", { fill: "#fff", d: "M0 0h90v55H0z" }) }) })
] });

// src/modules/container/components/brand/BrandCisco.tsx
var import_jsx_runtime51 = require("react/jsx-runtime");
var BrandCisco = /* @__PURE__ */ __name(() => {
  const isLocal2 = window.location.hostname.includes("localhost");
  const isAppdTest2 = window.location.hostname.includes("appd-test.com");
  const identityApiUrl = isLocal2 || isAppdTest2 ? CONSTANTS.IDENTITY_API_URL_FOR_LOCAL : CONSTANTS.IDENTITY_API_URL;
  const { data: userData, isLoading, error } = useSWRPreConfigured(identityApiUrl);
  const { appSwitcher } = (0, import_react32.useContext)(ShellContainerContext);
  const hrefHandler = /* @__PURE__ */ __name((e) => {
    e.preventDefault();
    if (!isLoading && !error) {
      const allApps = appSwitcher?.props?.apps;
      const isAdmin = userData?.user.is_admin;
      const destinationAppName = isAdmin === true || String(isAdmin).toLowerCase() === "true" ? CONSTANTS.PLATFORM_APP_LAYERID : getAppName();
      const destinationApp = allApps?.find((app) => app.name === destinationAppName);
      if (destinationApp) {
        const { homePageUri } = destinationApp;
        window.location.href = destinationApp.name !== void 0 ? getAppHomePageLink(homePageUri, destinationApp.name) : "/";
      }
    }
  }, "hrefHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsxs)(import_jsx_runtime51.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("div", { className: STYLES17.CISCO_STYLES, "data-testid": "brand-cisco", children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("a", { href: "/", className: (0, import_uik58.css)({ textDecoration: "none" }), onClick: hrefHandler, children: CISCO_LOGO }) }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("div", { className: STYLES17.TOP_NAV_PROD_LABEL, "data-testid": "product-label", children: "Observability Platform" }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(SeparatorComponent_default, {})
  ] });
}, "BrandCisco");

// src/modules/container/components/aiModalButton/aiModalButton.tsx
var import_fso_ui_shell_ai_assistant2 = require("@appd/fso-ui-shell-ai-assistant");
var import_uik60 = require("@appd/uik");
var import_react33 = require("react");

// src/modules/container/components/aiModalButton/STYLES.ts
var import_uik59 = require("@appd/uik");
var {
  COLORS: { DEFAULT_TEXT_STRONG, DEFAULT_TEXT: DEFAULT_TEXT8, INTERACT_ICON, INTERACT_ICON_WEAK_DISABLED, CONTROL_BG },
  RADIUS: RADIUS3,
  TYPOGRAPHY: { BODY }
} = import_uik59.MAGNETIC_TOKENS;
var BASE_MODAL = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: CONTROL_BG,
  borderRadius: RADIUS3.HEAVY,
  overflow: "hidden",
  position: "sticky"
};
var STYLES18 = {
  HOST: (0, import_uik59.css)({
    "::-webkit-scrollbar": { display: "none" },
    height: "var(--scrollHeight)",
    left: 0,
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)",
    marginBottom: -import_uik59.utils.CSS_MAX_NUMBER,
    marginRight: -import_uik59.utils.CSS_MAX_NUMBER,
    overscrollBehavior: "none",
    scrollbarWidth: "none",
    overflow: "scroll"
  }),
  BACKDROP: (0, import_uik59.css)({
    left: 0,
    top: 0,
    height: "101%",
    position: "absolute",
    width: "100%"
  }),
  FRAME: (0, import_uik59.css)({
    ...BODY.DEFAULT,
    color: DEFAULT_TEXT8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
    overflow: "hidden",
    position: "sticky",
    top: 0,
    left: 0
  }),
  CONTENT: (0, import_uik59.css)({
    display: "flex",
    flexWrap: "nowrap",
    overflow: "hidden",
    alignSelf: "flex-start",
    height: "100%",
    width: "100%"
  }),
  SLIDE: (0, import_uik59.css)({
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden"
  }),
  INDICATOR: (0, import_uik59.css)({
    paddingTop: 24,
    display: "flex",
    justifyContent: "center",
    gap: 12
  }),
  DOT: (0, import_uik59.css)({
    background: INTERACT_ICON_WEAK_DISABLED,
    width: 12,
    height: 12,
    borderRadius: "50%"
  }),
  MODAL: (0, import_uik59.css)({
    ...BASE_MODAL,
    height: 800,
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.60), 0px 4px 40px 0px rgba(0, 0, 0, 0.25)"
  }),
  FULLSCREEN_MODAL: (0, import_uik59.css)({
    ...BASE_MODAL,
    marginTop: "56px",
    height: "calc(100% - 56px)",
    width: "100%"
  }),
  IMAGE_CONTAINER: (0, import_uik59.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
    width: "100%",
    overflow: "hidden"
  }),
  TEXT_CONTAINER: (0, import_uik59.css)({
    display: "flex",
    padding: "24px 60px 0 60px",
    flexDirection: "column",
    alignItems: "center",
    gap: 8
  }),
  TITLE: (0, import_uik59.css)({
    fontWeight: 700,
    lineHeight: "34px",
    fontSize: "24px",
    textAlign: "center",
    color: DEFAULT_TEXT_STRONG,
    width: 600
  }),
  DESCRIPTION: (0, import_uik59.css)({
    fontWeight: 400,
    lineHeight: "22px",
    fontSize: "16px",
    textAlign: "center",
    color: DEFAULT_TEXT8,
    width: 600
  }),
  ACTIVE: (0, import_uik59.css)({
    background: INTERACT_ICON
  }),
  FOOTER: (0, import_uik59.css)({
    width: "100%"
  }),
  FOOTER_ACTIONS: (0, import_uik59.css)({
    display: "flex",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  }),
  SLIDE_ACTIONS: (0, import_uik59.css)({
    display: "flex",
    gap: 8
  }),
  IMAGE: (0, import_uik59.css)({
    transform: "scale(1.18)"
  })
};

// src/modules/container/components/aiModalButton/aiModalButton.tsx
var import_jsx_runtime52 = require("react/jsx-runtime");
var AIModalOverlay = /* @__PURE__ */ __name(({ closed, onCloseClick }) => {
  const { flagsStoreKey, appName: appName2 } = (0, import_react33.useContext)(ShellContainerContext);
  const isAITrainingEnabled = getFlagValue(flagsStoreKey, "ENABLE_AI_TRAINING") === true;
  const [isFullScreen, setIsFullScreen] = (0, import_react33.useState)(false);
  const modalStyles = isFullScreen ? STYLES18.FULLSCREEN_MODAL : STYLES18.MODAL;
  const toggleFullScreen = /* @__PURE__ */ __name(() => {
    setIsFullScreen(!isFullScreen);
  }, "toggleFullScreen");
  const setFullScreen = /* @__PURE__ */ __name((value) => {
    setIsFullScreen(value);
  }, "setFullScreen");
  if (closed) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(import_uik60.Overlay.Provider, { promote: Infinity, children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(import_uik60.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)("div", { className: STYLES18.HOST, children: [
    !isFullScreen && /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: STYLES18.BACKDROP }),
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: STYLES18.FRAME, children: /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)("div", { className: modalStyles, children: [
      /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: STYLES18.CONTENT, children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
        import_fso_ui_shell_ai_assistant2.AIChatWindow,
        {
          onCloseClick,
          isAITrainingEnabled,
          toggleFullScreen,
          isFullScreen,
          setFullScreen,
          isCSaas: false,
          appId: appName2,
          appName: appName2
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: STYLES18.FOOTER })
    ] }) })
  ] }) }) });
}, "AIModalOverlay");
var AIModalButtonComponent = /* @__PURE__ */ __name(({ style }) => {
  const [tooltipText, setTooltipText] = (0, import_react33.useState)("Launch AI Assistant");
  const [closed, setClosed] = (0, import_react33.useState)(true);
  const aiTrigger = require_aiModalTrigger();
  const onToggle = (0, import_react33.useCallback)(() => {
    setClosed(!closed);
  }, [closed]);
  const onIconClick = /* @__PURE__ */ __name(() => {
    onToggle();
  }, "onIconClick");
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)(import_jsx_runtime52.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(import_uik60.Tooltip, { onMouseOver: () => setTooltipText("Launch AI Assistant"), value: tooltipText, children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
      import_uik60.Button,
      {
        style,
        className: (0, import_uik60.css)(ButtonStyles.SHELL_BUTTON_STYLES),
        type: "TERTIARY",
        onClick: onIconClick,
        tabIndex: 0,
        "data-testid": "ai-modal-icon",
        children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("img", { src: aiTrigger, alt: "submit" })
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(AIModalOverlay, { closed, onCloseClick: onToggle })
  ] });
}, "AIModalButtonComponent");
var aiModalButton_default = AIModalButtonComponent;

// src/modules/container/builder/TopNavBuilder.tsx
var import_jsx_runtime53 = require("react/jsx-runtime");
var { TOP_NAV, LEFT_CONTAINER: LEFT_CONTAINER2, RIGHT_CONTAINER: RIGHT_CONTAINER2 } = STYLES6;
var componentList = /* @__PURE__ */ __name((key, isPageHeaderEnabled, isAIModalEnabled) => {
  const list = {
    separator: SeparatorComponent_default,
    refresh: RefreshComponent_default,
    logout: LogoutComponent_default,
    ...isPageHeaderEnabled ? {} : { breadcrumbs: BreadcrumbsComponent },
    label: LabelComponent_default,
    helpCenter: HelpCenterV2,
    miniProfile: MiniProfile,
    shareButton: ShareButtonComponent_default,
    display: DisplayComponent,
    ...isPageHeaderEnabled ? {} : { timeRangeV2: TimeRangeComponentV2_default },
    appSwitcher: appSwitcher_default,
    exchange: ExchangeComponent_default,
    ...isAIModalEnabled ? { aiModal: aiModalButton_default } : {}
  };
  return list[key];
}, "componentList");
var TopNavBuilder = /* @__PURE__ */ __name(({ config, router, isPageHeaderEnabled }) => {
  const { appSwitcher, flagsStoreKey } = (0, import_react34.useContext)(ShellContainerContext);
  const { pageTitle } = (0, import_react34.useContext)(PageHeaderContext);
  const routerObj = (0, import_react34.useMemo)(() => ({ router }), [router]);
  const isAIModalEnabled = getFlagValue(flagsStoreKey, "ENABLE_AI_MODAL");
  const showPageHeader = isPageHeaderEnabled && getFlagValue(flagsStoreKey, "PAGE_HEADER_ENABLED") && pageTitle !== void 0 && pageTitle !== "";
  const generatePlugins = /* @__PURE__ */ __name((pluginsArray) => pluginsArray.map((plugin) => {
    const Component = componentList(plugin.name, showPageHeader, isAIModalEnabled);
    const style = plugin.style ? { ...plugin.style } : {};
    style.display = plugin.visible && !currentUrlInList(plugin.hideOnUrls) ? void 0 : "none";
    const props = plugin.props ? plugin.props : {};
    props.style = style;
    if (Component) {
      return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(Component, { ...props }, plugin.name);
    }
    if (plugin.name === "custom" && plugin.remoteUrl !== void 0 && plugin.selector !== void 0) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = plugin.remoteUrl;
      document.body.appendChild(script);
      const CustomSelector = plugin.selector;
      return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(CustomSelector, { ...props }, plugin.name);
    }
    return void 0;
  }), "generatePlugins");
  let exchangeExist = false;
  let miniProfileExist = false;
  config.rightPlugins.forEach((item) => {
    if (item.name === "exchange") {
      exchangeExist = true;
    }
    if (item.name === "miniProfile") {
      miniProfileExist = true;
    }
  });
  if (!exchangeExist) {
    config.rightPlugins.push({
      name: "exchange",
      visible: true
    });
  }
  if (!miniProfileExist) {
    config.rightPlugins.push({
      name: "miniProfile",
      visible: true,
      props: {
        onLogoutClickEvent: "logoutClicked"
      }
    });
  }
  const sortedRightPlugins = pluginSort(config.rightPlugins, "right");
  let sortedLeftPlugins = pluginSort(config.leftPlugins, "left");
  if (appSwitcher) {
    sortedLeftPlugins.push(appSwitcher);
    sortedLeftPlugins = pluginSort(sortedLeftPlugins, "left");
  }
  const rightPlugins = generatePlugins(sortedRightPlugins);
  const leftPlugins = generatePlugins(sortedLeftPlugins);
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(RouterContext.Provider, { value: routerObj, children: /* @__PURE__ */ (0, import_jsx_runtime53.jsxs)("div", { className: (0, import_uik61.css)({ ...TOP_NAV }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(BrandCisco, {}),
    /* @__PURE__ */ (0, import_jsx_runtime53.jsx)("div", { className: (0, import_uik61.css)({ ...LEFT_CONTAINER2 }), children: leftPlugins }),
    /* @__PURE__ */ (0, import_jsx_runtime53.jsx)("div", { className: (0, import_uik61.css)({ ...RIGHT_CONTAINER2 }), children: rightPlugins })
  ] }) });
}, "TopNavBuilder");

// src/modules/container/auth/Authenticator.tsx
var import_fetch_intercept = __toESM(require("fetch-intercept"));
var import_react35 = require("react");
var import_uik62 = require("@appd/uik");
var import_jsx_runtime54 = require("react/jsx-runtime");
var Authenticator = /* @__PURE__ */ __name(({ disabled, children }) => {
  (0, import_react35.useEffect)(() => {
    if (disabled) {
      return;
    }
    const checkAuth = /* @__PURE__ */ __name(async () => fetch("/session/api/auth/auth", {
      method: "GET"
    }), "checkAuth");
    import_fetch_intercept.default.register({
      response(response) {
        if (response.status === 401 && !response.url.includes("/auth/auth") && response.url.includes("/api/") && response.url.includes(window.location.hostname)) {
          checkAuth().then((result) => {
            if (result.status === 401) {
              signIn();
            } else {
              (0, import_uik62.toast)({
                description: `${response.url} Unauthorized`,
                icon: "ERROR",
                title: "401 Unauthorized"
              });
            }
          });
        }
        return response;
      }
    });
    checkAuth().then((result) => {
      if (result.status === 401) {
        signIn();
        return;
      }
      if (result.status === 202) {
        const sub = result.headers.get("X-Auth-Sub");
        sessionStorage.setItem("appd-next-principal-id", sub ?? "");
        ShellEvent.emit("isShellAuthenticated", true);
        return;
      }
      (0, import_uik62.toast)({
        description: "Session Management Server is down",
        icon: "ERROR",
        title: "Error"
      });
    });
  }, [disabled]);
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(import_jsx_runtime54.Fragment, { children });
}, "Authenticator");
var Authenticator_default = Authenticator;

// src/modules/container/components/nav/Nav.tsx
var import_uik76 = require("@appd/uik");
var import_react43 = require("react");

// src/modules/container/components/nav/getStyles.ts
var import_uik64 = require("@appd/uik");

// src/modules/container/components/nav/FADE_IN.ts
var import_uik63 = require("@appd/uik");
var {
  MOTION: {
    EASING: { DECELERATE }
  }
} = import_uik63.MAGNETIC_TOKENS;
var FADE_IN = {
  animationDuration: "0.6s",
  animationFillMode: "forwards",
  animationName: {
    "0%": { opacity: 0 },
    "33%": { opacity: 0 },
    "100%": { opacity: 1 }
  },
  animationTimingFunction: DECELERATE
};

// src/modules/container/components/nav/getStyles.ts
var {
  COLORS: { DEFAULT_BG: DEFAULT_BG2, CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK8 },
  MOTION: { DURATION, EASING },
  SPACING: SPACING29
} = import_uik64.MAGNETIC_TOKENS;
var getStyles5 = /* @__PURE__ */ __name((isCollapsed) => import_uik64.css.Styles({
  ...FADE_IN,
  animationDuration: "400ms",
  background: DEFAULT_BG2,
  borderRight: `solid ${CONTROL_BORDER_WEAK8}`,
  borderRightWidth: 1,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  transition: `width ${DURATION.SLOW} ${EASING.DECELERATE}`,
  width: isCollapsed ? 62 : 210,
  paddingTop: SPACING29[2],
  "> nav": {
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 3,
    "> ul": {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      paddingInlineStart: 0,
      marginBlockStart: 0,
      marginBlockEnd: 0
    }
  }
}), "getStyles");

// src/modules/container/components/nav/item-renderer/NavItemRenderer.tsx
var import_stated_js2 = __toESM(require("stated-js"));
var import_react41 = require("react");
var import_uik74 = require("@appd/uik");
var import_cloneDeep3 = __toESM(require("lodash/cloneDeep"));

// src/modules/container/components/nav/link/NavLink.tsx
var import_uik66 = require("@appd/uik");
var import_react36 = require("react");

// src/modules/container/components/nav/link/getStyles.ts
var import_uik65 = require("@appd/uik");
var {
  COLORS: {
    ACCENT_D,
    CONTROL_ICON_WEAK: CONTROL_ICON_WEAK3,
    DEFAULT_BG_WEAK_ACTIVE,
    DEFAULT_BG_WEAK_HOVER,
    DEFAULT_TEXT: DEFAULT_TEXT9,
    DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM11,
    INTERACT_BORDER_WEAK_ACTIVE
  },
  TYPOGRAPHY: { BODY: BODY2, ELLIPSES: ELLIPSES2, TEXT: TEXT3 }
} = import_uik65.MAGNETIC_TOKENS;
var getStyles6 = /* @__PURE__ */ __name(({ active, isCollapsed }) => import_uik65.css.Styles({
  listStyleType: "none",
  outline: "none",
  ":focus-visible": {
    outline: `${INTERACT_BORDER_WEAK_ACTIVE} auto 3px`
  },
  "> a": {
    alignItems: "center",
    ...active && {
      "&::before": {
        content: "''",
        backgroundColor: ACCENT_D,
        position: "absolute",
        left: 0,
        height: "100%",
        borderRadius: "5px 0 0 5px",
        width: 5
      },
      backgroundColor: DEFAULT_BG_WEAK_ACTIVE
    },
    borderRadius: 8,
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    height: 40,
    justifyContent: "flex-start",
    overflow: "hidden",
    userSelect: "none",
    position: "relative",
    padding: 8,
    ":focus": {
      boxShadow: "none"
    },
    ":hover": {
      textDecoration: "none",
      ...!active && {
        backgroundColor: DEFAULT_BG_WEAK_HOVER,
        "> span": {
          color: DEFAULT_TEXT9
        }
      }
    },
    "> .icon": {
      marginLeft: 6,
      minWidth: 18,
      "& path": {
        fill: active ? ACCENT_D : CONTROL_ICON_WEAK3,
        fillOpacity: "unset"
      }
    },
    "> span": {
      ...active ? TEXT3.ACTION.DEFAULT : BODY2.DEFAULT,
      ...ELLIPSES2.END,
      ...FADE_IN,
      flex: 1,
      fontSize: 14,
      color: active ? DEFAULT_TEXT9 : DEFAULT_TEXT_MEDIUM11,
      ...isCollapsed && { display: "none" },
      marginLeft: 6,
      lineHeight: 16
    }
  }
}), "getStyles");

// src/modules/container/components/nav/utils.ts
var import_isEqual = __toESM(require("lodash/isEqual"));
var isActiveLink = /* @__PURE__ */ __name((path, currentPath) => {
  if (path === "/" && path !== currentPath) {
    return false;
  }
  const currentPathWithoutQueryParams = currentPath.split("?")[0].split("/");
  const pathWithoutQueryParams = path.split("?")[0].split("/");
  const pathLength = pathWithoutQueryParams.length;
  return (0, import_isEqual.default)(currentPathWithoutQueryParams.slice(0, pathLength), pathWithoutQueryParams);
}, "isActiveLink");
var getFlagValueWrapper = /* @__PURE__ */ __name((flagsStoreKey) => (flagName) => getFlagValue(flagsStoreKey, flagName), "getFlagValueWrapper");

// src/modules/container/components/nav/link/NavLink.tsx
var import_jsx_runtime55 = require("react/jsx-runtime");
var NavLink = Object.assign(
  ({ currentPath, icon, isCollapsed, uri, title }) => {
    const { appName: appName2 } = (0, import_react36.useContext)(ShellContainerContext);
    const { setPageNavGroupId } = (0, import_react36.useContext)(PageHeaderContext);
    const path = getFullPathFromUrl(uri, appName2);
    const isActive = isActiveLink(path, currentPath);
    const styles = getStyles6({ active: isActive, isCollapsed });
    (0, import_react36.useEffect)(() => {
      if (isActive) {
        setPageNavGroupId("");
      }
    }, [isActive, setPageNavGroupId]);
    return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_uik66.Tooltip, { position: "RIGHT", style: { left: 4 }, value: title, visible: isCollapsed ? void 0 : false, children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      "li",
      {
        className: (0, import_uik66.css)(styles),
        "data-testid": `nav-link-${title.split(" ").join("-")}`,
        children: /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)(LinkWrapper, { href: path, siteName: uri.site, children: [
          icon && /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_uik66.Icon, { "data-testid": "icon", className: "icon", size: "SMALL", type: icon }),
          /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("span", { "data-testid": "title", children: title })
        ] })
      },
      `nav-link-item-${title}`
    ) });
  },
  { getStyles: getStyles6 }
);

// src/modules/container/components/nav/header/NavHeader.tsx
var import_uik67 = require("@appd/uik");
var import_jsx_runtime56 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT_MEDIUM: DEFAULT_TEXT_MEDIUM12 },
  TYPOGRAPHY: {
    HEADINGS: { PANEL },
    ELLIPSES: ELLIPSES3
  }
} = import_uik67.MAGNETIC_TOKENS;
var STYLES19 = {
  ...ELLIPSES3.END,
  ...PANEL,
  boxSizing: "border-box",
  color: DEFAULT_TEXT_MEDIUM12,
  display: "block",
  height: 18,
  marginBottom: 4,
  marginTop: 12
};
var NavHeader = /* @__PURE__ */ __name(({ title }) => /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("li", { className: (0, import_uik67.css)(STYLES19), "data-testid": "title", children: title }), "NavHeader");

// src/modules/container/components/nav/divider/NavDivider.tsx
var import_uik69 = require("@appd/uik");

// src/modules/container/components/nav/divider/getStyles.ts
var import_uik68 = require("@appd/uik");
var {
  COLORS: { CONTROL_BORDER_WEAK: CONTROL_BORDER_WEAK9 },
  SPACING: SPACING30
} = import_uik68.MAGNETIC_TOKENS;
var getStyles7 = /* @__PURE__ */ __name(() => import_uik68.css.Styles({
  lineHeight: "1px",
  height: "1px",
  backgroundColor: CONTROL_BORDER_WEAK9,
  marginTop: SPACING30[1],
  marginBottom: SPACING30[1]
}), "getStyles");

// src/modules/container/components/nav/divider/NavDivider.tsx
var import_jsx_runtime57 = require("react/jsx-runtime");
var NavDivider = Object.assign(
  () => {
    const styles = getStyles7();
    return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)("li", { className: (0, import_uik69.css)(styles), children: /* @__PURE__ */ (0, import_jsx_runtime57.jsx)("div", { "data-testid": "nav-divider" }) });
  },
  { getStyles: getStyles7 }
);

// src/modules/container/components/nav/group/NavGroup.tsx
var import_uik73 = require("@appd/uik");
var import_react40 = require("react");

// src/modules/container/components/nav/group/getStyles.ts
var import_uik70 = require("@appd/uik");
var getStyles8 = /* @__PURE__ */ __name(({
  hasActiveItem,
  isCollapsed,
  open
}) => import_uik70.css.Styles({
  listStyleType: "none",
  // TODO: use the magnetic based `@appd/uik` <Button> once it covers all the styles from the mocks
  "> .inner-button": import_uik70.utils.let("it", NavLink.getStyles({ active: hasActiveItem, isCollapsed })["> a"]).get((it) => ({
    ...it,
    "> .icon": {
      ...it["> .icon"],
      "&.expand": {
        ...isCollapsed && { display: "none" },
        margin: 0
      }
    },
    "> span": {
      ...it["> span"]
    }
  })),
  "> .second-level-menu": {
    ...FADE_IN,
    listStyle: "none",
    ...(isCollapsed || !open) && { display: "none" },
    paddingLeft: 12
  }
}), "getStyles");

// src/modules/container/components/nav/group-section-link/NavGroupSectionLink.tsx
var import_uik72 = require("@appd/uik");
var import_react37 = require("react");

// src/modules/container/components/nav/group-section-link/getStyles.ts
var import_uik71 = require("@appd/uik");
var getStyles9 = /* @__PURE__ */ __name((active) => import_uik71.css.Styles({
  display: "block",
  marginBottom: 4,
  paddingBottom: 7.5,
  paddingTop: 7.5,
  "> a": {
    ...BODY3.DEFAULT,
    borderRadius: RADIUS4.DEFAULT,
    color: active ? INTERACT_TEXT_ACTIVE : DEFAULT_TEXT10,
    display: "block",
    overflow: "hidden",
    overflowWrap: "normal",
    textOverflow: "ellipsis",
    ":focus": {
      boxShadow: "none"
    },
    ":hover": {
      color: INTERACT_TEXT_HOVER2,
      textDecoration: "none"
    }
  }
}), "getStyles");
var {
  COLORS: { INTERACT_TEXT_ACTIVE, INTERACT_TEXT_HOVER: INTERACT_TEXT_HOVER2, DEFAULT_TEXT: DEFAULT_TEXT10 },
  RADIUS: RADIUS4,
  TYPOGRAPHY: { BODY: BODY3 }
} = import_uik71.MAGNETIC_TOKENS;

// src/modules/container/components/nav/group-section-link/NavGroupSectionLink.tsx
var import_jsx_runtime58 = require("react/jsx-runtime");
var NavGroupSectionLink = /* @__PURE__ */ __name(({ title, uri, currentPath, groupId }) => {
  const { appName: appName2 } = (0, import_react37.useContext)(ShellContainerContext);
  const path = (0, import_react37.useMemo)(() => getFullPathFromUrl(uri, appName2), [appName2, uri]);
  const activeLink = isActiveLink(path, currentPath);
  const { setPageNavGroupId } = (0, import_react37.useContext)(PageHeaderContext);
  (0, import_react37.useEffect)(() => {
    if (activeLink) {
      setPageNavGroupId(groupId ?? "");
    }
  }, [activeLink, groupId, setPageNavGroupId]);
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
    "li",
    {
      className: (0, import_uik72.css)(getStyles9(activeLink)),
      "data-testid": `group-section-link-${title.split(" ").join("-")}`,
      children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(LinkWrapper, { href: path, siteName: uri.site, children: title })
    },
    `nav-group-section-link-item-${title}`
  );
}, "NavGroupSectionLink");

// src/modules/container/components/nav/expression-renderer/NavExpressionRenderer.tsx
var import_react39 = require("react");

// src/modules/container/components/nav/hooks/useEvaluateNavigationExpression.ts
var import_react38 = require("react");
var import_cloneDeep2 = __toESM(require("lodash/cloneDeep"));
var import_stated_js = __toESM(require("stated-js"));

// src/modules/container/components/nav/configure-menu/configUtils.ts
var DEFAULT_SECTION = "modules";
function toSettingsConfigNavItems(staticNavItems, settingConfigItems, crudItems = []) {
  const navHeaderPositions = /* @__PURE__ */ new Map();
  const existingHeaders = /* @__PURE__ */ new Set();
  for (let i = 0; i < staticNavItems.length; i += 1) {
    if (staticNavItems[i][0] === "NavHeader") {
      const { title } = staticNavItems[i][1];
      navHeaderPositions.set(title, i);
      existingHeaders.add(title);
    }
  }
  function findInsertPosition(section) {
    const headerPosition = navHeaderPositions.get(section);
    if (headerPosition !== void 0) {
      let insertPosition = headerPosition + 1;
      while (insertPosition < staticNavItems.length && staticNavItems[insertPosition][0] !== "NavHeader") {
        insertPosition += 1;
      }
      return insertPosition;
    }
    return staticNavItems.length;
  }
  __name(findInsertPosition, "findInsertPosition");
  const dynamicNavItems = {};
  for (const settingsConfigItem of settingConfigItems) {
    const navigation = settingsConfigItem?.data?.uisettings?.navigation;
    if (navigation === void 0 || navigation === null || typeof navigation.destination !== "string") {
      continue;
    }
    const { id } = settingsConfigItem;
    const { section = DEFAULT_SECTION, title } = navigation;
    const navLinkItem = [
      "NavLink",
      {
        title,
        uri: {
          site: "/ui",
          path: `/${getAppName()}/crud/${encodeURIComponent(id)}/list`
        }
      }
    ];
    (dynamicNavItems[section] ??= []).push(navLinkItem);
  }
  for (const crudItem of crudItems) {
    const {
      id,
      data: { mode, label }
    } = crudItem;
    if (label === void 0) {
      continue;
    }
    (dynamicNavItems[DEFAULT_SECTION] ??= []).push([
      "NavLink",
      {
        title: label,
        uri: {
          site: "/ui",
          path: `/${getAppName()}/crud/${encodeURIComponent(id)}/${mode === "singleton" ? "edit" : "list"}`
        }
      }
    ]);
  }
  Object.entries(dynamicNavItems).forEach(([section, items]) => {
    if (!existingHeaders.has(section)) {
      staticNavItems.push(["NavHeader", { title: section }]);
      existingHeaders.add(section);
      navHeaderPositions.set(section, staticNavItems.length - 1);
    }
    const insertPosition = findInsertPosition(section);
    staticNavItems.splice(insertPosition, 0, ...items);
  });
  return staticNavItems;
}
__name(toSettingsConfigNavItems, "toSettingsConfigNavItems");

// src/modules/container/components/nav/hooks/useEvaluateNavigationExpression.ts
var useEvaluateNavigationExpression = /* @__PURE__ */ __name((navItem, flagsStoreKey) => {
  const [isConditionMet, setIsConditionMet] = (0, import_react38.useState)(null);
  const { tenantId } = (0, import_react38.useContext)(ShellContainerContext);
  const isSolutionSubscribed = (0, import_react38.useCallback)(
    async (solutionName) => {
      try {
        const solutionSubscriptionResponse = await getSolutionSubscription(tenantId, solutionName);
        return solutionSubscriptionResponse?.data?.isSubscribed ?? false;
      } catch (error) {
        console.error(`Error fetching solution subscription for solution name:${solutionName}`, error);
        return false;
      }
    },
    [tenantId]
  );
  (0, import_react38.useEffect)(() => {
    let didCancel = false;
    const runTemplateProcessor = /* @__PURE__ */ __name(async () => {
      if (navItem && navItem[1] && !didCancel) {
        const navObject = (0, import_cloneDeep2.default)(navItem[1]);
        const contextObject = {
          ff: getFlagValueWrapper(flagsStoreKey),
          encodeURIComponent,
          isSolutionSubscribed,
          toSettingsConfigNavItems
        };
        const statedTp = new import_stated_js.default(navObject, contextObject);
        await statedTp.initialize();
        if (navItem[0] === "NavExpression" && !didCancel) {
          setIsConditionMet(statedTp.output.evaluate);
        }
      }
    }, "runTemplateProcessor");
    runTemplateProcessor().catch((e) => {
      console.error("An error occurred while running the template processor:", e);
      setIsConditionMet(false);
    });
    return () => {
      didCancel = true;
    };
  }, [navItem, flagsStoreKey, isSolutionSubscribed]);
  return isConditionMet;
}, "useEvaluateNavigationExpression");

// src/modules/container/components/nav/expression-renderer/NavExpressionRenderer.tsx
var import_jsx_runtime59 = require("react/jsx-runtime");
var NavExpressionRenderer = /* @__PURE__ */ __name(({
  navExpressionItem,
  isCollapsed,
  setCollapsed,
  currentPath,
  isGroupSection = false,
  groupId
}) => {
  const { flagsStoreKey } = (0, import_react39.useContext)(ShellContainerContext);
  const isConditionMet = useEvaluateNavigationExpression(navExpressionItem, flagsStoreKey);
  if (isConditionMet && navExpressionItem[2]?.length > 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(import_jsx_runtime59.Fragment, { children: navExpressionItem[2].map((navItem, index) => /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
      NavItemRenderer,
      {
        item: navItem,
        isCollapsed,
        setCollapsed,
        currentPath,
        isGroupSection,
        groupId
      },
      `nav-expr-item-${index}`
    )) });
  }
  return null;
}, "NavExpressionRenderer");

// src/modules/container/components/nav/group/NavGroup.tsx
var import_jsx_runtime60 = require("react/jsx-runtime");
var NavGroup = /* @__PURE__ */ __name(({
  title,
  icon,
  currentPath,
  items,
  isCollapsed,
  setCollapsed
}) => {
  const [open, setOpen] = (0, import_react40.useState)(false);
  const { pageNavGroupId } = (0, import_react40.useContext)(PageHeaderContext);
  const hasActiveItem = pageNavGroupId === title;
  const onClick = /* @__PURE__ */ __name(() => {
    setCollapsed(false);
    setOpen(!open);
  }, "onClick");
  const onKeyUp = /* @__PURE__ */ __name(({ key }) => import_uik73.utils.maybeGet(
    {
      " ": onClick,
      ArrowDown: () => {
        setCollapsed(false);
        setOpen(true);
      },
      ArrowUp: () => setOpen(false),
      Enter: onClick
    },
    key
  )?.(), "onKeyUp");
  const styles = getStyles8({ hasActiveItem, isCollapsed, open });
  const renderNavItem = /* @__PURE__ */ __name((navItem, index) => {
    switch (navItem[0]) {
      case "NavLink":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          NavGroupSectionLink,
          {
            title: navItem[1].title,
            uri: navItem[1].uri,
            currentPath,
            groupId: title
          },
          `nav-group-section-link-${index}-${navItem[1].title}`
        );
      case "NavHeader":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(NavHeader, { title: navItem[1].title }, `nav-header-${navItem[1].title}`);
      case "NavDivider":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(NavDivider, {}, `nav-divider-${index}`);
      case "NavExpression":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          NavExpressionRenderer,
          {
            navExpressionItem: navItem,
            isCollapsed,
            setCollapsed,
            currentPath,
            groupId: title,
            isGroupSection: true
          },
          `nav-group-expression-renderer-${index}`
        );
      case "NavGroup":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          NavGroup,
          {
            title: navItem[1].title,
            icon: navItem[1].icon,
            items: navItem[2],
            currentPath,
            isCollapsed,
            setCollapsed
          }
        );
      case "NavDynamic":
        return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
          NavItemRenderer,
          {
            item: navItem,
            isCollapsed,
            setCollapsed,
            currentPath,
            groupId: title,
            isGroupSection: true
          },
          `nav-item-renderer-${index}`
        );
      default:
        return null;
    }
  }, "renderNavItem");
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(import_uik73.Tooltip, { position: "RIGHT", style: { left: 4 }, value: title, visible: isCollapsed ? void 0 : false, children: /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)("li", { className: (0, import_uik73.css)(styles), children: [
    /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(
      "div",
      {
        className: "inner-button",
        "data-testid": "button",
        onClick,
        onKeyUp,
        role: "menuitem",
        tabIndex: 0,
        children: [
          icon && /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(import_uik73.Icon, { className: "icon", size: "SMALL", type: icon }),
          /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("span", { "data-testid": "title", children: title }),
          /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
            import_uik73.Icon,
            {
              className: "expand icon",
              "data-testid": open ? "icon-opened" : "icon-closed",
              size: "SMALL",
              type: open ? "Navigation.ChevronDown" : "Navigation.ChevronRight"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("ul", { className: "second-level-menu", "data-testid": "sections", children: items.map(renderNavItem) })
  ] }) });
}, "NavGroup");

// src/modules/container/components/nav/item-renderer/NavItemRenderer.tsx
var import_jsx_runtime61 = require("react/jsx-runtime");
var NavItemRenderer = /* @__PURE__ */ __name(({
  item,
  isCollapsed,
  setCollapsed,
  currentPath,
  isGroupSection = false,
  groupId
}) => {
  const [dynamicNavItems, setDynamicNavItems] = (0, import_react41.useState)([]);
  const [isLoading, setIsLoading] = (0, import_react41.useState)(false);
  const { flagsStoreKey } = (0, import_react41.useContext)(ShellContainerContext);
  const { tenantId } = (0, import_react41.useContext)(ShellContainerContext);
  const isSolutionSubscribed = (0, import_react41.useCallback)(
    async (solutionName) => {
      try {
        const solutionSubscriptionResponse = await getSolutionSubscription(tenantId, solutionName);
        return solutionSubscriptionResponse?.data?.isSubscribed ?? false;
      } catch (error) {
        console.error(`Error fetching solution subscription for solution name:${solutionName}`, error);
        return false;
      }
    },
    [tenantId]
  );
  (0, import_react41.useEffect)(() => {
    const evaluateTemplate = /* @__PURE__ */ __name(async () => {
      setIsLoading(true);
      try {
        const navObject = (0, import_cloneDeep3.default)(item[1]);
        const statedTp = new import_stated_js2.default(navObject, {
          ff: getFlagValueWrapper(flagsStoreKey),
          encodeURIComponent,
          isSolutionSubscribed,
          toSettingsConfigNavItems
        });
        await statedTp.initialize();
        setDynamicNavItems(statedTp.output?.navItems);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }, "evaluateTemplate");
    if (item && item[0] === "NavDynamic") {
      void evaluateTemplate();
    }
  }, [flagsStoreKey, isSolutionSubscribed, item]);
  switch (item[0]) {
    case "NavLink":
      if (isGroupSection) {
        return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
          NavGroupSectionLink,
          {
            title: item[1].title,
            uri: item[1].uri,
            currentPath,
            groupId
          },
          `nav-item-group-section-link-${item[1].title}`
        );
      }
      return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        NavLink,
        {
          icon: item[1].icon,
          isCollapsed,
          uri: item[1].uri,
          title: item[1].title,
          currentPath
        },
        `nav-link-item-${item[1].title}`
      );
    case "NavHeader":
      return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(NavHeader, { title: item[1].title });
    case "NavDivider":
      return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(NavDivider, {});
    case "NavGroup":
      return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        NavGroup,
        {
          title: item[1].title,
          icon: item[1].icon,
          items: item[2],
          currentPath,
          isCollapsed,
          setCollapsed
        }
      );
    case "NavExpression":
      return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        NavExpressionRenderer,
        {
          navExpressionItem: item,
          isCollapsed,
          setCollapsed,
          currentPath,
          isGroupSection,
          groupId
        }
      );
    case "NavDynamic":
      if (isLoading) {
        return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)("li", { style: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(import_uik74.Spinner, { size: "SMALL" }) });
      }
      if (dynamicNavItems?.length > 0) {
        return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(import_jsx_runtime61.Fragment, { children: dynamicNavItems.map((dynamicItem, index) => /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
          NavItemRenderer,
          {
            item: dynamicItem,
            isCollapsed,
            setCollapsed,
            currentPath,
            isGroupSection,
            groupId
          },
          `nav-dynamic-${index}`
        )) });
      }
      return null;
    default:
      return null;
  }
}, "NavItemRenderer");

// src/modules/container/components/nav/size-toggle/NavSizeToggle.tsx
var import_uik75 = require("@appd/uik");
var import_jsx_runtime62 = require("react/jsx-runtime");
var NavSizeToggle = /* @__PURE__ */ __name(({ onToggle }) => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
  "div",
  {
    className: (0, import_uik75.css)(STYLES20()),
    "data-testid": "size-toggle",
    onClick: onToggle,
    onKeyUp: ({ key }) => [" ", "Enter"].includes(key) && onToggle(),
    role: "button",
    tabIndex: 0,
    children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(import_uik75.Icon, { className: "icon", "data-testid": "icon-nav-menu", size: "SMALL", type: "Navigation.Menu" })
  }
), "NavSizeToggle");
var {
  COLORS: { CONTROL_ICON_WEAK: CONTROL_ICON_WEAK4 },
  RADIUS: RADIUS5
} = import_uik75.MAGNETIC_TOKENS;
var STYLES20 = import_uik75.utils.lazyConstant(
  () => import_uik75.css.Styles({
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    justifyContent: "flex-start",
    userSelect: "none",
    width: "100%",
    ":focus-visible": {
      boxShadow: "none",
      outline: "none",
      "& .icon": {
        borderRadius: RADIUS5.DEFAULT,
        // Matches `<LinkWrapper>` `:focus` style.
        // Update this later when Chakra removed.
        outline: "3px solid rgb(66, 153, 225, .6)"
      }
    },
    "& .icon": {
      margin: "11px 21px",
      "& path": {
        fill: CONTROL_ICON_WEAK4
      }
    }
  })
);

// src/modules/container/components/nav/hooks/useNavCollapsedState.ts
var import_react42 = require("react");
var useNavCollapsedState = /* @__PURE__ */ __name((defaultValue = false) => {
  const getInitialNavCollapsedState = /* @__PURE__ */ __name(() => {
    const rawNavCollapsedState = sessionStorage.getItem("navCollapsedState");
    if (rawNavCollapsedState !== null) {
      try {
        return JSON.parse(rawNavCollapsedState);
      } catch (error) {
        console.error("Error parsing navCollapsedState from sessionStorage:", error);
        return defaultValue;
      }
    }
    return defaultValue;
  }, "getInitialNavCollapsedState");
  const [isCollapsed, setCollapsed] = (0, import_react42.useState)(getInitialNavCollapsedState);
  (0, import_react42.useEffect)(() => {
    try {
      sessionStorage.setItem("navCollapsedState", JSON.stringify(isCollapsed));
    } catch (error) {
      console.error("Error saving navCollapsedState to sessionStorage:", error);
    }
  }, [isCollapsed]);
  return [isCollapsed, setCollapsed];
}, "useNavCollapsedState");
var useNavCollapsedState_default = useNavCollapsedState;

// src/modules/container/components/nav/Nav.tsx
var import_jsx_runtime63 = require("react/jsx-runtime");
var Nav = /* @__PURE__ */ __name(({ className, router }) => {
  const [isCollapsed, setCollapsed] = useNavCollapsedState_default();
  const currentPath = window.location.pathname;
  const { tenantId, appName: appName2 } = (0, import_react43.useContext)(ShellContainerContext);
  const routerObj = (0, import_react43.useMemo)(() => ({ router }), [router]);
  const [appNavItems, setAppNavItems] = (0, import_react43.useState)([]);
  const onKeyUp = /* @__PURE__ */ __name(({ key }) => import_uik76.utils.let("next", import_uik76.utils.maybeGet({ ArrowLeft: true, ArrowRight: false }, key)).get((next) => next !== void 0 && setCollapsed(next)), "onKeyUp");
  const styles = getStyles5(isCollapsed);
  const getAppNavItems = /* @__PURE__ */ __name(async () => {
    const navItemsResponse = await getNavItemsInternal(tenantId, `layerId eq "${appName2}"&fields=data`);
    const navItems = navItemsResponse.items[0]?.data?.navItems;
    setAppNavItems(navItems);
    setSelectedAppNavItems(navItems);
  }, "getAppNavItems");
  (0, import_react43.useEffect)(() => {
    if (tenantId !== "" && appName2 !== "") {
      getAppNavItems().catch(reportError);
    }
  }, [tenantId, appName2]);
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(RouterContext.Provider, { value: routerObj, children: /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("aside", { className: (0, import_uik76.css)(styles, className), onKeyUp, role: "presentation", "data-testid": "nav-container", children: appNavItems && appNavItems.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)(import_jsx_runtime63.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(NavSizeToggle, { "data-testid": "nav-size-toggle", onToggle: () => setCollapsed(!isCollapsed) }),
    /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("nav", { children: /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("ul", { children: appNavItems?.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
      NavItemRenderer,
      {
        item,
        isCollapsed,
        setCollapsed,
        currentPath
      },
      `nav-item-${index}`
    )) }) })
  ] }) : null }) });
}, "Nav");

// src/modules/container/container/STYLES.ts
var import_uik77 = require("@appd/uik");
var STYLES21 = {
  BANNER_CONTAINER: import_uik77.css.Styles({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gridArea: "banner",
    position: "relative",
    overflow: "auto"
  }),
  MAIN_CONTAINER: import_uik77.css.Styles({
    overflow: "auto",
    width: "100vw",
    display: "flex",
    flexDirection: "row",
    gridArea: "main",
    position: "relative"
  }),
  MAIN_CONTENT: import_uik77.css.Styles({
    flex: 1,
    overflow: "auto"
  }),
  MAIN_GRID: import_uik77.css.Styles({
    height: "100vh",
    display: "grid",
    grid: `
      " top  " max-content
      " banner  " max-content
      " main " 1fr
    /   1fr 
  `
  }),
  HELP_CENTER_V2_ROOT: import_uik77.css.Styles({
    position: "absolute",
    right: 0,
    overflow: "auto",
    zIndex: 99,
    boxShadow: "-8px 2px 10px -5px #0000004d"
  }),
  EXCHANGE_ROOT: import_uik77.css.Styles({
    overflow: "auto",
    zIndex: 98,
    boxShadow: "-8px 2px 10px -5px #0000004d"
  })
};

// src/modules/container/components/productTour/ProductTourComponent.tsx
var import_uik79 = require("@appd/uik");
var import_react44 = require("react");

// src/modules/container/components/productTour/getStyles.ts
var import_uik78 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG2,
    DEFAULT_TEXT: DEFAULT_TEXT11,
    INTERACT_ICON: INTERACT_ICON2,
    INTERACT_ICON_WEAK_DISABLED: INTERACT_ICON_WEAK_DISABLED2,
    BRAND_TEXT_STRONG,
    CONTROL_BG: CONTROL_BG2
  },
  STATIC: { MODAL_BACKDROP },
  RADIUS: RADIUS6,
  TYPOGRAPHY: { BODY: BODY4 }
} = import_uik78.MAGNETIC_TOKENS;
var getStyles10 = /* @__PURE__ */ __name(() => import_uik78.css.Styles({
  HOST: import_uik78.css.Styles({
    "::-webkit-scrollbar": { display: "none" },
    height: "var(--scrollHeight)",
    left: 0,
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)",
    marginBottom: -import_uik78.utils.CSS_MAX_NUMBER,
    marginRight: -import_uik78.utils.CSS_MAX_NUMBER,
    overscrollBehavior: "none",
    scrollbarWidth: "none",
    overflow: "scroll"
  }),
  BACKDROP: import_uik78.css.Styles({
    backgroundColor: MODAL_BACKDROP,
    left: 0,
    top: 0,
    height: "101%",
    position: "absolute",
    width: "100%"
  }),
  FRAME: import_uik78.css.Styles({
    ...BODY4.DEFAULT,
    color: DEFAULT_TEXT11,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
    overflow: "hidden",
    position: "sticky",
    top: 0,
    left: 0
  }),
  CONTENT: import_uik78.css.Styles({
    display: "flex",
    flexWrap: "nowrap",
    overflow: "hidden",
    alignSelf: "flex-start",
    height: "100%"
  }),
  SLIDE: import_uik78.css.Styles({
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden"
  }),
  INDICATOR: import_uik78.css.Styles({
    paddingTop: 24,
    display: "flex",
    justifyContent: "center",
    gap: 12
  }),
  DOT: import_uik78.css.Styles({
    background: INTERACT_ICON_WEAK_DISABLED2,
    width: 12,
    height: 12,
    borderRadius: "50%"
  }),
  MODAL: import_uik78.css.Styles({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: CONTROL_BG2,
    borderRadius: RADIUS6.HEAVY,
    color: BRAND_TEXT_STRONG,
    overflow: "hidden",
    position: "sticky",
    height: 705,
    width: 912
  }),
  IMAGE_CONTAINER: import_uik78.css.Styles({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
    width: "100%",
    overflow: "hidden"
  }),
  TEXT_CONTAINER: import_uik78.css.Styles({
    display: "flex",
    padding: "24px 60px 0 60px",
    flexDirection: "column",
    alignItems: "center",
    gap: 8
  }),
  TITLE: import_uik78.css.Styles({
    fontWeight: 700,
    lineHeight: "34px",
    fontSize: "24px",
    textAlign: "center",
    color: DEFAULT_TEXT_STRONG2,
    width: 600
  }),
  DESCRIPTION: import_uik78.css.Styles({
    fontWeight: 400,
    lineHeight: "22px",
    fontSize: "16px",
    textAlign: "center",
    color: DEFAULT_TEXT11,
    width: 600
  }),
  ACTIVE: import_uik78.css.Styles({
    background: INTERACT_ICON2
  }),
  FOOTER: import_uik78.css.Styles({
    width: "100%"
  }),
  FOOTER_ACTIONS: import_uik78.css.Styles({
    display: "flex",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  }),
  SLIDE_ACTIONS: import_uik78.css.Styles({
    display: "flex",
    gap: 8
  }),
  IMAGE: import_uik78.css.Styles({
    transform: "scale(1.18)"
  })
}), "getStyles");

// src/modules/container/components/productTour/ProductTourComponent.tsx
var import_jsx_runtime64 = require("react/jsx-runtime");
var CANCEL = import_uik79.format.message`Cancel`.description("cancel button text");
var BACK = import_uik79.format.message`Back`.description("back button text");
var NEXT = import_uik79.format.message`Next`.description("next button text");
var GO = import_uik79.format.message`Let’s go`.description("Let\u2019s go button text");
var {
  HOST,
  BACKDROP,
  CONTENT,
  SLIDE,
  INDICATOR,
  DOT,
  FRAME,
  ACTIVE,
  SLIDE_ACTIONS,
  FOOTER_ACTIONS,
  DESCRIPTION,
  TITLE,
  TEXT_CONTAINER,
  IMAGE_CONTAINER,
  MODAL,
  FOOTER,
  IMAGE
} = getStyles10();
var ProductTourComponent = /* @__PURE__ */ __name(() => {
  const [showTour, setShowTour] = (0, import_react44.useState)(false);
  const [currentSlide, setCurrentSlide] = (0, import_react44.useState)(0);
  const [productTourSlides, setProductTourSlides] = (0, import_react44.useState)([]);
  const [isProductTourCompleted, setIsProductTourCompleted] = (0, import_react44.useState)(false);
  const { currentTheme } = (0, import_react44.useContext)(import_uik79.css.CONTEXT);
  const { tenantId, appName: appName2, site, appTitle, shellPreferences } = (0, import_react44.useContext)(ShellContainerContext);
  const { setShellPreferences: setShellPreferences2 } = useShellPreferences(
    `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
    "LOCALUSER" /* LOCALUSER */
  );
  const getAppProductTourSlides = (0, import_react44.useCallback)(async () => {
    const productTourResponse = await getProductTour(tenantId, `layerId eq "${appName2}"&fields=data`);
    const productTourSlidesFromOrion = productTourResponse.items[0]?.data?.productTourSlides;
    if (productTourSlidesFromOrion && productTourSlidesFromOrion.length) {
      setProductTourSlides(productTourSlidesFromOrion);
    }
  }, [appName2, tenantId]);
  const replayTour = (0, import_react44.useCallback)(() => {
    setShowTour(true);
  }, []);
  (0, import_react44.useEffect)(() => {
    getAppProductTourSlides().catch(() => setShowTour(false));
  }, [getAppProductTourSlides]);
  (0, import_react44.useEffect)(() => {
    if (shellPreferences) {
      const { data } = shellPreferences;
      if (isShellPreferencesData(data)) {
        const {
          shellPreferences: { showProductTour }
        } = data;
        if (showProductTour) {
          setShowTour(true);
        } else {
          setIsProductTourCompleted(true);
        }
      }
    }
  }, [shellPreferences]);
  (0, import_react44.useEffect)(() => {
    ShellEvent.on(ShellEventTypes.REPLAY_TOUR_CLICKED, replayTour);
    return () => {
      ShellEvent.un(ShellEventTypes.REPLAY_TOUR_CLICKED, replayTour);
    };
  }, [replayTour]);
  const saveProductTourPreferences = (0, import_react44.useCallback)(() => {
    const preferencesFromApi = { ...shellPreferences ?? { data: { shellPreferences: {} } } };
    const { data } = preferencesFromApi;
    if (isShellPreferencesData(data)) {
      const updatedPreferences = {
        ...preferencesFromApi,
        data: {
          ...data,
          shellPreferences: { ...data.shellPreferences, showProductTour: false }
        }
      };
      if (updatedPreferences.layerType === "SOLUTION" /* SOLUTION */) {
        setShellPreferences2({
          data: updatedPreferences.data,
          layerType: "LOCALUSER" /* LOCALUSER */
        }).then(() => setIsProductTourCompleted(true)).catch(reportError);
      } else {
        setShellPreferences2({
          ...updatedPreferences,
          data: {
            appName: appName2,
            shellPreferences: updatedPreferences.data.shellPreferences
          }
        }).then(() => setIsProductTourCompleted(true)).catch(reportError);
      }
    }
  }, [appName2, setShellPreferences2, shellPreferences]);
  const sendTelemetryEvent5 = (0, import_react44.useCallback)(
    (productTourCompleted) => {
      const telemetryProperties = {
        event: "Product Tour",
        properties: {
          productTourCompleted,
          applicationDisplayName: appTitle,
          applicationName: appName2
        }
      };
      TrackingService.sendEvent(telemetryProperties).catch(reportError);
    },
    [appTitle, appName2]
  );
  const onExit = /* @__PURE__ */ __name(() => {
    setShowTour(false);
    setCurrentSlide(0);
  }, "onExit");
  const prev = (0, import_react44.useCallback)(() => {
    setCurrentSlide((slide) => slide - 1);
  }, []);
  const next = (0, import_react44.useCallback)(() => {
    if (currentSlide === productTourSlides.length - 1) {
      if (!isProductTourCompleted) {
        sendTelemetryEvent5(true);
        saveProductTourPreferences();
      }
      onExit();
      return;
    }
    setCurrentSlide((slide) => slide + 1);
  }, [currentSlide, productTourSlides, isProductTourCompleted, sendTelemetryEvent5, saveProductTourPreferences]);
  const cancel = (0, import_react44.useCallback)(() => {
    if (!isProductTourCompleted) {
      sendTelemetryEvent5(false);
      saveProductTourPreferences();
    }
    onExit();
  }, [isProductTourCompleted, saveProductTourPreferences, sendTelemetryEvent5]);
  const getImageSrc = (0, import_react44.useCallback)(
    (path) => {
      let imageSrc = path;
      if (currentTheme === "dark") {
        imageSrc = imageSrc.replace(/\./, "_dt.");
      }
      if (site) {
        imageSrc = `${site}${imageSrc}`;
      }
      return imageSrc;
    },
    [currentTheme, site]
  );
  return showTour && productTourSlides.length ? /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_uik79.Overlay.Provider, { promote: Infinity, children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_uik79.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("div", { className: (0, import_uik79.css)(HOST), children: [
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(BACKDROP) }),
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(FRAME), children: /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("div", { className: (0, import_uik79.css)(MODAL), "data-testid": "product-tour-content", children: [
      /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(CONTENT), style: { width: `${productTourSlides.length * 100}%` }, children: productTourSlides.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(
        "div",
        {
          "data-testid": "product-tour-slide",
          className: (0, import_uik79.css)(SLIDE, {
            transform: `translate(-${currentSlide * 100}%)`,
            visibility: `${index !== currentSlide ? "hidden" : "visible"}`
          }),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(IMAGE_CONTAINER), children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
              "img",
              {
                className: (0, import_uik79.css)(IMAGE),
                src: getImageSrc(item.imageUri),
                alt: `product-tour-slide-${index}`
              }
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("div", { className: (0, import_uik79.css)(TEXT_CONTAINER), children: [
              /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(TITLE), children: item.title }),
              /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(DESCRIPTION), children: item.description })
            ] })
          ]
        },
        `product-tour-slide-${item.title}`
      )) }),
      /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("div", { className: (0, import_uik79.css)(FOOTER), children: [
        /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { "data-testid": "product-tour-indicator", className: (0, import_uik79.css)(INDICATOR), children: productTourSlides.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: (0, import_uik79.css)(DOT, index === currentSlide ? ACTIVE : {}) }, `indicator-${item.title}`)) }),
        /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)(
          "div",
          {
            className: (0, import_uik79.css)(
              FOOTER_ACTIONS,
              currentSlide === productTourSlides.length - 1 && { justifyContent: "flex-end" }
            ),
            children: [
              currentSlide !== productTourSlides.length - 1 && /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_uik79.Button, { "data-testid": "cancel-btn", type: "TERTIARY", onClick: cancel, children: CANCEL() }),
              /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("div", { className: (0, import_uik79.css)(SLIDE_ACTIONS), children: [
                /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_uik79.Button, { "data-testid": "back-btn", type: "SECONDARY", onClick: prev, disabled: currentSlide === 0, children: BACK() }),
                /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_uik79.Button, { "data-testid": "next-btn", type: "PRIMARY", onClick: next, children: currentSlide === productTourSlides.length - 1 ? GO() : NEXT() })
              ] })
            ]
          }
        )
      ] })
    ] }) })
  ] }) }) }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(import_jsx_runtime64.Fragment, {})
  );
}, "ProductTourComponent");

// src/modules/container/hook/useTenantId.ts
var import_react45 = require("react");
var useTenantId = /* @__PURE__ */ __name((tenantUrl, tenantIdFromInitConfig = "") => {
  const [tenantId, setTenantId] = (0, import_react45.useState)(tenantIdFromInitConfig);
  const isAppdTest2 = /* @__PURE__ */ __name((host = "") => host.includes("appd-test.com"), "isAppdTest");
  const isProd = /* @__PURE__ */ __name((host = "") => host.includes("appdynamics.com"), "isProd");
  const INTERNAL_LOOKUP = "https://levitate-tenants-lookup.saas.appd-test.com/tenants/lookup/";
  const PROD_LOOKUP = "https://observe-tenant-lookup-api.saas.appdynamics.com/tenants/lookup/";
  const PUBLIC_TENANT_URL = "https://alameda-c0-test-02.saas.appd-test.com";
  (0, import_react45.useEffect)(() => {
    setTenantId(tenantIdFromInitConfig);
  }, [tenantIdFromInitConfig]);
  (0, import_react45.useEffect)(() => {
    const fetchTenantId = /* @__PURE__ */ __name(async () => {
      if (isLocal()) {
        let hostName = window.location.host;
        let targetLookup = isLocal() || isAppdTest2(hostName) ? INTERNAL_LOOKUP : PROD_LOOKUP;
        targetLookup = isProd(tenantUrl) ? PROD_LOOKUP : targetLookup;
        hostName = tenantUrl || PUBLIC_TENANT_URL;
        hostName = hostName.replace(/^https?:\/\//, "");
        const tenantLookupUrl = `${targetLookup}${hostName}`;
        const tenantIdRes = await shellFetch(tenantLookupUrl);
        const tenantIdJson = await tenantIdRes.json();
        const resTenantId = tenantIdJson.tenantId;
        setTenantId(resTenantId);
      }
    }, "fetchTenantId");
    fetchTenantId();
  }, []);
  return tenantId;
}, "useTenantId");

// src/modules/container/components/banner/NotificationBanner.tsx
var import_react46 = require("react");
var import_uik80 = require("@appd/uik");
var import_isEqual2 = __toESM(require("lodash/isEqual"));
var import_jsx_runtime65 = (
  // eslint-disable-next-line  @typescript-eslint/no-misused-promises
  require("react/jsx-runtime")
);
var bannerStyle = {
  width: "100%"
};
var NotificationBanner = /* @__PURE__ */ __name(() => {
  const { preferences, tenantId } = (0, import_react46.useContext)(ShellContainerContext);
  const layerId = `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`;
  const { setPreferences: setPreferences2 } = usePreferences(layerId, "LOCALUSER" /* LOCALUSER */);
  const { getPreferences: getPreferences2 } = usePreferences(layerId, "LOCALUSER" /* LOCALUSER */);
  const [notification, setNotification] = (0, import_react46.useState)();
  const fetchNotification = /* @__PURE__ */ __name(async () => {
    try {
      const response = await shellFetch("/session/api/ext/ui/api/dashui/system/notifications", {
        headers: {
          Accept: "application/json"
        }
      });
      const notifications = await response.json();
      const newNotification = notifications.items.length > 0 && notifications.items[0].data ? notifications.items[0].data : void 0;
      if (newNotification !== void 0) {
        setNotification(newNotification);
      }
    } catch (e) {
    }
  }, "fetchNotification");
  (0, import_react46.useEffect)(() => {
    fetchNotification();
  }, []);
  if (notification === void 0 || notification.displayBanner === false || preferences === void 0) {
    return null;
  }
  const data = preferences.data;
  if (data && data.preferences && (0, import_isEqual2.default)(notification, data.preferences.banner)) {
    return null;
  }
  let bannerType = notification.severity.toUpperCase();
  if (bannerType === "CRITICAL") {
    bannerType = "ERROR";
  }
  const type = bannerType;
  const onCloseHandler = /* @__PURE__ */ __name(async () => {
    const allPreferences = await getPreferences2(`data.appName eq "${CONSTANTS.SHELL_APP}"`);
    const filteredPreference = filterPreferencesByLayerType(allPreferences, "LOCALUSER" /* LOCALUSER */) ?? { data: { preferences: {} } };
    const preferencesObj = {
      data: {
        ...filteredPreference.data,
        appName: CONSTANTS.SHELL_APP,
        preferences: {
          ...filteredPreference.data.preferences,
          banner: notification
        }
      },
      layerType: "LOCALUSER" /* LOCALUSER */,
      layerId,
      id: CONSTANTS.SHELL_APP
    };
    setPreferences2(preferencesObj).catch(() => {
    });
  }, "onCloseHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(import_uik80.Banner, { className: (0, import_uik80.css)(bannerStyle), title: notification.title, type, onClose: onCloseHandler, children: notification.message });
}, "NotificationBanner");

// src/modules/container/components/aiProductTour/AIProductTourComponent.tsx
var import_react48 = require("react");

// src/modules/container/components/carousel/CarouselComponent.tsx
var import_uik82 = require("@appd/uik");
var import_react47 = require("react");

// src/modules/container/components/carousel/STYLES.ts
var import_uik81 = require("@appd/uik");
var {
  COLORS: {
    DEFAULT_TEXT_STRONG: DEFAULT_TEXT_STRONG3,
    DEFAULT_TEXT: DEFAULT_TEXT12,
    INTERACT_ICON: INTERACT_ICON3,
    INTERACT_ICON_WEAK_DISABLED: INTERACT_ICON_WEAK_DISABLED3,
    BRAND_TEXT_STRONG: BRAND_TEXT_STRONG2,
    CONTROL_BG: CONTROL_BG3
  },
  STATIC: { MODAL_BACKDROP: MODAL_BACKDROP2 },
  RADIUS: RADIUS7,
  TYPOGRAPHY: { BODY: BODY5 }
} = import_uik81.MAGNETIC_TOKENS;
var STYLES22 = {
  HOST: (0, import_uik81.css)({
    "::-webkit-scrollbar": { display: "none" },
    height: "var(--scrollHeight)",
    left: 0,
    position: "absolute",
    top: 0,
    width: "var(--scrollWidth)",
    marginBottom: -import_uik81.utils.CSS_MAX_NUMBER,
    marginRight: -import_uik81.utils.CSS_MAX_NUMBER,
    overscrollBehavior: "none",
    scrollbarWidth: "none",
    overflow: "scroll"
  }),
  BACKDROP: (0, import_uik81.css)({
    backgroundColor: MODAL_BACKDROP2,
    left: 0,
    top: 0,
    height: "101%",
    position: "absolute",
    width: "100%"
  }),
  FRAME: (0, import_uik81.css)({
    ...BODY5.DEFAULT,
    color: DEFAULT_TEXT12,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    width: "100%",
    overflow: "hidden",
    position: "sticky",
    top: 0,
    left: 0
  }),
  CONTENT: (0, import_uik81.css)({
    display: "flex",
    flexWrap: "nowrap",
    overflow: "hidden",
    alignSelf: "flex-start",
    height: "100%"
  }),
  SLIDE: (0, import_uik81.css)({
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden"
  }),
  INDICATOR: (0, import_uik81.css)({
    paddingTop: 24,
    display: "flex",
    justifyContent: "center",
    gap: 12
  }),
  DOT: (0, import_uik81.css)({
    background: INTERACT_ICON_WEAK_DISABLED3,
    width: 12,
    height: 12,
    borderRadius: "50%"
  }),
  MODAL: (0, import_uik81.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: CONTROL_BG3,
    borderRadius: RADIUS7.HEAVY,
    color: BRAND_TEXT_STRONG2,
    overflow: "hidden",
    position: "sticky",
    height: 705,
    width: 912
  }),
  IMAGE_CONTAINER: (0, import_uik81.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
    width: "100%",
    overflow: "hidden"
  }),
  TEXT_CONTAINER: (0, import_uik81.css)({
    display: "flex",
    padding: "24px 60px 0 60px",
    flexDirection: "column",
    alignItems: "center",
    gap: 8
  }),
  TITLE: (0, import_uik81.css)({
    fontWeight: 700,
    lineHeight: "34px",
    fontSize: "24px",
    textAlign: "center",
    color: DEFAULT_TEXT_STRONG3,
    width: 600
  }),
  DESCRIPTION: (0, import_uik81.css)({
    fontWeight: 400,
    lineHeight: "22px",
    fontSize: "16px",
    textAlign: "center",
    color: DEFAULT_TEXT12,
    width: 600
  }),
  ACTIVE: (0, import_uik81.css)({
    background: INTERACT_ICON3
  }),
  FOOTER: (0, import_uik81.css)({
    width: "100%"
  }),
  FOOTER_ACTIONS: (0, import_uik81.css)({
    display: "flex",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  }),
  SLIDE_ACTIONS: (0, import_uik81.css)({
    display: "flex",
    gap: 8
  }),
  IMAGE: (0, import_uik81.css)({
    transform: "scale(1.18)"
  })
};

// src/modules/container/components/carousel/CarouselComponent.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
var CarouselComponent = /* @__PURE__ */ __name(({
  open,
  slides,
  cancel = "Cancel",
  back = "Back",
  next = "Next",
  lastSlideNextButton = `Let's go`,
  onClose
}) => {
  const [currentSlide, setCurrentSlide] = (0, import_react47.useState)(0);
  const handleBack = /* @__PURE__ */ __name(() => {
    setCurrentSlide((slide) => slide - 1);
  }, "handleBack");
  const handleNext = (0, import_react47.useCallback)(() => {
    if (currentSlide === slides.length - 1 && onClose) {
      onClose();
      return;
    }
    setCurrentSlide((slide) => slide + 1);
  }, [currentSlide, onClose, slides]);
  const handleCancel = (0, import_react47.useCallback)(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  return open ? /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(import_uik82.Overlay.Provider, { promote: Infinity, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(import_uik82.Overlay, { children: /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("div", { className: STYLES22.HOST, children: [
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { className: STYLES22.BACKDROP }),
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { className: STYLES22.FRAME, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("div", { className: STYLES22.MODAL, "data-testid": "carousel-modal", children: [
      /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { className: STYLES22.CONTENT, style: { width: `${slides.length * 100}%` }, children: slides.map((item, index) => /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(
        "div",
        {
          "data-testid": "carousel-slide",
          className: (0, import_uik82.css)(STYLES22.SLIDE, {
            transform: `translate(-${currentSlide * 100}%)`,
            visibility: `${index !== currentSlide ? "hidden" : "visible"}`
          }),
          children: [
            item.content,
            /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("div", { className: STYLES22.TEXT_CONTAINER, children: [
              /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { className: STYLES22.TITLE, children: item.title }),
              /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { className: STYLES22.DESCRIPTION, children: item.description })
            ] })
          ]
        },
        `carousel-slide-${generateUuid()}`
      )) }),
      /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("div", { className: STYLES22.FOOTER, children: [
        /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("div", { "data-testid": "carousel-indicator", className: STYLES22.INDICATOR, children: slides.map((_, index) => /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
          "div",
          {
            className: (0, import_uik82.css)(STYLES22.DOT, index === currentSlide ? STYLES22.ACTIVE : {})
          },
          `indicator-${generateUuid()}`
        )) }),
        /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)(
          "div",
          {
            className: (0, import_uik82.css)(
              STYLES22.FOOTER_ACTIONS,
              currentSlide === slides.length - 1 && { justifyContent: "flex-end" }
            ),
            children: [
              currentSlide !== slides.length - 1 && /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(import_uik82.Button, { "data-testid": "carousel-cancel-btn", type: "TERTIARY", onClick: handleCancel, children: cancel }),
              /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("div", { className: (0, import_uik82.css)(STYLES22.SLIDE_ACTIONS), children: [
                /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
                  import_uik82.Button,
                  {
                    "data-testid": "carousel-back-btn",
                    type: "SECONDARY",
                    onClick: handleBack,
                    disabled: currentSlide === 0,
                    children: back
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(import_uik82.Button, { "data-testid": "carousel-next-btn", type: "PRIMARY", onClick: handleNext, children: currentSlide === slides.length - 1 ? lastSlideNextButton : next })
              ] })
            ]
          }
        )
      ] })
    ] }) })
  ] }) }) }) : null;
}, "CarouselComponent");

// src/modules/container/components/aiProductTour/AIProductSlide.tsx
var import_uik83 = require("@appd/uik");

// src/modules/container/components/aiProductTour/icons.ts
var AI_LOGO_LARGE = require_ai_logo_large();
var LOCK = require_lockVector();
var PATH = require_pathVector();
var CHAT = require_chatVector();
var THUMBS_DOWN = require_thumbsDownVector();
var WARNING = require_warningVector();
var ICONS = {
  AI_LOGO_LARGE,
  LOCK,
  PATH,
  CHAT,
  THUMBS_DOWN,
  WARNING
};

// src/modules/container/components/aiProductTour/AIProductSlide.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var {
  COLORS: { DEFAULT_TEXT: DEFAULT_TEXT13, CONTROL_BG_WEAK_DISABLED },
  SPACING: SPACING31,
  TYPOGRAPHY: { P2_EMPHASIS, FONT_BODY }
} = import_uik83.MAGNETIC_TOKENS;
var STYLES23 = {
  SLIDES_CONTAINER: (0, import_uik83.css)({
    padding: SPACING31[6],
    background: CONTROL_BG_WEAK_DISABLED,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%"
  }),
  SUB_CONTAINER: (0, import_uik83.css)({
    display: "flex",
    alignItems: "flex-start",
    color: DEFAULT_TEXT13,
    maxWidth: "500px",
    padding: SPACING31[5]
  }),
  SUB_CONTENT_TEXT: (0, import_uik83.css)({
    paddingLeft: SPACING31[6]
  }),
  SUB_CONTENT_HEADER: (0, import_uik83.css)({
    font: P2_EMPHASIS,
    paddingBottom: SPACING31[1]
  }),
  SUB_CONTENT_DESCRIPTION: (0, import_uik83.css)({
    font: FONT_BODY
  }),
  SUB_CONTENT_ICON_CONTAINER: (0, import_uik83.css)({
    flexShrink: 0,
    width: "100px"
  }),
  SUB_CONTENT_ICON: (0, import_uik83.css)({
    margin: "0 auto",
    display: "block"
  })
};
var AIProductSlide = /* @__PURE__ */ __name(({ items, titleSlide }) => /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("div", { className: STYLES23.SLIDES_CONTAINER, children: titleSlide ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("img", { src: ICONS.AI_LOGO_LARGE, "data-testid": "title-slide", alt: "tour icon" }) : items?.map((item) => /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)("div", { "data-testid": "slide-item", className: STYLES23.SUB_CONTAINER, children: [
  /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("div", { className: STYLES23.SUB_CONTENT_ICON_CONTAINER, children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("img", { className: STYLES23.SUB_CONTENT_ICON, src: item.icon, alt: "tour icon" }) }),
  /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)("div", { children: [
    /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("div", { className: STYLES23.SUB_CONTENT_HEADER, children: item.header }),
    /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("div", { className: STYLES23.SUB_CONTENT_DESCRIPTION, children: item.description })
  ] })
] }, item.header)) }), "AIProductSlide");

// src/modules/container/components/aiProductTour/slideContent.ts
var SLIDE_TWO = [
  {
    icon: ICONS.LOCK,
    header: "The Assistant does not share your personal data",
    description: "The AI Assistant operates based of a large language model (LLM) which is designed to provide responses to your queries based on the questions it receives. It does this without collecting or storing any of your personal (PII) data. It does, however, retain past conversations you have had so you can easily reference them in the future."
  },
  {
    icon: ICONS.PATH,
    header: "The Assistant strives for transparency",
    description: `Where it can, the AI Assistant provides the sources of information used to answer your question. All data sources used in improving the AI Assistant are documented and accessible via our FAQ's.`
  }
];
var SLIDE_THREE = [
  {
    icon: ICONS.CHAT,
    header: "Be clear and use natural language",
    description: `Converse with the AI Assistant as you would with another human.  Be specific and provide more details as this will help the Assistant provide you with a more helpful response.`
  },
  {
    icon: ICONS.THUMBS_DOWN,
    header: "Provide feedback to improve the system",
    description: `If the AI Assistant makes a mistake or you are not satisfied with its response, use the built-in feedback mechanisms to let us know. We will use your feedback to improve the AI Assistant over time.`
  },
  {
    icon: ICONS.WARNING,
    header: "Verify critical information. You are in control",
    description: `The AI Assistant is committed to providing accurate and reliable information and will always provide a mechanism for you to review prior to it taking any actions on your behalf.`
  }
];

// src/modules/container/components/aiProductTour/AIProductTourComponent.tsx
var import_jsx_runtime68 = require("react/jsx-runtime");
var AIProductTourComponent = /* @__PURE__ */ __name(({ open = false }) => {
  const [showTour, setShowTour] = (0, import_react48.useState)(open);
  (0, import_react48.useEffect)(() => {
    const showAITour = /* @__PURE__ */ __name(() => {
      setShowTour(true);
    }, "showAITour");
    ShellEvent.on(ShellEventTypes.HELP_CENTER_SHOW_AI_TOUR, showAITour);
    return () => {
      ShellEvent.un(ShellEventTypes.HELP_CENTER_SHOW_AI_TOUR, showAITour);
    };
  }, []);
  const onExit = /* @__PURE__ */ __name(() => {
    ShellEvent.emit(ShellEventTypes.HELP_CENTER_AI_TOUR_COMPLETED);
    setShowTour(false);
  }, "onExit");
  const slides = [
    {
      title: "Welcome to your AI Assistant",
      description: `I'm your virtual companion for learning how to use the Cisco Observability Platform. Powered by generative artificial intelligence, I'm constantly improving based on your questions and feedback.`,
      content: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(AIProductSlide, { titleSlide: true })
    },
    {
      title: "The AI Assistant is committed to your privacy",
      description: "",
      content: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(AIProductSlide, { items: SLIDE_TWO })
    },
    {
      title: "A few tips for working with the AI Assistant",
      description: "",
      content: /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(AIProductSlide, { items: SLIDE_THREE })
    }
  ];
  return showTour ? /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(CarouselComponent, { open: showTour, slides, onClose: onExit }) : null;
}, "AIProductTourComponent");

// src/modules/container/components/pageHeader/PageHeader.tsx
var import_uik89 = require("@appd/uik");
var import_react51 = require("react");

// src/modules/container/components/pageHeader/breadcrumbs/BreadcrumbsComponent.tsx
var import_uik86 = require("@appd/uik");

// src/modules/container/components/pageHeader/breadcrumbs/STYLES.ts
var import_uik84 = require("@appd/uik");
var {
  SPACING: SPACING32,
  COLORS: { CONTROL_ICON_STRONG, INTERACT_BG, INTERACT_TEXT_WEAK },
  TYPOGRAPHY: { P3_EMPHASIS: P3_EMPHASIS3 }
} = import_uik84.MAGNETIC_TOKENS;
var STYLES24 = {
  BREADCRUMB_SEPARATOR: (0, import_uik84.css)({
    display: "flex",
    "> svg > path": {
      fill: CONTROL_ICON_STRONG
    }
  }),
  BREADCRUMB_LINK: (0, import_uik84.css)({
    ":hover": {
      "& path": { fill: `${INTERACT_BG} !important` },
      color: INTERACT_BG,
      textDecoration: "underline",
      textUnderlineOffset: 2
    },
    alignItems: "center",
    alignSelf: "flex-start",
    display: "flex",
    color: INTERACT_TEXT_WEAK,
    font: P3_EMPHASIS3,
    gap: 2,
    textDecoration: "none"
  }),
  BREADCRUMB_LABEL: (0, import_uik84.css)({
    color: INTERACT_TEXT_WEAK,
    font: P3_EMPHASIS3
  }),
  BREADCRUMB_CONTAINER: (0, import_uik84.css)({
    display: "flex",
    alignItems: "center",
    gap: "6",
    paddingBottom: `${SPACING32[1]}px`
  })
};

// src/modules/container/components/pageHeader/hooks/usePageHeaderContext.ts
var import_react49 = require("react");
var usePageHeaderContext = /* @__PURE__ */ __name(() => (0, import_react49.useContext)(PageHeaderContext), "usePageHeaderContext");

// src/modules/container/components/pageHeader/breadcrumbs/linkWrapper/LinkWrapper.tsx
var import_uik85 = require("@appd/uik");
var import_jsx_runtime69 = (
  // eslint-disable-next-line react/jsx-no-target-blank -- linter doesn't catch the conditional
  require("react/jsx-runtime")
);
function BreadCrumbLinkWrapper({
  href,
  className,
  children,
  newTab = false
}) {
  const onClickHandler = /* @__PURE__ */ __name((event, routerObj, url) => {
    if (!routerObj) {
      return;
    }
    if (routerObj.router) {
      const finalUrl = url.replace(/^\/[^\\/]*/, "");
      void routerObj.router(finalUrl);
      event.preventDefault();
    }
  }, "onClickHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(RouterContext.Consumer, { children: (routerObj) => /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
    "a",
    {
      href,
      onClick: (event) => onClickHandler(event, routerObj, href),
      className: (0, import_uik85.css)({ textDecoration: "none" }, className),
      onKeyUp: ({ key, currentTarget }) => [" ", "Enter"].includes(key) && currentTarget.click(),
      target: newTab ? "_blank" : "_self",
      rel: newTab ? "noreferrer" : void 0,
      children
    }
  ) });
}
__name(BreadCrumbLinkWrapper, "BreadCrumbLinkWrapper");

// src/modules/container/components/pageHeader/breadcrumbs/BreadcrumbsComponent.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");
function BreadcrumbsComponent2({ onClickEvent, style }) {
  const { breadcrumbItems } = usePageHeaderContext();
  if (!breadcrumbItems || breadcrumbItems.length === 0) {
    return null;
  }
  const onClickHandler = /* @__PURE__ */ __name((item) => {
    if (onClickEvent) {
      ShellEvent.emit(onClickEvent, item);
    }
  }, "onClickHandler");
  const renderedItems = breadcrumbItems.flatMap((item, index, { length }) => {
    const itemKey = `${item.href}-${index}`;
    const isLastItem = index === length - 1;
    if (length === 1) {
      if (onClickEvent) {
        return [
          /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(
            "a",
            {
              href: item.href,
              className: STYLES24.BREADCRUMB_LINK,
              onClick: (event) => {
                if (onClickEvent) {
                  event.preventDefault();
                  onClickHandler(item);
                }
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(import_uik86.Icon.Navigation.ArrowLeft, { size: "SMALL", style: { margin: "0 2px 0 -3px" }, "data-testid": "back-btn-arrow" }),
                item.label
              ]
            },
            itemKey
          )
        ];
      }
      return [
        /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)(BreadCrumbLinkWrapper, { href: item.href, className: STYLES24.BREADCRUMB_LINK, children: [
          /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(import_uik86.Icon.Navigation.ArrowLeft, { size: "SMALL", style: { margin: "0 2px 0 -3px" }, "data-testid": "back-btn-arrow" }),
          item.label
        ] }, itemKey)
      ];
    }
    const content = [];
    if (item.href === "") {
      content.push(
        /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("div", { className: STYLES24.BREADCRUMB_LABEL, children: item.label }, itemKey)
      );
    } else if (onClickEvent) {
      content.push(
        /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
          "a",
          {
            href: item.href,
            title: item.title,
            className: STYLES24.BREADCRUMB_LINK,
            onClick: (event) => {
              if (onClickEvent) {
                event.preventDefault();
                onClickHandler(item);
              }
            },
            children: item.label
          },
          itemKey
        )
      );
    } else {
      content.push(
        /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(BreadCrumbLinkWrapper, { href: item.href, className: STYLES24.BREADCRUMB_LINK, children: item.label }, itemKey)
      );
    }
    if (!isLastItem) {
      content.push(
        /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("div", { className: STYLES24.BREADCRUMB_SEPARATOR, children: /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(import_uik86.Icon.Navigation.ChevronRight, { size: "SMALL" }) }, `chevron:${itemKey}`)
      );
    }
    return content;
  });
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("div", { style, className: STYLES24.BREADCRUMB_CONTAINER, "data-testid": "breadcrumbs", children: renderedItems });
}
__name(BreadcrumbsComponent2, "BreadcrumbsComponent");

// src/modules/container/components/pageHeader/timerange/TimeRangeComponent.tsx
var import_future3 = require("@appd/uik/@future");
var import_react50 = require("react");
var import_uik87 = require("@appd/uik");

// src/modules/container/components/pageHeader/timerange/DEFAULT_PRESETS.ts
var DEFAULT_PRESETS2 = [
  {
    since: "-PT5M",
    title: "Last 5 Minutes"
  },
  {
    since: "-PT15M",
    title: "Last 15 Minutes"
  },
  {
    since: "-PT1H",
    title: "Last 1 Hour"
  },
  {
    since: "-PT3H",
    title: "Last 3 Hours"
  },
  {
    since: "-PT6H",
    title: "Last 6 Hours"
  },
  {
    since: "-PT12H",
    title: "Last 12 Hours"
  },
  {
    since: "-P1D",
    title: "Last 1 Day"
  },
  {
    since: "-P3D",
    title: "Last 3 Days"
  },
  {
    since: "-P14D",
    title: "Last 14 Days"
  },
  {
    since: "-P1W",
    title: "Last 1 Week"
  },
  {
    since: "-P2W",
    title: "Last 2 Weeks"
  },
  {
    since: "-P30D",
    title: "Last 1 Month"
  },
  {
    since: "-P90D",
    title: "Last 3 Months"
  },
  {
    since: "-P180D",
    title: "Last 6 Months"
  },
  {
    since: "-P365D",
    title: "Last 1 Year"
  }
];

// src/modules/container/components/pageHeader/timerange/TimeRangeComponent.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");
var PRESETS_PREFERENCE_TYPE2 = "uishell:timerangePresets";
var DEFAULT_RECENTS_COUNT2 = 5;
var REGEX_FOR_SINCE2 = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)([DW]))?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;
var TimeRangeComponent = /* @__PURE__ */ __name(({ displayFormat, style }) => {
  const [presets, setPresets] = (0, import_react50.useState)();
  const [recents, setRecents] = (0, import_react50.useState)([]);
  const isInitalTimeRangeParamPresent = (0, import_react50.useRef)(true);
  const isInitialLoad = (0, import_react50.useRef)(true);
  const { appName: appName2, tenantId } = (0, import_react50.useContext)(ShellContainerContext);
  const { timeRange: timeRange2, setTimeRange, setTimeRangeEventSource, shellPreferences } = (0, import_react50.useContext)(TimeRangeContext);
  const getTimerangePresets = (0, import_react50.useCallback)(async () => {
    const timerangePresetsResponse = await getGenericPreferences(
      PRESETS_PREFERENCE_TYPE2,
      tenantId,
      "TENANT" /* TENANT */,
      `data.appName eq "${appName2}"`
    );
    const timerangePresetsItem = filterPreferencesByLayerType(timerangePresetsResponse, "SOLUTION" /* SOLUTION */);
    if (timerangePresetsItem) {
      const { data: timerangePresetsData } = timerangePresetsItem;
      if ("timerangePresets" in timerangePresetsData) {
        setPresets(timerangePresetsData.timerangePresets);
      }
    } else {
      setPresets(DEFAULT_PRESETS2);
    }
  }, [appName2, tenantId]);
  const getTimerangeRecentsFromOrion = (0, import_react50.useCallback)(async () => {
    const timeRangeRecentsResponseFromShell = await getTimerangeRecents(
      `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
      "LOCALUSER" /* LOCALUSER */,
      `data.appName eq "${CONSTANTS.SHELL_APP}"`
    );
    let timerangeRecentsItem = filterPreferencesByLayerType(
      timeRangeRecentsResponseFromShell,
      "LOCALUSER" /* LOCALUSER */
    );
    if (!timerangeRecentsItem) {
      const timerangeRecentsResponseFromApp = await getTimerangeRecents(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        "LOCALUSER" /* LOCALUSER */,
        `data.appName eq "${appName2}"`
      );
      timerangeRecentsItem = filterPreferencesByLayerType(timerangeRecentsResponseFromApp, "LOCALUSER" /* LOCALUSER */);
      if (!timerangeRecentsItem && appName2 === "cco") {
        const deafultTimerangeRecentsResponse = await getTimerangeRecents(
          `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
          "LOCALUSER" /* LOCALUSER */,
          `data.appName eq "cnao"`
        );
        timerangeRecentsItem = filterPreferencesByLayerType(deafultTimerangeRecentsResponse, "LOCALUSER" /* LOCALUSER */);
      }
    }
    return timerangeRecentsItem;
  }, [appName2, tenantId]);
  const getTimerangeRecents2 = (0, import_react50.useCallback)(async () => {
    const timerangeRecentsItem = await getTimerangeRecentsFromOrion();
    if (timerangeRecentsItem) {
      const { data: timerangeRecentsData } = timerangeRecentsItem;
      if ("timerangeRecents" in timerangeRecentsData) {
        setRecents(timerangeRecentsData.timerangeRecents);
      }
    }
  }, [getTimerangeRecentsFromOrion]);
  const saveTimerangeRecents = (0, import_react50.useCallback)(
    async (input) => {
      let updatedRecents = [];
      const layerId = `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`;
      const timeRangeRecentsItem = await getTimerangeRecentsFromOrion();
      const { data: timeRangeRecentsData } = timeRangeRecentsItem ?? {
        data: {
          appName: CONSTANTS.SHELL_APP,
          timerangeRecents: []
        }
      };
      updatedRecents = [
        input,
        ...timeRangeRecentsData.timerangeRecents.filter(
          (recent) => !import_future3.TimeRangeSelector.TimeRange.isEqualInput(input, recent)
        )
      ];
      updatedRecents = updatedRecents.slice(0, DEFAULT_RECENTS_COUNT2);
      if (timeRangeRecentsItem && timeRangeRecentsItem.data.appName === CONSTANTS.SHELL_APP) {
        await setTimerangeRecents(layerId, {
          ...timeRangeRecentsItem,
          data: {
            ...timeRangeRecentsItem.data,
            timerangeRecents: updatedRecents
          }
        });
      } else {
        await setTimerangeRecents(layerId, {
          data: {
            appName: CONSTANTS.SHELL_APP,
            timerangeRecents: updatedRecents
          }
        });
      }
      setRecents(updatedRecents);
    },
    [getTimerangeRecentsFromOrion, tenantId]
  );
  const saveTimerangeToPreferences = (0, import_react50.useCallback)(
    async (newTimeRange) => {
      const shellApp = await getShellPreferences(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        "LOCALUSER" /* LOCALUSER */,
        `data.appName eq "${CONSTANTS.SHELL_APP}"`
      );
      const shellAppUserPref = filterPreferencesByLayerType(shellApp, "LOCALUSER" /* LOCALUSER */) ?? { data: { appName: CONSTANTS.SHELL_APP, shellPreferences: {} } };
      const updatedShellPreferences = {
        ...shellAppUserPref,
        data: {
          ...shellAppUserPref.data,
          shellPreferences: {
            ...shellAppUserPref.data.shellPreferences,
            selectedTimerange: newTimeRange
          }
        }
      };
      await setShellPreferences(
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        updatedShellPreferences
      );
    },
    [tenantId]
  );
  const onSelectedTimeRangeChange = (0, import_react50.useCallback)(
    (newTimeRange) => {
      setTimeRange(newTimeRange.value);
      ShellEvent.emit("timeRangeChanged", newTimeRange);
      setTimeRangeEventSource(newTimeRange.eventSource);
      if (newTimeRange.eventSource === "INPUT") {
        saveTimerangeRecents(newTimeRange.value.input).catch(reportError);
      }
      if (newTimeRange.eventSource !== "AUTO_REFRESH" && newTimeRange.eventSource !== "REFRESH") {
        saveTimerangeToPreferences(newTimeRange.value.input).catch(reportError);
      }
    },
    [saveTimerangeRecents, saveTimerangeToPreferences, setTimeRange, setTimeRangeEventSource]
  );
  const getInitialTimeRange = (0, import_react50.useCallback)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const timeRangeValueFromUrl = import_future3.TimeRangeSelector.TimeRange?.valueFromSearchParams(queryParams);
    if (!isInitalTimeRangeParamPresent.current || !timeRangeValueFromUrl) {
      isInitalTimeRangeParamPresent.current = false;
      isInitialLoad.current = false;
      if (shellPreferences && isShellPreferencesData(shellPreferences.data)) {
        const appSelectedTimeRange = shellPreferences.data.shellPreferences.selectedTimerange;
        if (appSelectedTimeRange && REGEX_FOR_SINCE2.test(appSelectedTimeRange.since)) {
          setTimeRange((prevTimeRange) => {
            if (!import_future3.TimeRangeSelector.TimeRange.isEqualInput(prevTimeRange.input, appSelectedTimeRange)) {
              return {
                input: appSelectedTimeRange,
                now: (/* @__PURE__ */ new Date()).toISOString()
              };
            }
            return prevTimeRange;
          });
        }
      }
    } else if (isInitialLoad.current) {
      isInitialLoad.current = false;
      setTimeRange((prevTimeRange) => {
        if (!import_future3.TimeRangeSelector.TimeRange.isEqualInput(prevTimeRange.input, timeRangeValueFromUrl.input)) {
          return timeRangeValueFromUrl;
        }
        return prevTimeRange;
      });
    }
  }, [shellPreferences, setTimeRange]);
  (0, import_react50.useEffect)(() => {
    getTimerangePresets().catch(reportError);
    getTimerangeRecents2().catch(reportError);
  }, [getTimerangePresets, getTimerangeRecents2]);
  (0, import_react50.useEffect)(() => {
    getInitialTimeRange();
    ShellEvent.on("stateTimeRangeUpdated", setTimeRange);
    return () => {
      ShellEvent.un("stateTimeRangeUpdated", setTimeRange);
    };
  }, [getInitialTimeRange, setTimeRange]);
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("div", { style: { marginLeft: "auto", ...style }, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("div", { className: (0, import_uik87.css)({ display: "flex", gap: 12, alignItems: "center", flexDirection: "row" }), children: presets && /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
    import_future3.TimeRangeSelector,
    {
      displayFormat,
      onSelectedTimeRangeChange,
      presets,
      recents,
      selectedTimeRange: timeRange2,
      "data-testid": "timeRange"
    }
  ) }) });
}, "TimeRangeComponent");
var TimeRangeComponent_default = TimeRangeComponent;

// src/modules/container/components/pageHeader/STYLES.ts
var import_uik88 = require("@appd/uik");
var { SPACING: SPACING33 } = import_uik88.MAGNETIC_TOKENS;
var STYLES25 = {
  HEADER_COMPONENT: (0, import_uik88.css)({
    paddingTop: SPACING33[6],
    paddingBottom: SPACING33[6],
    paddingLeft: 15,
    paddingRight: 15
  }),
  TITLE_CONTAINER: (0, import_uik88.css)({
    display: "flex",
    height: 36,
    width: "100%"
  })
};

// src/modules/container/components/pageHeader/PageHeader.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");
var PageHeader = /* @__PURE__ */ __name(({ config, router }) => {
  const { pageTitle, actionComponents } = usePageHeaderContext();
  const routerObj = (0, import_react51.useMemo)(() => ({ router }), [router]);
  const timeRangeProps = config.rightPlugins.find((plugin) => plugin.name === "timeRangeV2")?.props;
  const breadcrumbsProps = config.leftPlugins.find((plugin) => plugin.name === "breadcrumbs")?.props;
  if (!pageTitle) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)("div", { "data-testid": "page-header-component", className: STYLES25.HEADER_COMPONENT, children: [
    /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(RouterContext.Provider, { value: routerObj, children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
      BreadcrumbsComponent2,
      {
        ...breadcrumbsProps
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)("div", { className: STYLES25.TITLE_CONTAINER, children: [
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(import_uik89.Heading, { size: "PRIMARY", "data-testid": "page-header-title", children: pageTitle }),
      /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
        TimeRangeComponent_default,
        {
          ...timeRangeProps
        }
      ),
      actionComponents
    ] })
  ] });
}, "PageHeader");

// src/modules/container/hook/useInitConfig.ts
var import_react52 = require("react");

// src/modules/container/components/miniProfile/getMiniProfileConfig.ts
var getMiniProfileConfig = /* @__PURE__ */ __name(() => {
  let logoutUrl = "https://login.appdynamics.com/sso/logout/";
  let accountsLaunchUrl = "https://accounts.appdynamics.com/license-usage";
  let accountsManageProfileUrl = "https://accounts.appdynamics.com/personal-summary";
  let accountsOverviewUrl = "https://accounts.appdynamics.com/overview";
  let accountsViewAllUrl = "https://accounts.appdynamics.com/personal-summary/subscriptions";
  let cloudTenantApiUrl = "https://tenant-provision-apis.saas.appdynamics.com/levitate/v1/tenants";
  let communityUrl = "https://community.appdynamics.com";
  let helpUrl = "https://www.appdynamics.com/support";
  let identityApiUrl = CONSTANTS.IDENTITY_API_URL;
  let saasTenantApiUrl = "https://portal.appdynamics.com/api/rest/v2/licenses/search?page_size=20&page=1&deployment=saas";
  let universityUrl = "https://university.appdynamics.com";
  const isLocalEnv = isLocal();
  const isAppdTestEnv = isAppdTest();
  if (isLocalEnv || isAppdTestEnv) {
    logoutUrl = "https://login-staging.saas.appd-test.com/sso/logout";
    accountsLaunchUrl = "https://accounts-staging.saas.appd-test.com/license-usage";
    accountsManageProfileUrl = "https://accounts-staging.saas.appd-test.com/personal-summary";
    accountsOverviewUrl = "https://accounts-staging.saas.appd-test.com/overview";
    accountsViewAllUrl = "https://accounts-staging.saas.appd-test.com/personal-summary/subscriptions";
    cloudTenantApiUrl = "https://levitate-apis.saas.appd-test.com/levitate/v1/tenants";
    communityUrl = "https://community-staging.appdynamics.com";
    helpUrl = "https://www.appdynamics.com/support";
    identityApiUrl = CONSTANTS.IDENTITY_API_URL_FOR_LOCAL;
    saasTenantApiUrl = "https://portal-staging.saas.appd-test.com/api/rest/v2/licenses/search?page_size=20&page=1&deployment=saas";
    universityUrl = "https://learn-staging.saas.appd-test.com";
  }
  return {
    logoutUrl,
    accountsLaunchUrl,
    accountsManageProfileUrl,
    accountsOverviewUrl,
    accountsViewAllUrl,
    cloudTenantApiUrl,
    communityUrl,
    helpUrl,
    identityApiUrl,
    saasTenantApiUrl,
    universityUrl,
    isLocal: isLocalEnv,
    isAppdTest: isAppdTestEnv
  };
}, "getMiniProfileConfig");

// src/modules/container/hook/useInitConfig.ts
var useInitConfig = /* @__PURE__ */ __name((appName2) => {
  const [initConfig, setInitConfig] = (0, import_react52.useState)({});
  (0, import_react52.useEffect)(() => {
    const fetchInitConfig = /* @__PURE__ */ __name(async () => {
      try {
        const response = await shellFetch(`/session/api/ext/ui/api/dashui/shell/initConfig?appName=${appName2}`, {
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error("Failed to fetch init config");
        }
        const data = await response.json();
        data.integrations.miniProfileConfig = getMiniProfileConfig();
        setInitConfig(data);
      } catch (e) {
        console.error("There was an error fetching the init config", e);
      }
    }, "fetchInitConfig");
    void fetchInitConfig();
  }, [appName2]);
  return initConfig;
}, "useInitConfig");

// src/modules/container/components/WriteRecentlyVisited/WriteRecentlyVisited.tsx
var import_react53 = require("react");
var import_future4 = require("@appd/uik/@future");
var RECENTLY_VISITED_TYPE = "uishell:recentlyVisited";
var DEFAULT_RECENTLY_VISITED_PAGES_COUNT = 8;
var SINCE_PARAM2 = "since";
var UNTIL_PARAM2 = "until";
var NOW_PARAM2 = "now";
var DEFAULT_PAGE_NAME = "Home";
var WriteRecentlyVisited = /* @__PURE__ */ __name(({ isPageHeaderEnabled }) => {
  const { tenantId, appName: appName2, site } = (0, import_react53.useContext)(ShellContainerContext);
  const { pageName, pageNavGroupId, pagePathname, pageParams, setPageName } = (0, import_react53.useContext)(PageHeaderContext);
  const isSaveRequestInprogress = (0, import_react53.useRef)(false);
  const appNameRef = (0, import_react53.useRef)("");
  const siteRef = (0, import_react53.useRef)("");
  const recentlyVisitedConfigList = (0, import_react53.useRef)([]);
  (0, import_react53.useEffect)(() => {
    appNameRef.current = appName2;
    siteRef.current = site;
  }, [appName2, site]);
  const getPageFallbackNameFromUrl = (0, import_react53.useCallback)(() => {
    const appNameRefValue = appNameRef.current;
    const siteRefValue = siteRef.current;
    const { pathname } = window.location;
    let parts = pathname.split("/").filter((e) => e !== "");
    if (siteRefValue !== "" && pathname.includes(siteRefValue)) {
      parts = parts.splice(1);
    }
    if (parts.includes(appNameRefValue)) {
      parts = parts.filter((e) => e !== appNameRefValue);
    }
    const fallbackPageName = parts.map((e) => decodeURIComponent(e)).join(" / ");
    return fallbackPageName !== "" ? fallbackPageName : DEFAULT_PAGE_NAME;
  }, []);
  const paramsWithConvertedTimeRange = /* @__PURE__ */ __name((searchParams) => {
    const timeRangeValueFromUrl = import_future4.TimeRangeSelector.TimeRange?.valueFromSearchParams(searchParams);
    if (timeRangeValueFromUrl) {
      const { since: resolvedSince, until: resolvedUntil } = import_future4.TimeRangeSelector.TimeRange.resolve(timeRangeValueFromUrl);
      searchParams.delete(SINCE_PARAM2);
      if (searchParams.has(UNTIL_PARAM2)) {
        searchParams.delete(UNTIL_PARAM2);
      }
      if (searchParams.has(NOW_PARAM2)) {
        searchParams.delete(NOW_PARAM2);
      }
      searchParams.set(SINCE_PARAM2, encodeURIComponent(resolvedSince));
      searchParams.set(UNTIL_PARAM2, encodeURIComponent(resolvedUntil));
      return searchParams;
    }
    return searchParams;
  }, "paramsWithConvertedTimeRange");
  const saveRecentlyVisitedPagesOrion = (0, import_react53.useCallback)(
    async (recentlyVisitedPage) => {
      const appNameRefValue = appNameRef.current;
      let updatedRecentlyVisitedPages = [];
      const recentlyVisitedResponse = await getRecentlyVisitedItem(
        RECENTLY_VISITED_TYPE,
        `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
        "LOCALUSER" /* LOCALUSER */,
        `tags.app-${appNameRefValue} eq "yes"`
      );
      const recentlyVisitedOrionItem = recentlyVisitedResponse.items.find((item) => item.layerType === "LOCALUSER" /* LOCALUSER */) ?? {
        data: {
          "__META__!": {
            tags: {
              [`app-${appNameRefValue}`]: "yes"
            }
          },
          id: `${appNameRefValue}RecentlyVisited`,
          recentlyVisitedPages: []
        }
      };
      updatedRecentlyVisitedPages = [
        recentlyVisitedPage,
        ...recentlyVisitedOrionItem.data.recentlyVisitedPages.filter(
          (page) => page.url.split("?")[0] !== recentlyVisitedPage.url.split("?")[0]
        )
      ];
      updatedRecentlyVisitedPages = updatedRecentlyVisitedPages.slice(0, DEFAULT_RECENTLY_VISITED_PAGES_COUNT);
      if ("id" in recentlyVisitedOrionItem) {
        await putRecentlyVisitedItem(
          RECENTLY_VISITED_TYPE,
          `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
          "LOCALUSER" /* LOCALUSER */,
          JSON.stringify({
            ...recentlyVisitedOrionItem.data,
            recentlyVisitedPages: updatedRecentlyVisitedPages
          }),
          recentlyVisitedOrionItem.id
        );
      } else {
        await postRecentlyVisitedItem(
          RECENTLY_VISITED_TYPE,
          `${tenantId}@${sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) ?? ""}`,
          "LOCALUSER" /* LOCALUSER */,
          JSON.stringify({
            ...recentlyVisitedOrionItem.data,
            recentlyVisitedPages: updatedRecentlyVisitedPages
          })
        );
      }
      return Promise.resolve(true);
    },
    [tenantId]
  );
  const saveRecentlyVisitedPageExecutor = (0, import_react53.useCallback)(() => {
    isSaveRequestInprogress.current = true;
    if (recentlyVisitedConfigList.current.length > 0) {
      const recentlyVisitedPage = recentlyVisitedConfigList.current.shift();
      saveRecentlyVisitedPagesOrion(recentlyVisitedPage).then(() => {
        if (recentlyVisitedConfigList.current.length > 0) {
          saveRecentlyVisitedPageExecutor();
        } else {
          isSaveRequestInprogress.current = false;
        }
      }).catch((error) => {
        if (recentlyVisitedConfigList.current.length > 0) {
          saveRecentlyVisitedPageExecutor();
        } else {
          isSaveRequestInprogress.current = false;
        }
        console.error(error);
      });
    } else {
      isSaveRequestInprogress.current = false;
    }
  }, [saveRecentlyVisitedPagesOrion]);
  (0, import_react53.useEffect)(() => {
    if (isPageHeaderEnabled) {
      setPageName("");
    }
  }, [isPageHeaderEnabled, pagePathname, setPageName]);
  (0, import_react53.useEffect)(() => {
    recentlyVisitedConfigList.current.push({
      name: pageName !== "" ? `${pageNavGroupId !== "" ? `${pageNavGroupId} / ` : ""}${pageName}` : getPageFallbackNameFromUrl(),
      url: `${window.location.pathname}${window.location.search.length > 0 ? `?${paramsWithConvertedTimeRange(new URLSearchParams(window.location.search)).toString()}` : ""}`,
      timeStamp: (/* @__PURE__ */ new Date()).toISOString()
    });
    if (!isSaveRequestInprogress.current) {
      saveRecentlyVisitedPageExecutor();
    }
  }, [
    pagePathname,
    pageParams,
    appName2,
    site,
    getPageFallbackNameFromUrl,
    saveRecentlyVisitedPageExecutor,
    pageName,
    pageNavGroupId
  ]);
  return null;
}, "WriteRecentlyVisited");

// src/modules/container/components/error/LoadingErrorComponent.tsx
var import_uik91 = require("@appd/uik");

// src/modules/container/components/error/STYLES.ts
var import_uik90 = require("@appd/uik");
var {
  COLORS: { DEFAULT_BG_DISABLED: DEFAULT_BG_DISABLED3 }
} = import_uik90.MAGNETIC_TOKENS;
var STYLES26 = {
  CONTAINER: import_uik90.css.Styles({
    height: "100%",
    overflow: "scroll",
    gridArea: "main",
    backgroundColor: DEFAULT_BG_DISABLED3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  }),
  INNERCONTAINER: import_uik90.css.Styles({
    display: "flex",
    marginBottom: 200,
    alignItems: "center",
    flexDirection: "column"
  })
};

// src/modules/container/components/error/LoadingErrorComponent.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
function LoadingErrorComponent() {
  const errorImage2 = require_emptyStateError();
  const reloadHandler = /* @__PURE__ */ __name(() => {
    globalThis.location.reload();
  }, "reloadHandler");
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("div", { className: (0, import_uik91.css)(STYLES26.CONTAINER), "data-testid": "shell-api-error", children: /* @__PURE__ */ (0, import_jsx_runtime73.jsxs)("div", { className: (0, import_uik91.css)(STYLES26.INNERCONTAINER), children: [
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("img", { src: errorImage2, alt: "Error State" }),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("div", { style: { fontWeight: "bold", marginBottom: 10 }, children: " This page couldn't be reached" }),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsxs)("div", { children: [
      "Try reloading the page. If the issue persists,",
      /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("br", {}),
      "submit a support ticket and we will help you resolve it."
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("br", {}),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(import_uik91.Button, { onClick: reloadHandler, children: "Reload" })
  ] }) });
}
__name(LoadingErrorComponent, "LoadingErrorComponent");

// src/modules/container/container/ShellContainer.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
var ShellContainer = /* @__PURE__ */ __name(({ children, config }) => {
  const initConfigFromApi = useInitConfig(config.appName ?? CONSTANTS.DEFAULT_APP_NAME);
  const [initConfig, setInitConfig] = (0, import_react54.useState)(initConfigFromApi);
  const [apiFailure, setApiFailure] = (0, import_react54.useState)(false);
  const tenantId = useTenantId(config?.devConfig?.tenantUrl, initConfig?.tenantId);
  const [shellInitialized, setShellInitialized] = (0, import_react54.useState)(false);
  const [flagsConfig, setFlagsConfig] = (0, import_react54.useState)();
  setCommonErrorHandler(() => setApiFailure(true));
  (0, import_react54.useEffect)(() => {
    let updatedConfig = initConfigFromApi;
    if (tenantId) {
      updatedConfig = { ...initConfigFromApi, tenantId };
    }
    sessionStorage.setItem(CONSTANTS.COP_TENANT_ID, updatedConfig.tenantId);
    setInitConfig(updatedConfig);
  }, [initConfigFromApi, tenantId]);
  (0, import_react54.useEffect)(() => {
    if (initConfig) {
      const featureFlagsConfig = getFeatureFlagsConfig(
        initConfig,
        config.featureFlags?.flagsConfig?.flagsStoreKey ?? CONSTANTS.SHELL_FLAGS_STORE_KEY,
        config.featureFlags?.flagsConfig?.flagDefinitions
      );
      setFlagsConfig(featureFlagsConfig);
    }
  }, [config.featureFlags?.flagsConfig?.flagDefinitions, config.featureFlags?.flagsConfig?.flagsStoreKey, initConfig]);
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("div", { id: "fso-ui-shell", className: "ShellContainer", children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Authenticator_default, { disabled: config.authenticator && config.authenticator.disabled, children: tenantId !== "" && sessionStorage.getItem(CONSTANTS.APPD_NEXT_PRINCIPAL_ID) !== null ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(import_react_router_dom2.BrowserRouter, { children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(FeatureFlagsProvider, { enabled: true, config: flagsConfig, children: /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
    ShellContainerProvider,
    {
      setShellInitialized,
      tenantId,
      configAppName: config.appName ?? "",
      flagsStoreKey: config.featureFlags?.flagsConfig?.flagsStoreKey ?? CONSTANTS.SHELL_FLAGS_STORE_KEY,
      initConfig,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(ProductTourComponent, {}),
        /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(AIProductTourComponent, {}),
        /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)("div", { className: (0, import_uik92.css)(config.topNav ? { ...STYLES21.MAIN_GRID } : {}), children: [
          config.topNav ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
            TopNavBuilder,
            {
              config: config.topNav,
              router: config.router,
              isPageHeaderEnabled: config.isPageHeaderEnabled
            }
          ) : null,
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("div", { className: (0, import_uik92.css)({ ...STYLES21.BANNER_CONTAINER }), children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(NotificationBanner, {}) }),
          /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)("div", { className: (0, import_uik92.css)({ ...STYLES21.MAIN_CONTAINER }), children: [
            !config.leftNav?.disabled && /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Nav, { className: (0, import_uik92.css)({ height: "100%" }), router: config.router }),
            /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
              "div",
              {
                className: (0, import_uik92.css)({
                  ...STYLES21.MAIN_CONTENT,
                  height: "100%"
                }),
                children: [
                  config.isPageHeaderEnabled && config.topNav && getFlagValue(
                    config.featureFlags?.flagsConfig?.flagsStoreKey ?? CONSTANTS.SHELL_FLAGS_STORE_KEY,
                    "PAGE_HEADER_ENABLED"
                  ) ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(PageHeader, { config: config.topNav, router: config.router }) : null,
                  apiFailure ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(LoadingErrorComponent, {}) : null,
                  shellInitialized && !apiFailure ? children : null
                ]
              }
            ),
            config.topNav ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("div", { id: "fso-shell-modal-root", className: (0, import_uik92.css)(STYLES21.EXCHANGE_ROOT) }) : null,
            config.topNav ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("div", { id: "fso-shell-help-center-root", className: (0, import_uik92.css)(STYLES21.HELP_CENTER_V2_ROOT) }) : null
          ] })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(WriteRecentlyVisited, { isPageHeaderEnabled: !!config.isPageHeaderEnabled })
      ]
    }
  ) }) }) : null }) });
}, "ShellContainer");

// src/modules/container/components/pageHeader/hooks/useSetPageContext.ts
var import_react55 = require("react");
var useSetPageContext = /* @__PURE__ */ __name(() => {
  const context = (0, import_react55.useContext)(PageHeaderContext);
  if (!context) {
    throw new Error("useSetPageContext must be used within a PageHeaderContextProvider");
  }
  const { setPageTitle, setPageName } = context;
  const setPageTitleWrapper = (0, import_react55.useCallback)(
    (pageTitle) => {
      setPageTitle(pageTitle ?? "");
      return () => {
        setPageTitle("");
      };
    },
    [setPageTitle]
  );
  const setPageNameWrapper = (0, import_react55.useCallback)(
    (pageName) => {
      setPageName(pageName);
      return () => {
        setPageName("");
      };
    },
    [setPageName]
  );
  const resetPageContext = (0, import_react55.useCallback)(() => {
    setPageTitle("");
    setPageName("");
  }, [setPageTitle, setPageName]);
  return {
    setPageTitle: setPageTitleWrapper,
    setPageName: setPageNameWrapper,
    resetPageContext
  };
}, "useSetPageContext");

// src/modules/container/components/pageHeader/hooks/useSetBreadcrumbs.ts
var import_react56 = require("react");
var useSetBreadcrumbs = /* @__PURE__ */ __name(() => {
  const context = (0, import_react56.useContext)(PageHeaderContext);
  if (!context) {
    throw new Error("useSetBreadcrumbs must be used within a PageHeaderContextProvider");
  }
  const { setBreadcrumbItems } = context;
  return (0, import_react56.useCallback)(
    (breadcrumbItems) => {
      setBreadcrumbItems(breadcrumbItems);
      return () => {
        setBreadcrumbItems([]);
      };
    },
    [setBreadcrumbItems]
  );
}, "useSetBreadcrumbs");

// src/modules/container/components/pageHeader/hooks/useUpdatePageTitle.ts
var import_react57 = require("react");
var useUpdatePageTitle = /* @__PURE__ */ __name((pageTitle, pageName = "", dependencies = []) => {
  const context = (0, import_react57.useContext)(PageHeaderContext);
  if (!context) {
    throw new Error("useUpdatePageTitle must be used within a PageHeaderContextProvider");
  }
  const { setPageTitle, setPageName } = context;
  (0, import_react57.useEffect)(() => {
    setPageTitle(pageTitle ?? "");
    if (pageName) {
      setPageName(pageName);
    }
    return () => {
      setPageTitle("");
      setPageName("");
    };
  }, [pageName, pageTitle, setPageName, setPageTitle, ...dependencies]);
}, "useUpdatePageTitle");

// src/modules/container/components/pageHeader/hooks/useUpdateBreadcrumbs.ts
var import_react58 = require("react");
var useUpdateBreadcrumbs = /* @__PURE__ */ __name((breadcrumbItems, dependencies = []) => {
  const context = (0, import_react58.useContext)(PageHeaderContext);
  if (!context) {
    throw new Error("useUpdateBreadcrumbs must be used within a PageHeaderContextProvider");
  }
  const { setBreadcrumbItems } = context;
  (0, import_react58.useEffect)(() => {
    setBreadcrumbItems(breadcrumbItems);
    return () => setBreadcrumbItems([]);
  }, [breadcrumbItems, ...dependencies]);
}, "useUpdateBreadcrumbs");

// src/modules/container/components/pageHeader/hooks/useUpdatePageTitleActions.ts
var import_react59 = require("react");
var useUpdatePageTitleActions = /* @__PURE__ */ __name((actionComponents, dependencies = []) => {
  const context = (0, import_react59.useContext)(PageHeaderContext);
  if (!context) {
    throw new Error("useUpdateActionComponents must be used within a PageHeaderContextProvider");
  }
  const { setActionComponents } = context;
  (0, import_react59.useEffect)(() => {
    if (setActionComponents && actionComponents) {
      setActionComponents(actionComponents);
    }
    return () => {
      if (setActionComponents) {
        setActionComponents(null);
      }
    };
  }, [actionComponents, setActionComponents, ...dependencies]);
}, "useUpdatePageTitleActions");

// src/modules/container/hook/useApplicationName.ts
var import_react60 = require("react");
var useApplicationName = /* @__PURE__ */ __name(() => (0, import_react60.useContext)(ShellContainerContext).appName, "useApplicationName");

// src/modules/container/components/timeRangeV2/useShellTimeRange.ts
var import_react61 = require("react");
var import_future5 = require("@appd/uik/@future");
var useShellTimeRange = /* @__PURE__ */ __name(() => {
  const { timeRange: timeRange2, setTimeRange, timeRangeEventSource } = (0, import_react61.useContext)(TimeRangeContext);
  const timeRangeRef = (0, import_react61.useRef)(timeRange2);
  (0, import_react61.useEffect)(() => {
    timeRangeRef.current = timeRange2;
  }, [timeRange2]);
  const setShellTimeRange = (0, import_react61.useCallback)(
    (newTimeRangeValue) => {
      if (!import_future5.TimeRangeSelector.TimeRange.isEqualValue(timeRangeRef.current, newTimeRangeValue)) {
        if (import_future5.TimeRangeSelector.TimeRange.isEqualInput(newTimeRangeValue.input, timeRangeRef.current.input)) {
          if (new Date(newTimeRangeValue.now).getTime() - 6e4 > new Date(timeRangeRef.current.now).getTime()) {
            setTimeRange(newTimeRangeValue);
          }
        } else {
          setTimeRange(newTimeRangeValue);
        }
      }
    },
    [setTimeRange]
  );
  const getCurrentUpdatedShellTimeRange = (0, import_react61.useCallback)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const newTimeRange = import_future5.TimeRangeSelector.TimeRange?.valueFromSearchParams(queryParams, { excludeNow: true }) ?? {
      ...timeRangeRef.current,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
    if (import_future5.TimeRangeSelector.TimeRange.isEqualInput(newTimeRange.input, timeRangeRef.current.input)) {
      if (new Date(newTimeRange.now).getTime() - 6e4 > new Date(timeRangeRef.current.now).getTime()) {
        setTimeRange(newTimeRange);
        return newTimeRange;
      }
      return timeRangeRef.current;
    }
    setTimeRange(newTimeRange);
    return newTimeRange;
  }, [setTimeRange]);
  (0, import_react61.useEffect)(() => {
    ShellEvent.on("stateTimeRangeUpdated", setShellTimeRange);
    return () => {
      ShellEvent.un("stateTimeRangeUpdated", setShellTimeRange);
    };
  }, [setShellTimeRange]);
  return {
    getUpdatedTimeRange: getCurrentUpdatedShellTimeRange,
    setTimeRange: setShellTimeRange,
    timeRangeEventSource,
    shellTimeRange: timeRange2
  };
}, "useShellTimeRange");

// src/modules/container/hook/useApplicationsList.ts
var import_react62 = require("react");
var useApplicationsList = /* @__PURE__ */ __name(() => {
  const { appSwitcher } = (0, import_react62.useContext)(ShellContainerContext);
  return appSwitcher.props.apps;
}, "useApplicationsList");

// src/modules/container/hook/useSelectedApplication.ts
var import_react63 = require("react");
var import_omit = __toESM(require("lodash/omit"));
var useSelectedApplication = /* @__PURE__ */ __name(() => (0, import_omit.default)((0, import_react63.useContext)(ShellContainerContext), ["appSwitcher", "flagsStoreKey", "shellPreferences"]), "useSelectedApplication");

// src/modules/container/config/csp.ts
var csp = {
  "default-src": [
    "'self'",
    "'unsafe-eval'",
    "https",
    "*.smartlook.cloud",
    "siteintercept.qualtrics.com",
    "pdx-col.eum-appdynamics.com",
    "*.appdynamics.com",
    "*.saas.appd-test.com",
    "app.launchdarkly.com",
    "ws:",
    "wss:",
    "cdn.segment.com",
    "api.segment.io"
  ],
  "script-src": [
    "'nonce-c2NpbWFueURwcEFpdWhTYUQ='",
    "'strict-dynamic'",
    "'unsafe-eval'",
    "https:",
    "cdn.appdynamics.com",
    "zn3mtxq3jh7rfumqs-ciscocx.siteintercept.qualtrics.com",
    "siteintercept.qualtrics.com",
    "pdx-col.eum-appdynamics.com",
    "*.appdynamics.com",
    "*.saas.appd-test.com",
    "cdn.segment.com",
    "web-sdk.smartlook.com"
  ],
  "child-src": "self",
  "style-src": ["'self'", "'unsafe-inline'", "fonts.googleapis.com", "cdn.jsdelivr.net", "data:"],
  "img-src": ["'self'", "data:", "https:", "qualtrics.com"],
  "font-src": ["'self'", "fonts.gstatic.com", "data:"],
  "frame-src": ["'self'", "ciscocx.qualtrics.com", "research.appdynamics.com"],
  "object-src": "self"
};
var generateCSP = /* @__PURE__ */ __name(() => Object.entries(csp).map(([key, value]) => {
  const formattedValue = Array.isArray(value) ? value.join(" ") : value;
  return `${key} ${formattedValue};`;
}).join(" "), "generateCSP");

// src/modules/container/components/pageHeader/ShellPageHeader.tsx
var import_react64 = require("react");
var ShellPageHeader = /* @__PURE__ */ __name(({ pageTitle, actionComponents, pageName = "" }) => {
  const context = (0, import_react64.useContext)(PageHeaderContext);
  (0, import_react64.useEffect)(() => {
    context.setPageTitle(pageTitle ?? "");
    if (pageName) {
      context.setPageName(pageName);
    }
    if (actionComponents && context.setActionComponents) {
      context.setActionComponents(actionComponents);
    }
    return () => {
      context.setPageTitle("");
      context.setPageName("");
      if (context.setActionComponents) {
        context.setActionComponents(void 0);
      }
    };
  }, [actionComponents, context, pageName, pageTitle]);
  return null;
}, "ShellPageHeader");

// src/modules/container/components/pageHeader/breadcrumbs/ShellBreadcrumbs.tsx
var import_react65 = require("react");
var ShellBreadcrumbs = /* @__PURE__ */ __name(({ breadcrumbItems }) => {
  const context = (0, import_react65.useContext)(PageHeaderContext);
  (0, import_react65.useEffect)(() => {
    context.setBreadcrumbItems(breadcrumbItems ?? []);
    return () => context.setBreadcrumbItems([]);
  }, [breadcrumbItems, context]);
  return null;
}, "ShellBreadcrumbs");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ShellBreadcrumbs,
  ShellContainer,
  ShellEvent,
  ShellEventTypes,
  ShellPageHeader,
  generateCSP,
  getAppBasedLink,
  getAppName,
  getSelectedApplication,
  getTimeRange,
  useApplicationName,
  useApplicationsList,
  useSelectedApplication,
  useSetBreadcrumbs,
  useSetPageContext,
  useShellTimeRange,
  useUpdateBreadcrumbs,
  useUpdatePageTitle,
  useUpdatePageTitleActions
});
//# sourceMappingURL=container.js.map
